
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jK2OK", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $88ded4887dba0d0a$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $88ded4887dba0d0a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});


var $62c24f0b30c8c5a5$export$6c365a50d635fce6 = /*#__PURE__*/ function(parentPageTypes) {
    parentPageTypes["FREE"] = "free";
    parentPageTypes["RESTRICTED"] = "restricted";
    parentPageTypes["NOT_RESTRICTED"] = "not_restricted";
    return parentPageTypes;
}({});
const $62c24f0b30c8c5a5$export$d1f8b77844df7861 = (userCanEditRestrictions, edition)=>{
    if (!userCanEditRestrictions) return "not_restricted";
    if (edition === (0, $88ded4887dba0d0a$export$68577d543b14ae02).FREE) return "free";
    return "restricted";
};
module.exports["parentPageTypes"] = $62c24f0b30c8c5a5$export$6c365a50d635fce6;
module.exports["getRestrictionType"] = $62c24f0b30c8c5a5$export$d1f8b77844df7861;

});

parcelRegister("gLkqy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ix5ga = parcelRequire("ix5ga");


var $7dPLK = parcelRequire("7dPLK");


var $dUJl3 = parcelRequire("dUJl3");

const $962f4b1e576e5032$var$FEDRAMP_HOST_SUFFIXES = [
    'atlassian-fex.com',
    'atlassian-fex.net',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net',
    'atlassian-stg-fedm.net'
];
const $962f4b1e576e5032$var$FEDRAMP_IMPORT_STRATEGIES = (0, $7dPLK.IMPORT_STRATEGIES).filter(({ key: key })=>key === (0, $dUJl3.ActiveImports).IMPORT_FROM_LOCAL);
const $962f4b1e576e5032$var$isFedRampHostname = (hostname)=>$962f4b1e576e5032$var$FEDRAMP_HOST_SUFFIXES.some((suffix)=>hostname === suffix || hostname.endsWith(`.${suffix}`));
const $962f4b1e576e5032$export$841c53a144a831b7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { surface: surface, contentId: contentId, spaceId: spaceId, hasSourceRestrictions: hasSourceRestrictions, children: children } = t0;
    const hostname = globalThis.location?.hostname ?? "";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = $962f4b1e576e5032$var$isFedRampHostname(hostname);
        $[0] = t1;
    } else t1 = $[0];
    const isFedRampEnvironment = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== hasSourceRestrictions || $[3] !== spaceId) {
        t2 = Boolean(contentId) && Boolean(spaceId && /^\d+$/.test(spaceId)) && !hasSourceRestrictions;
        $[1] = contentId;
        $[2] = hasSourceRestrictions;
        $[3] = spaceId;
        $[4] = t2;
    } else t2 = $[4];
    const hasEligibleDestination = t2;
    const t3 = surface !== "editorRightRail" || !hasEligibleDestination || isFedRampEnvironment;
    let t4;
    if ($[5] !== t3) {
        t4 = {
            skip: t3
        };
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { isEnabled: isTwcg2304Treatment, loading: isTwcg2304Loading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)(t4);
    const baseStrategies = isFedRampEnvironment && (0, $9wGTI.fg)("cc_feature_discovery_ifs_fe") ? $962f4b1e576e5032$var$FEDRAMP_IMPORT_STRATEGIES : (0, $7dPLK.IMPORT_STRATEGIES);
    let t5;
    if ($[7] !== children || $[8] !== hasEligibleDestination || $[9] !== isTwcg2304Loading || $[10] !== isTwcg2304Treatment || $[11] !== surface) {
        t5 = children([
            ...baseStrategies,
            ...surface === "editorRightRail" && hasEligibleDestination && !isFedRampEnvironment && !isTwcg2304Loading && !isTwcg2304Treatment && (0, $6mKj3.expValEquals)("twcg_2627_markdown_file_import_into_confluence", "isEnabled", true) ? [
                (0, $7dPLK.MARKDOWN_IMPORT_STRATEGY)
            ] : []
        ]);
        $[7] = children;
        $[8] = hasEligibleDestination;
        $[9] = isTwcg2304Loading;
        $[10] = isTwcg2304Treatment;
        $[11] = surface;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5);
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ surface: surface, contentId: contentId, spaceId: spaceId, hasSourceRestrictions: hasSourceRestrictions, children: children })=>{
    const hostname = globalThis.location?.hostname ?? '';
    const isFedRampEnvironment = $962f4b1e576e5032$var$isFedRampHostname(hostname);
    const hasEligibleDestination = Boolean(contentId) && Boolean(spaceId && /^\d+$/.test(spaceId)) && !hasSourceRestrictions;
    const { isEnabled: isTwcg2304Treatment, loading: isTwcg2304Loading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)({
        skip: surface !== 'editorRightRail' || !hasEligibleDestination || isFedRampEnvironment
    });
    const baseStrategies = // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    isFedRampEnvironment && (0, $9wGTI.fg)('cc_feature_discovery_ifs_fe') ? $962f4b1e576e5032$var$FEDRAMP_IMPORT_STRATEGIES : (0, $7dPLK.IMPORT_STRATEGIES);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children([
        ...baseStrategies,
        ...surface === 'editorRightRail' && hasEligibleDestination && !isFedRampEnvironment && !isTwcg2304Loading && !isTwcg2304Treatment && (0, $6mKj3.expValEquals)('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true) ? [
            (0, $7dPLK.MARKDOWN_IMPORT_STRATEGY)
        ] : []
    ]));
};
module.exports["ImportStrategyRegistry"] = $962f4b1e576e5032$export$841c53a144a831b7;

});

parcelRegister("7dPLK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2jY8x = parcelRequire("2jY8x");

var $e73dbccb32a0cdf7$exports = {};
$e73dbccb32a0cdf7$exports = new URL("word.87639ee0.svg", import.meta.url).toString();


var $0c84c24c7b90e233$exports = {};
$0c84c24c7b90e233$exports = new URL("googleDocs.076e85b0.svg", import.meta.url).toString();


var $f1d9a311771e5602$exports = {};
$f1d9a311771e5602$exports = new URL("oneDriveLogo.a603c61e.svg", import.meta.url).toString();


/* ImportFromLocal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $dUJl3 = parcelRequire("dUJl3");

const $bb011addc13fe4ae$var$wrapperStyles = {
    root: "_39xV02N91d _1mT5xdRAKS"
};
const $bb011addc13fe4ae$export$e1ff9184b37d2a0d = ({ onStartStrategy: onStartStrategy, onDocumentSelect: onDocumentSelect, registerTrigger: registerTrigger, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const localInputRef = (0, $cozmU.useRef)(null);
    const pickDocument = ()=>{
        localInputRef.current.dispatchEvent(new MouseEvent(`click`, {
            //event must not be bubbled to prevent a callback loop error
            bubbles: false,
            cancelable: true,
            view: window
        }));
    };
    //TODO: create base strategy component and remove the duplication
    //due to stale closure we have to keep the props in a ref, so the methods are always up to date after rerender
    // another approach is to move ImportContextStrategy into every strategy and extend it with the props.
    const strategyProps = {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_LOCAL,
        folderName: formatMessage((0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_LOCAL]),
        pickDocument: pickDocument
    };
    const strategyPropsRef = (0, $cozmU.useRef)(strategyProps);
    strategyPropsRef.current = strategyProps;
    const handleClick = ()=>{
        onStartStrategy(strategyPropsRef);
    }; // Expose the same entry point the card's onItemClick uses, so consumers that render
    // their own trigger (e.g. the onboarding CTA dropdown) can start the import without
    // this component owning the clickable element. This must stay synchronous so the
    // hidden file input below is still clicked inside the trusted user gesture.
    (0, $cozmU.useEffect)(()=>{
        registerTrigger?.({
            start: ()=>onStartStrategy(strategyPropsRef)
        });
    }, [
        registerTrigger,
        onStartStrategy
    ]);
    const handleSelectedDocuments = (documents)=>{
        onDocumentSelect(documents);
    };
    const handleFileChange = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        const { files: files } = event.target;
        const fileList = Array.from(files);
        localInputRef.current.value = '';
        handleSelectedDocuments(fileList);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $bb011addc13fe4ae$var$wrapperStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "file",
        ref: localInputRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-negative-400, -32px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-100, 8px)"
        },
        accept: ".docx",
        onChange: handleFileChange,
        multiple: true,
        "data-testid": "import-from-local-file-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        ...children.props,
        // SourcesListCard triggers analytics with onItemClick prop
        onItemClick: (data)=>{
            handleClick();
            const originalOnItemClick = children.props.onItemClick;
            if (originalOnItemClick) originalOnItemClick(data);
        },
        // Remaining callbacks (notably AvatarItem in SourceListCard)
        onClick: (event_0)=>{
            handleClick();
            const originalOnClick = children.props.onClick;
            if (originalOnClick) originalOnClick(event_0);
        }
    }));
};


/* ImportFromGD.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $9DHhW = parcelRequire("9DHhW");


var $68uaC = parcelRequire("68uaC");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $dPJCf = parcelRequire("dPJCf");


var $7twp9 = parcelRequire("7twp9");


var $hTMqv = parcelRequire("hTMqv");

const $95a437f2a1213f31$export$61ddedcc8def425 = {
    width: 600,
    height: 600
};
class $95a437f2a1213f31$var$GoogleAuthenticator {
    async getAuthData() {
        const [oauthToken, { appId: appId, apiKey: apiKey }] = await Promise.all([
            this.obtainOauthToken(),
            this.obtainBasicCredentials()
        ]);
        return {
            apiKey: apiKey,
            appId: appId,
            oauthToken: oauthToken
        };
    }
    async obtainBasicCredentials() {
        const { data: data } = await (0, $7twp9.cfetchWithAbort)(`${(0, $hTMqv.IFS_API)}/google/secrets`, {
            mode: 'cors',
            credentials: 'include'
        }).then((response)=>response.json());
        return data;
    }
    async obtainOauthToken() {
        // window.open should not be called in async code to prevent popup blocking in Safari, Firefox
        this.authWindow = window.open('', 'auth', `width=${$95a437f2a1213f31$export$61ddedcc8def425.width},height=${$95a437f2a1213f31$export$61ddedcc8def425.height},toolbar=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no,top=${(screen.height - $95a437f2a1213f31$export$61ddedcc8def425.height) / 2},left=${(screen.width - $95a437f2a1213f31$export$61ddedcc8def425.width) / 2}`);
        const oauthToken = await Promise.race([
            this.handleCloseAuthWindow(),
            this.handleGrantAccess()
        ]);
        window.removeEventListener('message', this.popupMessageHandler);
        this.popupMessageHandler = null;
        this.authWindow = null;
        return oauthToken;
    }
    handleCloseAuthWindow() {
        return new Promise((resolve)=>{
            const self = this;
            (function checkAuthWindow() {
                if (self.authWindow && !self.authWindow.closed) return setTimeout(checkAuthWindow, 100);
                resolve('');
            })();
        });
    }
    handleGrantAccess() {
        return new Promise((resolve)=>{
            this.popupMessageHandler = this.handleMessage(resolve);
            window.addEventListener('message', this.popupMessageHandler);
            // eslint-disable-next-line no-restricted-syntax
            this.authWindow.location.href = `${0, $hTMqv.IFS_API}/google/login`;
        });
    }
    constructor(){
        this.authWindow = null;
        this.popupMessageHandler = null;
        this.handleMessage = (callback)=>(evt)=>{
                if (typeof evt.data === 'string' && evt.data.startsWith('ifs_google_access_token')) {
                    if (this.authWindow && !this.authWindow.closed) this.authWindow.close();
                    callback(evt.data.split(':')[1]);
                }
            };
    }
}
const $95a437f2a1213f31$export$b34b0f838337f14f = new $95a437f2a1213f31$var$GoogleAuthenticator();


/// <reference types="@types/gapi" />
/// <reference types="@types/google.picker" />
// TODO: replace with dynamic imports when webpack supports importing external scripts
//  with transpiling of the import statement itself:
//  https://github.com/webpack/webpack/issues/10446
//  https://github.com/webpack/webpack/issues/8341
async function $28d832b35f2bea3d$export$ea64e154fd703e14(src) {
    return new Promise((resolve, reject)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const existingScript = document.querySelector(`script[src='${src}']`);
        if (existingScript) {
            resolve(existingScript);
            return;
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const script = document.createElement('script');
        script.src = src;
        script.onload = ()=>resolve(script);
        script.onerror = reject;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(script);
    });
}


class $8a1b064d143bc7ee$export$236b283c346fef02 {
    async init() {
        await this.loadAPI();
        return this;
    }
    showPicker() {
        return new Promise((resolve, reject)=>{
            if (!this.googlePickerAPI) return reject(new Error('google.picker API was not loaded yet'));
            const view = new this.googlePickerAPI.DocsView(this.googlePickerAPI.ViewId.DOCUMENTS);
            // Show only GoogleDocs, exclude Word documents
            view.setMimeTypes('application/vnd.google-apps.document');
            this.pickerInstance = new this.googlePickerAPI.PickerBuilder().enableFeature(this.googlePickerAPI.Feature.NAV_HIDDEN).enableFeature(this.googlePickerAPI.Feature.MULTISELECT_ENABLED).setAppId(this.credentials.appId).setOAuthToken(this.credentials.oauthToken).addView(view).setDeveloperKey(this.credentials.apiKey)// Note, that setCallback will be called several times on different events inside the Picker
            .setCallback((data)=>this.performPickerResult(data, resolve, reject)).build();
            this.pickerInstance.setVisible(true);
        });
    }
    showPickerWithoutKey() {
        return new Promise((resolve, reject)=>{
            if (!this.googlePickerAPI) return reject(new Error('google.picker API was not loaded yet'));
            const view = new this.googlePickerAPI.DocsView(this.googlePickerAPI.ViewId.DOCUMENTS);
            // filter for only Google docs
            view.setMimeTypes('application/vnd.google-apps.document');
            this.pickerInstance = new this.googlePickerAPI.PickerBuilder().enableFeature(this.googlePickerAPI.Feature.NAV_HIDDEN).enableFeature(this.googlePickerAPI.Feature.MULTISELECT_ENABLED).setAppId(this.credentials.appId).setOAuthToken(this.credentials.oauthToken)// omit setDeveloperKey call since it seems unnecessary for displaying the file picker
            .addView(view).setCallback((data)=>this.performPickerResult(data, resolve, reject)).build();
            this.pickerInstance.setVisible(true);
        });
    }
    performPickerResult(data, onSuccess, onError) {
        if (!this.googlePickerAPI) {
            onError(new Error('google.picker API was not loaded yet'));
            return;
        }
        const buttonActions = [
            this.googlePickerAPI.Action.PICKED,
            this.googlePickerAPI.Action.CANCEL
        ];
        if (!buttonActions.includes(data.action)) return;
        if (data.action === this.googlePickerAPI.Action.PICKED) {
            if (!data.docs || !data.docs[0]) onError(new Error('Failed to pick a file'));
            else onSuccess(data.docs);
        } else if (data.action === this.googlePickerAPI.Action.CANCEL) onSuccess(null);
        this.addGadgetsToGlobalScope();
    }
    async loadAPI() {
        const loadApiPromise = async ()=>{
            this.removeGadgetsFromGlobalScope();
            this.googleScript = await (0, $28d832b35f2bea3d$export$ea64e154fd703e14)('https://apis.google.com/js/api.js');
            return new Promise((resolve)=>{
                gapi.load('picker', ()=>{
                    resolve(google.picker);
                });
            });
        };
        this.googlePickerAPI = await loadApiPromise();
    }
    /*
   this is workaround to make Google API works properly.
   variable "gadgets" doesn't allow gapi.load('picker') works properly because of global scope pollution and
   "gapi" cannot initialize global "google" variable with "picker" field inside.
   this problem occurred after https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/12152/overview
   was merged into master. The PR linked above is a fix for editor gadgets which interact with Jira and it is very important.
    */ removeGadgetsFromGlobalScope() {
        this.gadgets = globalThis.gadgets;
        globalThis.gadgets = null;
    }
    addGadgetsToGlobalScope() {
        globalThis.gadgets = this.gadgets;
        this.gadgets = null;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.removeChild(this.googleScript);
        this.googleScript = null;
    }
    constructor(credentials){
        this.credentials = void 0;
        this.pickerInstance = null;
        this.googlePickerAPI = null;
        this.gadgets = null;
        this.googleScript = null;
        this.credentials = credentials;
    }
}





class $494e6c3b48704c4a$export$16e2fcd4a5c7550c {
    /** Performs export of a Google Docs files to other formats
   * https://developers.google.com/drive/api/v3/reference/files/export
   */ async exportFile(fileId, exportFormat, signal) {
        const path = `${$494e6c3b48704c4a$export$16e2fcd4a5c7550c.GOOGLE_API_URL}/files/${fileId}/export`;
        const url = `${path}?mimeType=${exportFormat}&key=${this.credentials.apiKey}`;
        const headers = {
            Authorization: `Bearer ${this.credentials.oauthToken}`
        };
        //https://jira.atlassian.com/browse/CONFCLOUD-75614
        //omit credentials to prevent CORS errors from google
        const request = new Request(url, {
            credentials: 'omit'
        });
        // We send a plain fetch instead of gapi.client usage because gapi.client seems to return data in a wrong format
        const res = await (0, $7twp9.cfetchWithAbort)(request, {
            headers: headers,
            signal: signal
        });
        return res.blob();
    }
    constructor(credentials){
        this.credentials = void 0;
        this.credentials = credentials;
    }
}
$494e6c3b48704c4a$export$16e2fcd4a5c7550c.GOOGLE_API_URL = 'https://www.googleapis.com/drive/v3';



var $e3aE9 = parcelRequire("e3aE9");


var $lrhMp = parcelRequire("lrhMp");

const $30f79d193bd028a2$export$911012e8fa58fb0a = (e, errorType)=>{
    if (e?.error?.errors && Array.isArray(e.error.errors)) {
        const result = e.error.errors.filter((elem)=>elem.reason === errorType);
        return !!result.length;
    }
    return false;
};



var $bGxBv = parcelRequire("bGxBv");


var $ix5ga = parcelRequire("ix5ga");


var $r3F1B = parcelRequire("r3F1B");


var $aGMzc = parcelRequire("aGMzc");










const $bd22dcf592a5e0f2$export$58335605c8ce1869 = (e)=>{
    return e.response?.json();
};



var $hPg0A = parcelRequire("hPg0A");


var $eImq9 = parcelRequire("eImq9");





var $eEPSE = parcelRequire("eEPSE");


var $c4iAx = parcelRequire("c4iAx");





var $6mKj3 = parcelRequire("6mKj3");

const $09b30d0ccda17211$export$c73cf090995fe84f = ()=>{
    const getAccessToken = async (containerId, serviceKey, userId)=>{
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/word-doc/get-access-token?aaId=${userId}&containerId=${containerId}&serviceKey=${serviceKey}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (!data.access_token) throw new Error('Access token not found in Outbound response');
            return data.access_token;
        } catch (e) {
            throw new Error(`Failed to get access token: ${e}`);
        }
    };
    return (0, $cozmU.useCallback)((containerId_0, serviceKey_0, userId_0)=>{
        if (!userId_0) return;
        if (!serviceKey_0.trim() || !containerId_0.trim()) return;
        const baseUrl = (0, $c4iAx.getATLContextUrl)('id');
        let authUrl = `${baseUrl}/outboundAuth/start?containerId=${containerId_0}&serviceKey=${serviceKey_0}`;
        if (serviceKey_0 === 'gdrive' && (0, $6mKj3.expValEquals)('cc_import_google_file_scopes', 'isEnabled', true)) {
            const url = new URL(authUrl);
            url.searchParams.set('scopes', [
                'https://www.googleapis.com/auth/drive.readonly',
                'https://www.googleapis.com/auth/userinfo.email',
                'https://www.googleapis.com/auth/userinfo.profile'
            ].join(' '));
            authUrl = url.toString();
        }
        return (0, $eEPSE.auth)(authUrl).then(()=>{
            return getAccessToken(containerId_0, serviceKey_0, userId_0);
        });
    }, []);
};



var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");








var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $lsxnT = parcelRequire("lsxnT");

const $ea168c2c6f2f5c9d$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, onClose: onClose } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: "medium"
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children, onClose: onClose })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: "medium"
    }, children);
};
const $ea168c2c6f2f5c9d$var$ATL_COOKIES_URL = 'https://www.atlassian.com/legal/cookies';
const $ea168c2c6f2f5c9d$var$styles = {
    content: "_0jFU0VymWf",
    contentText: "_3SamIHkG2W _2YLqiKdnbC",
    buttonGroup: "_313842kG2W"
};
const $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    googleCookiesNotAllowedModalTitle: {
        id: "import-from-sources.cookies-not-allowed.title",
        defaultMessage: "Import unavailable"
    },
    googleCookiesNotAllowedModalText: {
        id: "import-from-sources.cookies-not-allowed.text",
        defaultMessage: "To import from Google Docs, please clear your browser cookies, refresh the page, and allow all cookies."
    },
    moreOnCookiesButtonLabel: {
        id: "import-from-sources.cookies-not-allowed.moreOnCookiesAction",
        defaultMessage: "More on cookies"
    },
    gotItButtonLabel: {
        id: "import-from-sources.cookies-not-allowed.gotItAction",
        defaultMessage: "Got it"
    }
});
const $ea168c2c6f2f5c9d$export$99947b15cc7a9e07 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onClose: onClose } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.googleCookiesNotAllowedModalTitle)));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "p",
            xcss: $ea168c2c6f2f5c9d$var$styles.contentText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.googleCookiesNotAllowedModalText));
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            testId: "google-cookies-more-on-cookies-button",
            href: $ea168c2c6f2f5c9d$var$ATL_COOKIES_URL,
            target: "_blank"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.moreOnCookiesButtonLabel));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.gotItButtonLabel);
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== onClose) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ea168c2c6f2f5c9d$var$styles.content
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignInline: "end",
            alignBlock: "center",
            space: "space.150",
            xcss: $ea168c2c6f2f5c9d$var$styles.buttonGroup
        }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "google-cookies-got-it-button",
            onClick: onClose
        }, t4))));
        $[4] = onClose;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== onClose || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea168c2c6f2f5c9d$var$ChoreographerModal, {
            onClose: onClose
        }, t1, t5);
        $[6] = onClose;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea168c2c6f2f5c9d$var$ChoreographerModal, {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.googleCookiesNotAllowedModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ea168c2c6f2f5c9d$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "p",
        xcss: $ea168c2c6f2f5c9d$var$styles.contentText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.googleCookiesNotAllowedModalText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "end",
        alignBlock: "center",
        space: "space.150",
        xcss: $ea168c2c6f2f5c9d$var$styles.buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        testId: "google-cookies-more-on-cookies-button",
        href: $ea168c2c6f2f5c9d$var$ATL_COOKIES_URL,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.moreOnCookiesButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "google-cookies-got-it-button",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ea168c2c6f2f5c9d$export$a7357cdd1f0b0168.gotItButtonLabel))))));
};















var $6kn6H = parcelRequire("6kn6H");

const $6b3959da692eedfe$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    fileGoogleExceedsLimit: {
        id: "import-from-sources.warning-modal.fileGoogleExceedsLimit",
        defaultMessage: "{fileName} exceeds the 10 MB export limit from Google Drive."
    }
});
const $6b3959da692eedfe$export$377b1c3a545b7ee7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onSubmit: onSubmit, onClose: onClose, fileName: fileName } = t0;
    let t1;
    if ($[0] !== fileName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$6b3959da692eedfe$export$a7357cdd1f0b0168.fileGoogleExceedsLimit,
            values: {
                fileName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileName)
            }
        });
        $[0] = fileName;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClose || $[3] !== onSubmit || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kn6H.FileSizeModal), {
            onSubmit: onSubmit,
            onClose: onClose,
            bodyText: t1
        });
        $[2] = onClose;
        $[3] = onSubmit;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ onSubmit: onSubmit, onClose: onClose, fileName: fileName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kn6H.FileSizeModal), {
        onSubmit: onSubmit,
        onClose: onClose,
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$6b3959da692eedfe$export$a7357cdd1f0b0168.fileGoogleExceedsLimit,
            values: {
                fileName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileName)
            }
        })
    });
};
























var $4aRua = parcelRequire("4aRua");





var $cJ0FD = parcelRequire("cJ0FD");
















var $28cabb47ab246b30$exports = {};
$28cabb47ab246b30$exports = new URL("googleLogo.82902f28.svg", import.meta.url).toString();


const $573ee800daa4cda8$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, onClose: onClose, testId: testId } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: "medium",
            testId: testId
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, onClose: onClose, testId: testId })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: "medium",
        testId: testId
    }, children);
};
const $573ee800daa4cda8$var$i18n = (0, $kSwu1.defineMessages)({
    googleSignInModalTitle: {
        id: "import-from-sources.import-from-gd-modal.title",
        defaultMessage: "Import Google Doc"
    },
    googleSignInModalText: {
        id: "import-from-sources.import-from-gd-modal.text",
        defaultMessage: "Connect your Google account to continue"
    },
    cancelGoogleSignInModalButtonLabel: {
        id: "import-from-sources.import-from-gd-modal.cancelAction",
        defaultMessage: "Cancel"
    },
    signInGoogleSignInModalButtonLabel: {
        id: "import-from-sources.import-from-gd-modal.singIn",
        defaultMessage: "Sign in with Google"
    }
});
const $573ee800daa4cda8$var$styles = {
    content: "_0jFU0VoV4E",
    contentText: "_3SamIHkG2W _2YLqiKdnbC",
    buttonGroup: "_313842kG2W"
};
const $573ee800daa4cda8$export$d04b73213d5fb885 = ({ onClose: onClose, onSignIn: onSignIn, handleAuth: handleAuth })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importGoogleSignInModal'
            }
        }).fire(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onCloseClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importGDocModal',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'importGoogleSignInCancel'
            }
        }).fire();
        return onClose();
    };
    const onSignInClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importGDocModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importGoogleSignIn'
            }
        }).fire();
        return onSignIn();
    };
    const onHandleAuthClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importGDocModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importGoogleSignInAuthClick'
            }
        }).fire();
        return handleAuth();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($573ee800daa4cda8$var$ChoreographerModal, {
        onClose: onCloseClick,
        testId: "import-google-sign-in-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $573ee800daa4cda8$var$i18n.googleSignInModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $573ee800daa4cda8$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "p",
        xcss: $573ee800daa4cda8$var$styles.contentText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $573ee800daa4cda8$var$i18n.googleSignInModalText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "end",
        alignBlock: "center",
        space: "space.150",
        xcss: $573ee800daa4cda8$var$styles.buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "google-sign-in-close-button",
        appearance: "subtle",
        onClick: onCloseClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $573ee800daa4cda8$var$i18n.cancelGoogleSignInModalButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "google-sign-in-button",
        onClick: (0, $9wGTI.fg)('cc_feature_discovery_ifs_fe') ? onHandleAuthClick : onSignInClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($28cabb47ab246b30$exports))),
        alt: "",
        height: 18,
        width: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $573ee800daa4cda8$var$i18n.signInGoogleSignInModalButtonLabel))))))));
};















var $9ZvQo = parcelRequire("9ZvQo");









const $b434310b362a1ff3$export$a867028b3abc34c9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { docActions: t0 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocFailure: uploadDocFailure } = t0;
    let t1;
    if ($[0] !== uploadDocFailure) {
        t1 = async (error, docName)=>{
            if (error === (0, $7twp9.REQUEST_ABORTED)) {
                uploadDocFailure(docName, {
                    type: (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return;
            }
            const errorBody = await (0, $bd22dcf592a5e0f2$export$58335605c8ce1869)(error);
            if ((0, $30f79d193bd028a2$export$911012e8fa58fb0a)(errorBody, (0, $lrhMp.GOOGLE_EXPORT_ERRORS).FILE_SIZE_LIMIT)) {
                uploadDocFailure(docName, {
                    type: (0, $9ZvQo.DocErrors).SIZE_GD_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return;
            }
            if ((0, $30f79d193bd028a2$export$911012e8fa58fb0a)(errorBody, (0, $lrhMp.GOOGLE_EXPORT_ERRORS).USER_RATE_LIMIT)) {
                uploadDocFailure(docName, {
                    type: (0, $lrhMp.GOOGLE_EXPORT_ERRORS).USER_RATE_LIMIT,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return;
            }
            uploadDocFailure(docName, {
                type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
        };
        $[0] = uploadDocFailure;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)(async (error, docName)=>{
        if (error === (0, $7twp9.REQUEST_ABORTED)) {
            uploadDocFailure(docName, {
                type: (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
            return;
        }
        const errorBody = await (0, $bd22dcf592a5e0f2$export$58335605c8ce1869)(error);
        if ((0, $30f79d193bd028a2$export$911012e8fa58fb0a)(errorBody, (0, $lrhMp.GOOGLE_EXPORT_ERRORS).FILE_SIZE_LIMIT)) {
            uploadDocFailure(docName, {
                type: (0, $9ZvQo.DocErrors).SIZE_GD_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
            return;
        }
        if ((0, $30f79d193bd028a2$export$911012e8fa58fb0a)(errorBody, (0, $lrhMp.GOOGLE_EXPORT_ERRORS).USER_RATE_LIMIT)) {
            uploadDocFailure(docName, {
                type: (0, $lrhMp.GOOGLE_EXPORT_ERRORS).USER_RATE_LIMIT,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
            return;
        }
        uploadDocFailure(docName, {
            type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
            role: (0, $9ZvQo.ErrorRoles).ERROR
        });
    }, [
        uploadDocFailure
    ]);
};


const $d759c9c40647c36b$var$pressableStyles = {
    root: "_0KLXru66of _39xV02N91d"
};
var $d759c9c40647c36b$var$GDModalTypes = /*#__PURE__*/ function(GDModalTypes) {
    GDModalTypes["SIGN_IN"] = "SIGN_IN";
    GDModalTypes["FILE_SIZE"] = "FILE_SIZE";
    GDModalTypes["COOKIES"] = "COOKIES";
    return GDModalTypes;
}($d759c9c40647c36b$var$GDModalTypes || {});
const $d759c9c40647c36b$var$useImportSourceParam = (0, $dPJCf.createSingleQueryParamHook)('importSource');
const $d759c9c40647c36b$export$65e7c42aee199ab4 = 'google-picker';
const $d759c9c40647c36b$export$cce50c292925c71b = ({ onStartStrategy: onStartStrategy, onDocumentSelect: onDocumentSelect, onDocumentSelectError: onDocumentSelectError, registerTrigger: registerTrigger, skipAuthInterstitial: skipAuthInterstitial, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const authData = (0, $cozmU.useRef)(null);
    const googleToken = (0, $cozmU.useRef)();
    const outboundAuthContainer = (0, $cozmU.useRef)();
    const googleAuthData = (0, $cozmU.useRef)(null);
    const importSourceParam = $d759c9c40647c36b$var$useImportSourceParam();
    const { isEnabled: isExperimentEnabled } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const { modalStack: GDModalStack, showModal: showGDModal, closeModal: closeGDModal } = (0, $bGxBv.useModals)();
    const { closeModal: closeImportModal, docActions: { uploadDocSize: uploadDocSize, updateDocuments: updateDocuments } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleGoogleBulkErrors = (0, $b434310b362a1ff3$export$a867028b3abc34c9)();
    const bulkLimitCheck = (0, $hPg0A.useBulkLimitCheck)();
    const addAbortControllerDocuments = (0, $eImq9.useAddAbortControllerDocuments)();
    const getAccessToken = (0, $09b30d0ccda17211$export$c73cf090995fe84f)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const exportFromGoogleDrive = async (selectedDoc, isBulkUpload)=>{
        const [selectedDocAbortSignal] = addAbortControllerDocuments([
            selectedDoc
        ]);
        const { signal: signal } = selectedDocAbortSignal;
        try {
            // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
            const googleAuth = (0, $9wGTI.fg)('cc_feature_discovery_ifs_fe') ? {
                apiKey: googleAuthData.current?.apiKey || '',
                appId: '',
                oauthToken: googleToken.current
            } : authData.current;
            const blob = await new (0, $494e6c3b48704c4a$export$16e2fcd4a5c7550c)(googleAuth).exportFile(selectedDoc.id, (0, $e3aE9.FILES_EXPORT_FORMATS).WordDocument, signal);
            const file = new File([
                blob
            ], selectedDoc.name, {
                lastModified: selectedDoc.lastEditedUtc,
                type: blob.type
            });
            uploadDocSize(file.name, file.size);
            return file;
        } catch (error) {
            if (!isBulkUpload) return handleSingleErrors(error, selectedDoc.name);
            else {
                await handleGoogleBulkErrors(error, selectedDoc.name);
                return null;
            }
        }
    };
    const pickDocument = async ()=>{
        await (0, $68uaC.Cookies).checkThirdParty($d759c9c40647c36b$export$65e7c42aee199ab4, async ()=>{
            if (authData.current) selectFileInGDPicker();
            else if (skipAuthInterstitial) {
                // Do exactly what the sign-in modal's primary button does, without
                // asking the user to confirm an intent they already expressed.
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                if ((0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) {
                    // The modal's hover/focus prefetch never ran, so make sure the
                    // outbound auth container is resolved before handleAuth needs it.
                    await getGoogleSecrets();
                    await handleAuth();
                } else selectFileInGDPicker();
            } else showGDModal("SIGN_IN");
        }, async ()=>{
            showGDModal("COOKIES");
        });
    };
    //do not validate files before export because they don't have size and type
    const skipValidation = (docs)=>docs;
    const validateBulkBeforeUpload = async (documents)=>{
        const filteredDocs = documents.filter((doc)=>doc); //update the context with the exported docs before limit modal is shown
        updateDocuments(filteredDocs);
        return bulkLimitCheck(filteredDocs);
    }; // TODO: create base strategy component and remove the duplication
    // due to stale closure we have to keep the props in a ref, so the methods are always up to date after rerender
    // another approach is to move ImportContextStrategy into every strategy and extend it with the props.
    const strategyProps = {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_GD,
        folderName: formatMessage((0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_GD]),
        pickDocument: pickDocument,
        exportFile: exportFromGoogleDrive,
        validateSingleUploadBeforeProgress: skipValidation,
        validateBulkUploadBeforeProgress: skipValidation,
        validateBulkBeforeUpload: validateBulkBeforeUpload
    };
    const strategyPropsRef = (0, $cozmU.useRef)(strategyProps);
    strategyPropsRef.current = strategyProps;
    const getGoogleSecrets = (0, $cozmU.useCallback)(async ()=>{
        // optimistically fetch outbound container
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        if (!outboundAuthContainer.current && (0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) try {
            const result = await (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/word-doc/get-google-secrets?secretType=OUTBOUND_AUTH`).then((res)=>res.json());
            if (result) outboundAuthContainer.current = result.outboundAuthContainerId;
        } catch (err) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'gdPicker',
                    action: 'fetch',
                    actionSubject: 'outboundAuthToken',
                    attributes: {
                        errMessage: err.message
                    }
                }
            }).fire();
            return;
        }
    }, [
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Auto-trigger Google Docs import when the user arrives via the onboarding Import CTA
        // with importSource=gDoc in the URL (set by FooterCreateButtons → createPageContent).
        // Guard with the experiment hook so this only fires for users enrolled in the experiment.
        if (importSourceParam === (0, $dUJl3.ActiveImports).IMPORT_FROM_GD && isExperimentEnabled) {
            if (!googleToken.current && !googleAuthData.current) onStartStrategy(strategyPropsRef);
            getGoogleSecrets();
        } // Run once on mount — importSourceParam is a stable query-param value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = ()=>{
        // Clear cached credentials when starting from the left nav so the user always
        // re-authenticates before the picker opens, including skipAuthInterstitial routes.
        authData.current = null;
        googleToken.current = undefined;
        onStartStrategy(strategyPropsRef);
    }; // Expose the same entry point the card's onItemClick uses, so consumers that render
    // their own trigger (e.g. the onboarding CTA dropdown) can start the import without
    // this component owning the clickable element. `prefetch` mirrors the hover/focus
    // warm-up on the card wrapper below, which never fires when there is no visible card.
    const handleClickRef = (0, $cozmU.useRef)(handleClick);
    handleClickRef.current = handleClick;
    (0, $cozmU.useEffect)(()=>{
        registerTrigger?.({
            start: ()=>handleClickRef.current(),
            prefetch: ()=>void getGoogleSecrets()
        });
    }, [
        registerTrigger,
        getGoogleSecrets
    ]);
    const checkSizeErrorAndShowModal = async (error, documentName)=>{
        const errorBody = await (0, $bd22dcf592a5e0f2$export$58335605c8ce1869)(error);
        if ((0, $30f79d193bd028a2$export$911012e8fa58fb0a)(errorBody, (0, $lrhMp.GOOGLE_EXPORT_ERRORS).FILE_SIZE_LIMIT)) {
            closeImportModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            showGDModal("FILE_SIZE", {
                fileName: documentName
            });
            return true;
        }
        return false;
    };
    const handleSingleErrors = async (error, docName)=>{
        const handledError = error === (0, $7twp9.REQUEST_ABORTED) || (0, $7twp9.checkForAbortErrorMsg)(error) || await checkSizeErrorAndShowModal(error, docName);
        if (!handledError) onDocumentSelectError();
        return null;
    };
    const sendGPickerCancelEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'gdPicker',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'gdPickerClose'
            }
        }).fire();
    };
    const sendGPickerSelectEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'gdPicker',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gdPickerSelect'
            }
        }).fire();
    };
    const selectFileInGDPicker = async ()=>{
        try {
            if (!authData.current) {
                const data = await (0, $95a437f2a1213f31$export$b34b0f838337f14f).getAuthData();
                if (!data.oauthToken) return false;
                authData.current = data;
            }
            const gdPicker = await new (0, $8a1b064d143bc7ee$export$236b283c346fef02)(authData.current).init();
            const selectedDocs = await gdPicker.showPicker();
            if (!selectedDocs) {
                // absence of a selected doc means that picker was closed with Cancel/Close button
                sendGPickerCancelEvent();
                return;
            }
            sendGPickerSelectEvent();
            onDocumentSelect(selectedDocs);
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'gdPicker',
                    action: 'select',
                    actionSubject: 'googlDriveFile',
                    attributes: {
                        errMessage: error.message
                    }
                }
            }).fire();
            onDocumentSelectError();
        }
    };
    const closeModalAndSelectFile = (modalType)=>{
        closeGDModal(modalType);
        selectFileInGDPicker();
    };
    const handleFileSizeModalClose = ()=>{
        closeGDModal("FILE_SIZE");
        authData.current = null;
    };
    const handleAuth = async ()=>{
        closeGDModal("SIGN_IN");
        try {
            const result = await (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/word-doc/get-google-secrets?secretType=API_SECRETS`).then((res)=>res.json()); // fetch and store appId and apiKey (for upload)
            if (result) googleAuthData.current = {
                apiKey: result.googleApiKey,
                appId: result.googleAppId
            };
        } catch (err) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'gdPicker',
                    action: 'fetch',
                    actionSubject: 'googleDriveSecrets',
                    attributes: {
                        errMessage: err.message
                    }
                }
            }).fire();
            return;
        }
        selectFile();
    };
    const getGoogleToken = async ()=>{
        // Fetch container ID by environment
        if (outboundAuthContainer.current && !googleToken.current && userId) {
            const token = await getAccessToken(outboundAuthContainer.current, 'gdrive', userId);
            googleToken.current = token;
        }
    };
    const selectFile = async ()=>{
        await getGoogleToken(); // Fetch Google secrets (appId and apiKey)
        if (googleToken.current && googleAuthData.current) {
            const gdPicker = await new (0, $8a1b064d143bc7ee$export$236b283c346fef02)({
                oauthToken: googleToken.current,
                appId: googleAuthData.current.appId,
                apiKey: googleAuthData.current.apiKey
            }).init();
            const selectedDocuments = await gdPicker.showPickerWithoutKey(); // Upload selected documents
            if (selectedDocuments) onDocumentSelect(selectedDocuments);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, GDModalStack["SIGN_IN"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $573ee800daa4cda8$export$d04b73213d5fb885), {
        onClose: ()=>closeGDModal("SIGN_IN"),
        onSignIn: ()=>closeModalAndSelectFile("SIGN_IN"),
        handleAuth: handleAuth
    }), GDModalStack["FILE_SIZE"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b3959da692eedfe$export$377b1c3a545b7ee7), {
        onClose: handleFileSizeModalClose,
        onSubmit: ()=>closeModalAndSelectFile("FILE_SIZE"),
        fileName: GDModalStack["FILE_SIZE"].fileName
    }), GDModalStack["COOKIES"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea168c2c6f2f5c9d$export$99947b15cc7a9e07), {
        onClose: ()=>closeGDModal("COOKIES")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onMouseEnter: getGoogleSecrets,
        onFocus: getGoogleSecrets,
        className: (0, $hekY6.default)([
            $d759c9c40647c36b$var$pressableStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        ...children.props,
        onItemClick: (data)=>{
            handleClick();
            const originalOnItemClick = children.props.onItemClick;
            if (originalOnItemClick) originalOnItemClick(data);
        }
    })));
};


/* ImportFromOneDrive.tsx generated by @compiled/babel-plugin v3.0.2 */ 


























var $3239d32085437ca5$export$ddb511faf6105515 = /*#__PURE__*/ function(OneDriveActionTypes) {
    OneDriveActionTypes["CLICK"] = "click";
    OneDriveActionTypes["INIT"] = "init";
    OneDriveActionTypes["UNMOUNT"] = "unmount";
    OneDriveActionTypes["SUCCESS"] = "success";
    OneDriveActionTypes["CANCEL"] = "cancel";
    OneDriveActionTypes["ERROR"] = "error";
    return OneDriveActionTypes;
}({});
var $3239d32085437ca5$export$ed808eefc887672f = /*#__PURE__*/ function(OneDrivePickerActions) {
    OneDrivePickerActions["SHARE"] = "share";
    OneDrivePickerActions["QUERY"] = "query";
    OneDrivePickerActions["DOWNLOAD"] = "download";
    return OneDrivePickerActions;
}({});
var $3239d32085437ca5$export$94c0d1c674a48872 = /*#__PURE__*/ function(OneDriveErrorStatuses) {
    OneDriveErrorStatuses[OneDriveErrorStatuses["NO_ACCESS"] = 403] = "NO_ACCESS";
    return OneDriveErrorStatuses;
}({});


class $293c7da1d374b695$export$5966f623d01a4ea5 {
    init() {
        this.options.iframe.contentWindow?.postMessage({
            type: 'ifs-onedrive',
            actionType: (0, $3239d32085437ca5$export$ddb511faf6105515).INIT,
            pickerOptions: {
                multiSelect: this.options.multiSelect
            },
            microsoftClientId: this.options.microsoftClientId
        }, '*');
        window.addEventListener('message', this.pickerListener, false);
        return this;
    }
    unmount() {
        this.options.iframe.contentWindow?.postMessage({
            type: 'ifs-onedrive',
            actionType: (0, $3239d32085437ca5$export$ddb511faf6105515).UNMOUNT
        }, '*');
        window.removeEventListener('message', this.pickerListener, false);
    }
    async exportFromMicrosoftGraph(selectedDoc) {
        //due to CORS error cfetch can't be used because it adds the credentials field
        /* oxlint-disable-next-line eslint-core/no-restricted-syntax */ // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        const response = await fetch(selectedDoc['@microsoft.graph.downloadUrl']);
        if (!response.ok) throw {
            status: response.status
        };
        const fileBlob = await response.blob();
        return new File([
            fileBlob
        ], selectedDoc.name, {
            type: fileBlob.type
        });
    }
    constructor(opt){
        this.options = void 0;
        this.pickerPromise = {};
        this.handleIframeClick = ()=>{
            this.pickerPromise.promise = new Promise((resolve, reject)=>{
                this.pickerPromise.resolve = resolve;
                this.pickerPromise.reject = reject;
            });
            this.options.onIframeClick(this.pickerPromise.promise);
        };
        this.handlePickerSuccess = (pickerData)=>{
            //there's no value if the file is removed or the access is disabled
            // https://hello.atlassian.net/wiki/spaces/CCECO/pages/1277983936/IFS+office+365+Use+cases#10.-Should-show-the-error-if-a-document-is-not-shared-anymore.
            pickerData.value ? this.pickerPromise.resolve(pickerData.value) : this.pickerPromise.reject({
                status: (0, $3239d32085437ca5$export$94c0d1c674a48872).NO_ACCESS
            });
        };
        this.pickerListener = (event)=>{
            if (event.data?.type !== 'ifs-onedrive') return;
            const { actionType: actionType, pickerData: pickerData } = event.data || {};
            switch(actionType){
                case (0, $3239d32085437ca5$export$ddb511faf6105515).CLICK:
                    this.handleIframeClick();
                    break;
                case (0, $3239d32085437ca5$export$ddb511faf6105515).SUCCESS:
                    this.handlePickerSuccess(pickerData);
                    break;
                case (0, $3239d32085437ca5$export$ddb511faf6105515).CANCEL:
                    this.pickerPromise.resolve(null);
                    break;
                case (0, $3239d32085437ca5$export$ddb511faf6105515).ERROR:
                    this.pickerPromise.reject(pickerData);
                    break;
            }
        };
        this.options = opt;
    }
}
















var $8ARcf = parcelRequire("8ARcf");

















var $I7hWB = parcelRequire("I7hWB");








var $kh0hi = parcelRequire("kh0hi");


var $w6R6I = parcelRequire("w6R6I");


var $9GVkD = parcelRequire("9GVkD");



















const $3ac803fc93089416$var$ONEDRIVE_PICKER = 'onedrive-picker';
const $3ac803fc93089416$var$IFS_DIRECT_PATH_PROD = `https://cc-import-sources.services.atlassian.com/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_SANDBOX = `https://cc-import-sources.atlassian-fex.com/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_STAGING = `https://cc-import-sources.stg.services.atlassian.com/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_LOCAL = `http://localhost:8080/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_STG = `https://cc-import-sources.stg.services.atlassian-us-gov-mod.com/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_PROD = `https://cc-import-sources.services.atlassian-us-gov-mod.com/${$3ac803fc93089416$var$ONEDRIVE_PICKER}`;
const $3ac803fc93089416$var$IFS_DIRECT_PATH_STAGING_BIFROST = 'https://cc-import-sources-onedrive.stg-east.frontend.public.atl-paas.net';
const $3ac803fc93089416$var$IFS_DIRECT_PATH_PROD_BIFROST = 'https://cc-import-sources-onedrive.prod-east.frontend.public.atl-paas.net';
const $3ac803fc93089416$export$1653697dcdd50deb = (environment)=>{
    const hostname = window?.location?.hostname || '';
    const environmentTail = hostname.split('.').slice(-2).join('.');
    const isLocal = hostname === 'localhost';
    const isProd = environment === 'PRODUCTION';
    switch(environmentTail){
        case 'atlassian-fex.com':
        case 'atlassian-fex.net':
            return $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_SANDBOX;
        case 'atlassian-us-gov-mod.com':
        case 'atlassian-us-gov-mod.net':
            return $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_PROD;
        case 'atlassian-stg-fedm.net':
            return $3ac803fc93089416$var$IFS_DIRECT_PATH_FEDRAMP_STG;
        default:
            if (isProd) {
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                if ((0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) return $3ac803fc93089416$var$IFS_DIRECT_PATH_PROD_BIFROST;
                return $3ac803fc93089416$var$IFS_DIRECT_PATH_PROD;
            } else if (isLocal) {
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                if ((0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) return $3ac803fc93089416$var$IFS_DIRECT_PATH_STAGING_BIFROST;
                return $3ac803fc93089416$var$IFS_DIRECT_PATH_LOCAL;
            } else {
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                if ((0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) return $3ac803fc93089416$var$IFS_DIRECT_PATH_STAGING_BIFROST;
                return $3ac803fc93089416$var$IFS_DIRECT_PATH_STAGING;
            }
    }
};


const $b55dd2dba33efd74$var$styles = {
    body: "_2Y7lL4NHnM _0Of8r25zaO _1wydGWNHnM",
    bodyText: "_3SamIH5zaO _2YLqiKdnbC _1UtDYzKGUX",
    buttonGroup: "_313842kG2W",
    frame: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0bjKvDKTcp _30huDKN1NE _1mT5xdRAKS _3iDTPbvbI6 _0KLXruDM2k _0wOv4Q7zJH _0hPERGJrlu _1eOmH6hmrj",
    disabledFrame: "_1pp6NdYbGa _1YKVNsVx3j",
    primaryButton: "_30huDKYbGa _4c065UdnbC _2Y7lL4kG2W _1pp6NdYbGa _0KLXrujOvk _1UtDYze5R3 _1mT5xdRAKS _1kk5Tk7GSX _0jFU0VcM5X _0wOv4Q7zJH"
};
const $b55dd2dba33efd74$var$i18n = (0, $kSwu1.defineMessages)({
    oneDriveConfirmModalText: {
        id: "import-from-sources.import-from-onedrive-confirm-modal.text",
        defaultMessage: "This site is trying to launch OneDrive. Do you want to continue?"
    },
    oneDriveConfirmModalHeader: {
        id: "import-from-sources.import-from-onedrive-confirm-modal.header",
        defaultMessage: "Open OneDrive"
    },
    launchingOneDriveHeading: {
        id: "import-from-sources.import-from-onedrive-confirm-modal.sr-heading",
        defaultMessage: "Launching OneDrive"
    },
    continueOneDriveConfirmModalButtonLabel: {
        id: "import-from-sources.import-from-onedrive-confirm-modal.continue",
        defaultMessage: "Continue"
    }
});
const $b55dd2dba33efd74$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClose: onClose, testId: testId, width: width } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose || $[3] !== testId || $[4] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: width,
            testId: testId
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = testId;
        $[4] = width;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, onClose: onClose, testId: testId, width: width })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: width,
        testId: testId
    }, children);
};
const $b55dd2dba33efd74$export$81fa250450e7a3ee = 'oneDriveConfirmModalId';
const $b55dd2dba33efd74$export$da95c48dd722cf8 = ({ onClose: onClose, onIframeLoad: onIframeLoad })=>{
    const iframeRef = (0, $cozmU.useRef)(null);
    const [isIframeLoading, setIsIframeLoading] = (0, $cozmU.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importOneDriveConfirmModal'
            }
        }).fire(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleIframeLoad = ()=>{
        setIsIframeLoading(false); //haven't found any normal way of changing the styles of the modal's wrapper. have to use the data-testid
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const modalWrapper = document.querySelectorAll(`[data-testid="${$b55dd2dba33efd74$export$81fa250450e7a3ee}"]`)[0];
        onIframeLoad(iframeRef, modalWrapper);
    };
    const handleClose = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'office365ConfirmModal',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'office365ConfirmClose'
            }
        }).fire();
        onClose();
    };
    const ifsDirectPath = (0, $3ac803fc93089416$export$1653697dcdd50deb)(environment);
    const isGeminiVr = typeof window !== 'undefined' && Boolean(window.Gemini);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b55dd2dba33efd74$var$ChoreographerModal, {
        onClose: handleClose,
        width: 360,
        testId: $b55dd2dba33efd74$export$81fa250450e7a3ee
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b55dd2dba33efd74$var$i18n.launchingOneDriveHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, (0, $9wGTI.fg)('platform_dst_modal-dialog-use-modal-title') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b55dd2dba33efd74$var$i18n.oneDriveConfirmModalHeader)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b55dd2dba33efd74$var$i18n.oneDriveConfirmModalHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b55dd2dba33efd74$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "p",
        xcss: $b55dd2dba33efd74$var$styles.bodyText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b55dd2dba33efd74$var$i18n.oneDriveConfirmModalText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "end",
        alignBlock: "center",
        space: "space.100",
        xcss: $b55dd2dba33efd74$var$styles.buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b55dd2dba33efd74$var$styles.frame, isIframeLoading && $b55dd2dba33efd74$var$styles.disabledFrame),
        testId: "frame-container",
        "aria-disabled": isIframeLoading
    }, !isGeminiVr && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        onLoad: handleIframeLoad,
        ref: iframeRef,
        src: ifsDirectPath,
        title: "OneDrive picker",
        height: "100%",
        width: "100%",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            border: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        "aria-hidden": "true",
        tabIndex: -1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $b55dd2dba33efd74$var$styles.primaryButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b55dd2dba33efd74$var$i18n.continueOneDriveConfirmModalButtonLabel))))));
};


















var $acRhQ = parcelRequire("acRhQ");


var $iaxSo = parcelRequire("iaxSo");

const $c0e016f17327d2c0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noAccess: {
        id: "import-from-sources.import-from-onedrive.no-access",
        defaultMessage: "We couldn\u2019t open the file"
    },
    noPermissions: {
        id: "import-from-sources.import-from-onedrive.no-permission",
        defaultMessage: "You may not have permission to access the file, or the file may not exist anymore."
    },
    noAccessCommon: {
        id: "import-from-sources.import-from-onedrive.noAccessCommon",
        defaultMessage: "One or more of the files couldn\u2019t be opened"
    },
    noPermissionsCommon: {
        id: "import-from-sources.import-from-onedrive.noPermissionsCommon",
        defaultMessage: "You may not have permission to access the files, or they may not exist anymore."
    }
});
const $c0e016f17327d2c0$export$468e6d9d28a5eb22 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { onSubmit: onSubmit, onClose: onClose } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "office365PermissionWarningModal",
                    action: "dismissed",
                    actionSubject: "button",
                    actionSubjectId: "closeWarningModal"
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const handleCloseClick = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== onSubmit) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "office365PermissionWarningModal",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "office365selectDifferentDoc"
                }
            }).fire();
            onSubmit();
        };
        $[3] = createAnalyticsEvent;
        $[4] = onSubmit;
        $[5] = t2;
    } else t2 = $[5];
    const handleSubmitClick = t2;
    let t3;
    let t4;
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c0e016f17327d2c0$export$a7357cdd1f0b0168.noAccessCommon);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c0e016f17327d2c0$export$a7357cdd1f0b0168.noPermissionsCommon);
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iaxSo.i18n).tryDifferentDocumentsUploadErrorPopupButton);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else {
        t3 = $[6];
        t4 = $[7];
        t5 = $[8];
    }
    let t6;
    if ($[9] !== handleCloseClick || $[10] !== handleSubmitClick) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
            onSubmit: handleSubmitClick,
            onClose: handleCloseClick,
            headText: t3,
            bodyText: t4,
            submitText: t5
        });
        $[9] = handleCloseClick;
        $[10] = handleSubmitClick;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ onSubmit: onSubmit, onClose: onClose })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleCloseClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'office365PermissionWarningModal',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'closeWarningModal'
            }
        }).fire();
        onClose();
    };
    const handleSubmitClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'office365PermissionWarningModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'office365selectDifferentDoc'
            }
        }).fire();
        onSubmit();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
        onSubmit: handleSubmitClick,
        onClose: handleCloseClick,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c0e016f17327d2c0$export$a7357cdd1f0b0168.noAccessCommon),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c0e016f17327d2c0$export$a7357cdd1f0b0168.noPermissionsCommon),
        submitText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iaxSo.i18n).tryDifferentDocumentsUploadErrorPopupButton)
    });
};


const $8c311127f1973a7e$var$useImportSourceParam = (0, $dPJCf.createSingleQueryParamHook)('importSource');
const $8c311127f1973a7e$var$pressableStyles = {
    root: "_0KLXru66of _39xV02N91d"
};
var $8c311127f1973a7e$export$ac5355e0d22c18d7 = /*#__PURE__*/ function(OneDriveModals) {
    OneDriveModals["NO_ACCESS"] = "NO_ACCESS";
    OneDriveModals["CONFIRM"] = "CONFIRM";
    return OneDriveModals;
}({});
const $8c311127f1973a7e$export$fa9cabb8106f3a7d = ({ onDocumentSelect: onDocumentSelect, onStartStrategy: onStartStrategy, onDocumentSelectError: onDocumentSelectError, registerTrigger: registerTrigger, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { closeModal: closeImportModal, docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { modalStack: OneDriveModalStack, showModal: showOneDriveModal, closeModal: closeOneDriveModal } = (0, $bGxBv.useModals)();
    const fileSizeCheck = (0, $8ARcf.useFileSizeCheck)();
    const oneDrivePicker = (0, $cozmU.useRef)(null);
    const confirmModalWrapper = (0, $cozmU.useRef)(null);
    const pickDocument = ()=>{
        showOneDriveModal("CONFIRM");
    };
    const handlePickerIframeLoad = async (iframeRef, modalWrapperNode)=>{
        //in case of reloading the Iframe manually, unmount the previous listeners
        oneDrivePicker.current?.unmount();
        let clientId; // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        if ((0, $9wGTI.fg)('cc_feature_discovery_ifs_fe')) try {
            const result = await (0, $f7B1p.cfetch)(`/wiki/rest/internals/1.0/word-doc/get-onedrive-secrets?secretType=CLIENT_ID`).then((res)=>res.json()); // fetch and store appId and apiKey (for upload)
            if (result) clientId = result.oneDriveClientId;
        } catch (err) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'office365Picker',
                    action: 'fetch',
                    actionSubject: 'office365Secrets',
                    attributes: {
                        errMessage: err.message
                    }
                }
            }).fire();
            return false;
        }
        oneDrivePicker.current = new (0, $293c7da1d374b695$export$5966f623d01a4ea5)({
            multiSelect: true,
            iframe: iframeRef.current,
            onIframeClick: handlePickerResponse,
            microsoftClientId: clientId
        }).init();
        confirmModalWrapper.current = modalWrapperNode;
        return true;
    };
    const closeConfirmModalAndUmountPicker = ()=>{
        // the order is important. Unmount the picker first to send the event to the iframe inside the modal
        // and then close the modal
        // the use case https://hello.atlassian.net/wiki/spaces/CCECO/pages/1277983936/IFS+office+365+Use+cases#link_to_closing_picker
        oneDrivePicker.current?.unmount();
        setTimeout(()=>{
            closeOneDriveModal("CONFIRM");
        }, 100);
    };
    const sendPickerCancelEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'office365Picker',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'office365PickerClose'
            }
        }).fire();
    };
    const sendPickerSelectEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'office365Picker',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'office365PickerSelect'
            }
        }).fire();
    };
    const makeConfirmModalTransparent = ()=>{
        //we have to make the OneDriveConfirmModal transparent (but not close it) while the file picker is opened
        // because if we close the modal, the iframe which contains the file picker will be deleted from the page
        // and we won't receive the messages from the iframe
        //since there's no normal way to set the styles of the modal backdrop, we use the data-testid attribute to get the node
        // When the picker was launched from an inline overlay there is no modal to hide.
        if (confirmModalWrapper.current) confirmModalWrapper.current.style.opacity = '0';
    };
    const validateSingleUploadBeforeProgress = async (documents)=>{
        if (!fileSizeCheck(documents[0])) return false;
        return documents;
    };
    const handlePickerResponse = async (filesPromise)=>{
        makeConfirmModalTransparent();
        try {
            const selectedDocuments = await filesPromise;
            closeConfirmModalAndUmountPicker(); //the picker cancelled
            if (!selectedDocuments) {
                sendPickerCancelEvent();
                return false;
            }
            sendPickerSelectEvent();
            onDocumentSelect(selectedDocuments);
        } catch (e) {
            closeConfirmModalAndUmountPicker();
            closeImportModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            if (e.status === (0, $3239d32085437ca5$export$94c0d1c674a48872).NO_ACCESS) {
                showOneDriveModal("NO_ACCESS");
                return;
            }
            onDocumentSelectError();
        }
    };
    const exportFromMicrosoftGraph = async (doc, isBulkUpload)=>{
        try {
            return await oneDrivePicker.current.exportFromMicrosoftGraph(doc);
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'office365Picker',
                    action: 'export',
                    actionSubject: 'office365Documents',
                    attributes: {
                        errMessage: error.message,
                        isBulkUpload: isBulkUpload
                    }
                }
            }).fire();
            if (!isBulkUpload) {
                onDocumentSelectError();
                return null;
            } else {
                uploadDocFailure(doc.name, {
                    type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return null;
            }
        }
    };
    const closeModalAndSelectFile = (modalType)=>{
        closeOneDriveModal(modalType);
        pickDocument();
    }; //TODO: create base strategy component and remove the duplication
    //due to stale closure we have to keep the props in a ref, so the methods are always up to date after rerender
    // another approach is to move ImportContextStrategy into every strategy and extend it with the props.
    const strategyProps = {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_ONE_DRIVE,
        folderName: formatMessage((0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_ONE_DRIVE]),
        pickDocument: pickDocument,
        exportFile: exportFromMicrosoftGraph,
        validateSingleUploadBeforeProgress: validateSingleUploadBeforeProgress
    };
    const strategyPropsRef = (0, $cozmU.useRef)(strategyProps);
    strategyPropsRef.current = strategyProps;
    const importSourceParam = $8c311127f1973a7e$var$useImportSourceParam();
    const { isEnabled: isExperimentEnabled } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    (0, $cozmU.useEffect)(()=>{
        // Auto-trigger OneDrive import when the user arrives via the onboarding Import CTA
        // with importSource=office365Doc in the URL (set by FooterCreateButtons → createPageContent).
        // Guard with the experiment hook so this only fires for users enrolled in the experiment.
        if (importSourceParam === (0, $dUJl3.ActiveImports).IMPORT_FROM_ONE_DRIVE && isExperimentEnabled) onStartStrategy(strategyPropsRef);
         // Run once on mount — importSourceParam is a stable query-param value
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleStrategyClick = async ()=>{
        onStartStrategy(strategyPropsRef);
    }; // Expose the same entry point the card's onItemClick uses, so consumers that render
    // their own trigger (e.g. the onboarding CTA dropdown) can start the import without
    // this component owning the clickable element.
    (0, $cozmU.useEffect)(()=>{
        registerTrigger?.({
            start: ()=>onStartStrategy(strategyPropsRef)
        });
    }, [
        registerTrigger,
        onStartStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, OneDriveModalStack["NO_ACCESS"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0e016f17327d2c0$export$468e6d9d28a5eb22), {
        onClose: ()=>closeOneDriveModal("NO_ACCESS"),
        onSubmit: ()=>closeModalAndSelectFile("NO_ACCESS")
    }), OneDriveModalStack["CONFIRM"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b55dd2dba33efd74$export$da95c48dd722cf8), {
        onIframeLoad: handlePickerIframeLoad,
        onClose: closeConfirmModalAndUmountPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $8c311127f1973a7e$var$pressableStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        ...children.props,
        onItemClick: (data)=>{
            handleStrategyClick();
            const originalOnItemClick = children.props.onItemClick;
            if (originalOnItemClick) originalOnItemClick(data);
        }
    })));
};












var $ds37j = parcelRequire("ds37j");

















var $k91X3 = parcelRequire("k91X3");

const $d3dec4d743db592d$var$assertFolderResolutionEnabled = ()=>{
    if (!(0, $6mKj3.expValEquals)('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true)) throw new (0, $k91X3.MarkdownImportError)('experiment_disabled');
};
const $d3dec4d743db592d$var$assertNotAborted = (signal)=>{
    if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)('aborted');
};
const $d3dec4d743db592d$var$escapeCqlString = (value)=>value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
const $d3dec4d743db592d$export$68a1e76617944147 = async ({ spaceKey: spaceKey, title: title, signal: signal })=>{
    try {
        $d3dec4d743db592d$var$assertNotAborted(signal);
        $d3dec4d743db592d$var$assertFolderResolutionEnabled();
        const cql = `space = "${$d3dec4d743db592d$var$escapeCqlString(spaceKey)}" AND title ~ "${$d3dec4d743db592d$var$escapeCqlString(title)}"`;
        const searchParams = new URLSearchParams({
            cql: cql,
            limit: '50'
        });
        const response = await (0, $f7B1p.cfetch)(`/wiki/rest/api/search?${searchParams.toString()}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            },
            signal: signal
        });
        const searchResult = await response.json();
        $d3dec4d743db592d$var$assertNotAborted(signal);
        const results = searchResult.results ?? [];
        const matchingFolders = results.filter(({ breadcrumbs: breadcrumbs, content: content })=>{
            return content?.type === 'folder' && content.title === title && Array.isArray(breadcrumbs) && breadcrumbs.length === 0 && typeof content.id === 'string';
        });
        const existingFolderId = matchingFolders[0]?.content?.id;
        const isTruncated = typeof searchResult.totalSize === 'number' && searchResult.totalSize > results.length;
        if (!existingFolderId && isTruncated) throw new Error('Folder search results were truncated before an exact root folder match could be confirmed');
        return existingFolderId;
    } catch (error) {
        if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)('aborted');
        throw error;
    }
};
const $d3dec4d743db592d$export$1fcdbeae515a20e3 = async ({ spaceId: spaceId, title: title, signal: signal })=>{
    try {
        $d3dec4d743db592d$var$assertNotAborted(signal);
        if (!/^\d+$/.test(spaceId)) throw new (0, $k91X3.MarkdownImportError)('invalid_destination');
        $d3dec4d743db592d$var$assertFolderResolutionEnabled();
        const response = await (0, $f7B1p.cfetch)('/wiki/api/v2/folders', {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                spaceId: spaceId,
                title: title
            }),
            signal: signal
        });
        const folder = await response.json();
        $d3dec4d743db592d$var$assertNotAborted(signal);
        if (!folder.id) throw new Error('The create folder response did not contain an ID');
        return folder.id;
    } catch (error) {
        if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)('aborted');
        throw error;
    }
};





const $e43b50ae6dc26ed3$export$c4e886952ea2143c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return $e43b50ae6dc26ed3$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)(async ({ spaceId: spaceId, spaceKey: spaceKey, folderName: folderName, signal: signal })=>{
        if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)('aborted');
        if (!(0, $6mKj3.expValEquals)('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true)) throw new (0, $k91X3.MarkdownImportError)('experiment_disabled');
        const existingFolderId = await (0, $d3dec4d743db592d$export$68a1e76617944147)({
            spaceKey: spaceKey,
            title: folderName,
            signal: signal
        });
        if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)('aborted');
        if (existingFolderId) return existingFolderId;
        return (0, $d3dec4d743db592d$export$1fcdbeae515a20e3)({
            spaceId: spaceId,
            title: folderName,
            signal: signal
        });
    }, []);
};
async function $e43b50ae6dc26ed3$var$_temp(t0) {
    const { spaceId: spaceId, spaceKey: spaceKey, folderName: folderName, signal: signal } = t0;
    if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)("aborted");
    if (!(0, $6mKj3.expValEquals)("twcg_2627_markdown_file_import_into_confluence", "isEnabled", true)) throw new (0, $k91X3.MarkdownImportError)("experiment_disabled");
    const existingFolderId = await (0, $d3dec4d743db592d$export$68a1e76617944147)({
        spaceKey: spaceKey,
        title: folderName,
        signal: signal
    });
    if (signal.aborted) throw new (0, $k91X3.MarkdownImportError)("aborted");
    if (existingFolderId) return existingFolderId;
    return (0, $d3dec4d743db592d$export$1fcdbeae515a20e3)({
        spaceId: spaceId,
        title: folderName,
        signal: signal
    });
}





const $3979ee68b1996528$var$i18n = (0, $kSwu1.defineMessages)({
    fileInputLabel: {
        id: "import-from-sources.markdown.file-input.label",
        defaultMessage: "Choose Markdown files"
    },
    fallbackTitle: {
        id: "import-from-sources.markdown.fallback-title",
        defaultMessage: "Imported Markdown"
    }
});
const $3979ee68b1996528$var$createAttemptId = ()=>{
    if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID();
    if (typeof globalThis.crypto?.getRandomValues !== 'function') return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    const values = new Uint32Array(4);
    globalThis.crypto.getRandomValues(values);
    return Array.from(values, (value)=>value.toString(16).padStart(8, '0')).join('-');
};


const $3979ee68b1996528$export$d2fb2a99f80d308b = ({ onStartStrategy: onStartStrategy, onDocumentSelect: onDocumentSelect, onDocumentSelectError: onDocumentSelectError, registerTrigger: registerTrigger, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolveMarkdownFolder = (0, $e43b50ae6dc26ed3$export$c4e886952ea2143c)();
    const inputRef = (0, $cozmU.useRef)(null);
    const attemptIdByFileRef = (0, $cozmU.useRef)(new WeakMap());
    const validatedTextByFileRef = (0, $cozmU.useRef)(new WeakMap());
    const pickDocument = ()=>{
        inputRef.current?.dispatchEvent(new MouseEvent('click', {
            bubbles: false,
            cancelable: true,
            view: window
        }));
    };
    const validateMarkdownDocuments = async (documents)=>{
        const files = documents;
        const results = await Promise.all(files.map((file)=>(0, $ds37j.validateMarkdownFile)(file)));
        if (results.some((result)=>!result.ok)) {
            onDocumentSelectError();
            return false;
        }
        results.forEach((result_0)=>{
            if (result_0.ok) validatedTextByFileRef.current.set(result_0.file, result_0.text);
        });
        return files;
    };
    const folderName = formatMessage((0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_MARKDOWN]);
    const strategy = {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_MARKDOWN,
        folderName: folderName,
        pickDocument: pickDocument,
        createsSeparatePage: true,
        bulkImportMode: 'independent-pages',
        validateSingleUploadBeforeProgress: validateMarkdownDocuments,
        validateBulkUploadBeforeProgress: validateMarkdownDocuments,
        validateBulkBeforeUpload: async (documents_0)=>{
            const files_0 = documents_0.filter((document)=>document !== null);
            return files_0.length ? files_0 : false;
        },
        resolveParentPage: ({ spaceId: spaceId, spaceKey: spaceKey, signal: signal })=>resolveMarkdownFolder({
                spaceId: spaceId,
                spaceKey: spaceKey,
                folderName: folderName,
                signal: signal
            }),
        uploadSingle: async (document_0, options)=>{
            let markdown = validatedTextByFileRef.current.get(document_0);
            validatedTextByFileRef.current.delete(document_0);
            if (markdown === undefined) {
                const validation = await (0, $ds37j.validateMarkdownFile)(document_0);
                if (!validation.ok) throw new Error(`Markdown validation failed: ${validation.errorCode}`);
                markdown = validation.text;
            }
            const { convertMarkdownToAdf: convertMarkdownToAdf } = await (parcelRequire("4THDy"));
            const conversion = await convertMarkdownToAdf({
                markdown: markdown,
                fileName: document_0.name,
                fallbackTitle: formatMessage($3979ee68b1996528$var$i18n.fallbackTitle),
                signal: options.signal
            });
            const { createMarkdownDraft: createMarkdownDraft } = await Promise.resolve((parcelRequire("k91X3")));
            const data = await createMarkdownDraft({
                spaceId: options.spaceId,
                spaceKey: options.spaceKey,
                parentPageId: options.parentPageId,
                title: conversion.title,
                adf: conversion.adf,
                subtype: 'live',
                attemptId: attemptIdByFileRef.current.get(document_0) ?? $3979ee68b1996528$var$createAttemptId(),
                signal: options.signal,
                onCreateDispatch: options.onCreateDispatch
            });
            return {
                data: data,
                warnings: conversion.warnings
            };
        }
    };
    const strategyRef = (0, $cozmU.useRef)(strategy);
    strategyRef.current = strategy;
    const start = (0, $cozmU.useCallback)(()=>onStartStrategy(strategyRef), [
        onStartStrategy
    ]);
    (0, $cozmU.useEffect)(()=>{
        registerTrigger?.({
            start: start
        });
    }, [
        registerTrigger,
        start
    ]);
    const handleFileChange = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        const files_1 = Array.from(event.target.files ?? []);
        event.target.value = '';
        if (files_1.length > 0) {
            files_1.forEach((file_0)=>attemptIdByFileRef.current.set(file_0, $3979ee68b1996528$var$createAttemptId()));
            onDocumentSelect(files_1);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        ref: inputRef,
        type: "file",
        accept: ".md,.markdown,.mdown",
        "aria-label": formatMessage($3979ee68b1996528$var$i18n.fileInputLabel),
        multiple: true,
        onChange: handleFileChange,
        "data-testid": "import-from-markdown-frontend-file-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(children, {
        ...children.props,
        onItemClick: (data_0)=>{
            start();
            children.props.onItemClick?.(data_0);
        },
        onClick: (event_0)=>{
            start();
            children.props.onClick?.(event_0);
        }
    }));
};





const $2dae960ebe3e6ff3$var$i18n = (0, $kSwu1.defineMessages)({
    oneDriveSourcesListCardDataName: {
        id: "import-from-sources.sources-list.oneDriveSourcesListCardDataName",
        defaultMessage: "OneDrive"
    },
    msWordSourcesCardDataName: {
        id: "import-from-sources.sources-list.msWordCardDataName",
        defaultMessage: "Microsoft Word"
    },
    gdocSourcesCardDataName: {
        id: "import-from-sources.sources-list.gdocCardDataName",
        defaultMessage: "Google Docs"
    },
    markdownSourcesCardDataName: {
        id: "import-from-sources.sources-list.markdownCardDataName",
        defaultMessage: "Markdown"
    },
    markdownSourcesCardStatus: {
        id: "import-from-sources.sources-list.markdownCardStatus",
        defaultMessage: "TRY"
    }
});
const $2dae960ebe3e6ff3$export$6a5ec53f59b5b960 = {
    key: (0, $dUJl3.ActiveImports).IMPORT_FROM_MARKDOWN,
    folderName: (0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_MARKDOWN],
    component: (0, $3979ee68b1996528$export$d2fb2a99f80d308b),
    card: {
        name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2dae960ebe3e6ff3$var$i18n.markdownSourcesCardDataName),
        iconURL: '',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2jY8x))), {
            label: "",
            size: "medium"
        }),
        status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2dae960ebe3e6ff3$var$i18n.markdownSourcesCardStatus)
    }
};
const $2dae960ebe3e6ff3$export$7b07b76eacbbb7eb = [
    {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_LOCAL,
        folderName: (0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_LOCAL],
        component: (0, $bb011addc13fe4ae$export$e1ff9184b37d2a0d),
        card: {
            name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2dae960ebe3e6ff3$var$i18n.msWordSourcesCardDataName),
            iconURL: (0, (/*@__PURE__*/$parcel$interopDefault($e73dbccb32a0cdf7$exports)))
        }
    },
    {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_GD,
        folderName: (0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_GD],
        component: (0, $d759c9c40647c36b$export$cce50c292925c71b),
        card: {
            name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2dae960ebe3e6ff3$var$i18n.gdocSourcesCardDataName),
            iconURL: (0, (/*@__PURE__*/$parcel$interopDefault($0c84c24c7b90e233$exports)))
        }
    },
    {
        key: (0, $dUJl3.ActiveImports).IMPORT_FROM_ONE_DRIVE,
        folderName: (0, $dUJl3.IMPORT_FOLDER_NAMES)[(0, $dUJl3.ActiveImports).IMPORT_FROM_ONE_DRIVE],
        component: (0, $8c311127f1973a7e$export$fa9cabb8106f3a7d),
        card: {
            name: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2dae960ebe3e6ff3$var$i18n.oneDriveSourcesListCardDataName),
            iconURL: (0, (/*@__PURE__*/$parcel$interopDefault($f1d9a311771e5602$exports)))
        }
    }
];
module.exports["MARKDOWN_IMPORT_STRATEGY"] = $2dae960ebe3e6ff3$export$6a5ec53f59b5b960;
module.exports["IMPORT_STRATEGIES"] = $2dae960ebe3e6ff3$export$7b07b76eacbbb7eb;

});

parcelRegister("ds37j", function(module, exports) {
const $937b358178451b1a$export$6d8d1d48e9e65a20 = 5242880;
const $937b358178451b1a$var$SUPPORTED_MARKDOWN_EXTENSION = /\.(?:md|markdown|mdown)$/i;
const $937b358178451b1a$var$MINIMUM_BINARY_CONTROL_CHARACTERS = 3;
const $937b358178451b1a$var$BINARY_CONTROL_CHARACTER_RATIO = 0.3;
const $937b358178451b1a$var$validationError = (errorCode)=>({
        ok: false,
        errorCode: errorCode
    });
const $937b358178451b1a$var$readFileAsArrayBuffer = (file)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = ()=>reject(reader.error);
        reader.onload = ()=>{
            if (reader.result instanceof ArrayBuffer) {
                resolve(reader.result);
                return;
            }
            reject(new Error('Markdown file could not be read as binary data'));
        };
        reader.readAsArrayBuffer(file);
    });
const $937b358178451b1a$var$isBinaryText = (text)=>{
    let controlCharacterCount = 0;
    for(let index = 0; index < text.length; index++){
        const code = text.charCodeAt(index);
        const isDisallowedControlCharacter = code >= 0x01 && code <= 0x08 || code === 0x0b || code === 0x0c || code >= 0x0e && code <= 0x1f || code === 0x7f;
        if (isDisallowedControlCharacter) controlCharacterCount++;
    }
    return controlCharacterCount >= $937b358178451b1a$var$MINIMUM_BINARY_CONTROL_CHARACTERS && controlCharacterCount / text.length >= $937b358178451b1a$var$BINARY_CONTROL_CHARACTER_RATIO;
};
const $937b358178451b1a$export$bad5f816adc0924e = async (file)=>{
    if (!$937b358178451b1a$var$SUPPORTED_MARKDOWN_EXTENSION.test(file.name)) return $937b358178451b1a$var$validationError('unsupported_extension');
    if (file.size > $937b358178451b1a$export$6d8d1d48e9e65a20) return $937b358178451b1a$var$validationError('file_too_large');
    let bytes;
    try {
        bytes = await $937b358178451b1a$var$readFileAsArrayBuffer(file);
    } catch  {
        return $937b358178451b1a$var$validationError('read_failed');
    }
    let text;
    try {
        text = new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes);
    } catch  {
        return $937b358178451b1a$var$validationError('invalid_utf8');
    }
    if (text.includes('\0')) return $937b358178451b1a$var$validationError('nul_byte');
    if (text.trim().length === 0) return $937b358178451b1a$var$validationError('empty_content');
    if ($937b358178451b1a$var$isBinaryText(text)) return $937b358178451b1a$var$validationError('binary_content');
    return {
        ok: true,
        file: file,
        text: text
    };
};
module.exports["MARKDOWN_SOURCE_SIZE_LIMIT_BYTES"] = $937b358178451b1a$export$6d8d1d48e9e65a20;
module.exports["validateMarkdownFile"] = $937b358178451b1a$export$bad5f816adc0924e;

});

parcelRegister("k91X3", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $6mKj3 = parcelRequire("6mKj3");

const $34515d42f4be902b$var$MAX_PAGE_TITLE_LENGTH = 255;
const $34515d42f4be902b$var$TITLE_CONFLICT_STATUSES = new Set([
    400,
    409
]);
const $34515d42f4be902b$var$TITLE_CONFLICT_MESSAGES = [
    'a page with this title already exists',
    'exists with the same title in this space'
];
class $34515d42f4be902b$export$804c26cfbd3ae968 extends Error {
    constructor(code, options = {}){
        super(code, options.cause === undefined ? undefined : {
            cause: options.cause
        }), this.code = code;
        this.name = 'MarkdownImportError';
        this.status = void 0;
        this.attemptId = void 0;
        this.status = options.status;
        this.attemptId = options.attemptId;
    }
}
const $34515d42f4be902b$var$normalizeResponse = (response, input)=>{
    if (!response.id || !response.title) throw new Error('The create page response did not contain an ID and title');
    return {
        id: response.id,
        title: response.title,
        subType: response.subtype ?? input.subtype,
        space: {
            id: response.spaceId ?? input.spaceId,
            key: input.spaceKey
        },
        _links: {
            context: '',
            editui: response._links?.editui ?? response._links?.edituiv2 ?? ''
        }
    };
};
const $34515d42f4be902b$var$createTimestampedTitle = (title, now = new Date())=>{
    const timestamp = now.toISOString().slice(0, 19).replace('T', ' ');
    const suffix = ` ${timestamp}`;
    return `${title.slice(0, $34515d42f4be902b$var$MAX_PAGE_TITLE_LENGTH - suffix.length)}${suffix}`;
};
const $34515d42f4be902b$var$isTitleConflictError = async (error)=>{
    if (!$34515d42f4be902b$var$TITLE_CONFLICT_STATUSES.has(error.response.status)) return false;
    try {
        const responseBody = (await error.response.clone().text()).toLowerCase();
        return $34515d42f4be902b$var$TITLE_CONFLICT_MESSAGES.some((message)=>responseBody.includes(message));
    } catch  {
        return false;
    }
};
const $34515d42f4be902b$var$throwMarkdownImportError = (error, attemptId)=>{
    if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) throw new $34515d42f4be902b$export$804c26cfbd3ae968('http_error', {
        status: error.response.status,
        cause: error
    });
    throw new $34515d42f4be902b$export$804c26cfbd3ae968('outcome_unknown', {
        attemptId: attemptId,
        cause: error
    });
};
const $34515d42f4be902b$export$9c15a580022584f8 = async (input)=>{
    if (input.signal.aborted) throw new $34515d42f4be902b$export$804c26cfbd3ae968('aborted');
    if (!/^\d+$/.test(input.spaceId)) throw new $34515d42f4be902b$export$804c26cfbd3ae968('invalid_destination');
    if (!(0, $6mKj3.expValEquals)('twcg_2627_markdown_file_import_into_confluence', 'isEnabled', true)) throw new $34515d42f4be902b$export$804c26cfbd3ae968('experiment_disabled');
    const url = input.parentPageId ? '/wiki/api/v2/pages' : '/wiki/api/v2/pages?root-level=true';
    const createPage = async (title)=>{
        const response = await (0, $f7B1p.cfetch)(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                spaceId: input.spaceId,
                ...input.parentPageId ? {
                    parentId: input.parentPageId
                } : {},
                status: 'draft',
                subtype: input.subtype,
                title: title,
                body: {
                    representation: 'atlas_doc_format',
                    value: JSON.stringify(input.adf)
                }
            }),
            signal: input.signal
        });
        return $34515d42f4be902b$var$normalizeResponse(await response.json(), input);
    };
    input.onCreateDispatch();
    try {
        return await createPage(input.title);
    } catch (error) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && await $34515d42f4be902b$var$isTitleConflictError(error)) try {
            return await createPage($34515d42f4be902b$var$createTimestampedTitle(input.title));
        } catch (retryError) {
            return $34515d42f4be902b$var$throwMarkdownImportError(retryError, input.attemptId);
        }
        return $34515d42f4be902b$var$throwMarkdownImportError(error, input.attemptId);
    }
};
module.exports["MarkdownImportError"] = $34515d42f4be902b$export$804c26cfbd3ae968;
module.exports["createMarkdownDraft"] = $34515d42f4be902b$export$9c15a580022584f8;

});

parcelRegister("4THDy", function(module, exports) {

let $390e25e133456abb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $390e25e133456abb$var$load("kozF6").then(()=>parcelRequire('iDdtV'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("hPpKm", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");


var $ix5ga = parcelRequire("ix5ga");

const $27bc3d6341d74652$export$885b4341e7c3daaa = (documents)=>documents.length > 1;












var $dPJCf = parcelRequire("dPJCf");


var $dw6y2 = parcelRequire("dw6y2");

const $40054d1753472ec4$export$740648e9e1f317ac = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (pageData)=>{
            if (!pageData) return;
            const importedPageUrl = (0, $dw6y2.createEditDraftPageUrl)(pageData);
            push(`${importedPageUrl}${importedPageUrl.includes("?") ? "&" : "?"}importSurvey=true`);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $cozmU.useCallback)((pageData)=>{
        if (!pageData) return;
        const importedPageUrl = (0, $dw6y2.createEditDraftPageUrl)(pageData);
        push(`${importedPageUrl}${importedPageUrl.includes('?') ? '&' : '?'}importSurvey=true`);
    }, [
        push
    ]);
};



var $f7B1p = parcelRequire("f7B1p");


var $7twp9 = parcelRequire("7twp9");


var $hTMqv = parcelRequire("hTMqv");

const $fdac6c26a59eb2dd$export$652bca884c5df689 = (response)=>{
    return response.json();
};
const $fdac6c26a59eb2dd$export$b6975c476b7eccc7 = (url, options)=>(0, $7twp9.cfetchWithAbort)(url, options).then($fdac6c26a59eb2dd$export$652bca884c5df689);
function $fdac6c26a59eb2dd$export$f955ae403ee4069a() {
    return window.location.hostname === 'localhost' ? $fdac6c26a59eb2dd$var$getLocalhostBackendUrl() : window.location.origin;
}
function $fdac6c26a59eb2dd$var$getLocalhostBackendUrl() {
    return window.__backendOriginHost ? `https://${window.__backendOriginHost}` : 'https://pug.jira-dev.com';
}
async function $fdac6c26a59eb2dd$var$getCSRFToken() {
    const result = await $fdac6c26a59eb2dd$export$b6975c476b7eccc7(`${(0, $hTMqv.IFS_API)}/csrf-token`, {
        credentials: 'include'
    });
    return result?.csrfToken;
}
async function $fdac6c26a59eb2dd$export$a5575dbeeffdad98(options) {
    const { signal: signal } = options;
    delete options.signal; //remove not needed field in the body
    const formData = new FormData();
    Object.keys(options).forEach((key)=>{
        if (options[key]) {
            // Update subType when uploading to new API
            if (key === 'subType') options[key] = options[key].toUpperCase();
            formData.append(key, options[key]);
        }
    });
    formData.append('apiUrl', $fdac6c26a59eb2dd$export$f955ae403ee4069a());
    return $fdac6c26a59eb2dd$export$b6975c476b7eccc7('/wiki/rest/internals/1.0/word-doc/upload', {
        method: 'POST',
        credentials: 'include',
        signal: signal,
        body: formData
    });
}
async function $fdac6c26a59eb2dd$var$executeDelete(queryParams, endpoint) {
    const stringifiedQueryParams = new URLSearchParams({
        apiUrl: $fdac6c26a59eb2dd$export$f955ae403ee4069a(),
        ...queryParams
    }).toString();
    const csrfToken = await $fdac6c26a59eb2dd$var$getCSRFToken();
    const res = await (0, $f7B1p.cfetch)(`${(0, $hTMqv.IFS_API)}/${endpoint}?${stringifiedQueryParams}`, {
        method: 'delete',
        headers: {
            'csrf-token': csrfToken
        }
    });
    return res.json();
}
async function $fdac6c26a59eb2dd$export$2e9858c25869c949(contentId, params = {}) {
    await $fdac6c26a59eb2dd$var$executeDelete({
        contentId: contentId,
        ...params
    }, 'discard');
}
async function $fdac6c26a59eb2dd$export$8469d33cda4a42e2(parentPageId, params = {}) {
    await $fdac6c26a59eb2dd$var$executeDelete({
        parentPageId: parentPageId,
        ...params
    }, 'discard-bulk-pages');
}
async function $fdac6c26a59eb2dd$export$e27fe4356d25ad56(space, parentPageId, restriction, subType, pageTitle, createAsFolder) {
    const body = {
        space: space,
        parentPageId: parentPageId ? Number(parentPageId) : null,
        apiUrl: $fdac6c26a59eb2dd$export$f955ae403ee4069a(),
        restriction: restriction,
        ...subType ? {
            subType: subType
        } : {},
        ...pageTitle ? {
            pageTitle: pageTitle
        } : {},
        ...createAsFolder ? {
            createAsFolder: true
        } : {}
    };
    // During migration, expected parameters for the BE were updated to upper case
    if (body.subType === 'live') body.subType = 'LIVE';
    // Matches parentPageTypes
    body.restriction = restriction.toUpperCase();
    const result = await (0, $f7B1p.cfetch)('/wiki/rest/internals/1.0/word-doc/create-parent-page', {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return result.json();
}
function $fdac6c26a59eb2dd$export$e443105147d5115a(contentId) {
    return $fdac6c26a59eb2dd$export$b6975c476b7eccc7(`/wiki/rest/api/content/${contentId}?status=draft&expand=metadata.properties.originalDraftId`);
}


async function $d7928fb9aa00f145$export$a84f95519fdfe50e({ document: document, pageTitle: pageTitle, space: space, parentPageId: parentPageId, importSource: importSource, isDraftDiscard: isDraftDiscard, contentId: contentId, isBulkUpload: isBulkUpload, signal: signal, subType: subType }) {
    const uploadOptions = {
        document: document,
        pageTitle: pageTitle,
        importSource: importSource,
        space: space,
        parentPageId: parentPageId,
        isBulkUpload: isBulkUpload,
        signal: signal,
        subType: subType
    };
    if (isDraftDiscard) {
        const { metadata: metadata } = await (0, $fdac6c26a59eb2dd$export$e443105147d5115a)(contentId);
        uploadOptions.originalDraftId = metadata.properties.hasOwnProperty('originalDraftId') ? metadata.properties.originalDraftId.value : contentId;
    }
    return (0, $fdac6c26a59eb2dd$export$a5575dbeeffdad98)(uploadOptions);
}



var $k7Q8j = parcelRequire("k7Q8j");













const $e59673e9ec04ccad$export$6c54cc766c157eef = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (pageData)=>{
            if (!pageData) return;
            push(`/wiki/spaces/${pageData.space}/pages/${pageData.id}`);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $cozmU.useCallback)((pageData)=>{
        if (!pageData) return;
        push(`/wiki/spaces/${pageData.space}/pages/${pageData.id}`);
    }, [
        push
    ]);
};








/**
 * @generated SignedSource<<18f83d90d08d35826622988187c162f8>>
 * @relayHash d0a86cdbb584e4c3956f1dbc3faee88b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e39e53b6f62a16b044476f6392f68b0779e61b0127b5cbd6694fa4524c80a32e
const $b75c70034d5c1d96$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "wasDeleted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useHandleDeleteCreatedDraftMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useHandleDeleteCreatedDraftMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "d0a86cdbb584e4c3956f1dbc3faee88b",
            "id": "e39e53b6f62a16b044476f6392f68b0779e61b0127b5cbd6694fa4524c80a32e",
            "metadata": {},
            "name": "useHandleDeleteCreatedDraftMutation",
            "operationKind": "mutation",
            "text": "mutation useHandleDeleteCreatedDraftMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
        }
    };
}();
$b75c70034d5c1d96$var$node.hash = "ce0469fb9474cc179bf4a91e6558aa3b";
var $b75c70034d5c1d96$export$2e2bcd8739ae039 = $b75c70034d5c1d96$var$node;






var $308Wd = parcelRequire("308Wd");

var $355bf0f849b3d686$export$e0db935847b66dda = /*#__PURE__*/ function(ContentDeleteActionType) {
    ContentDeleteActionType["DELETE_DRAFT"] = "DELETE_DRAFT";
    ContentDeleteActionType["DELETE_DRAFT_IF_BLANK"] = "DELETE_DRAFT_IF_BLANK";
    ContentDeleteActionType["MOVE_TO_TRASH"] = "MOVE_TO_TRASH";
    ContentDeleteActionType["PURGE_FROM_TRASH"] = "PURGE_FROM_TRASH";
    return ContentDeleteActionType;
}({});


const $b2241accc91c4476$export$d012c53dc024cf12 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { createdDraftId: createdDraftId, setCreatedDraftId: setCreatedDraftId, isCreatingDraftCancelled: isCreatingDraftCancelled, setIsCreatingDraftCancelled: setIsCreatingDraftCancelled, subType: subType } = t0;
    const [deleteContentMutation] = (0, $308Wd.useMutationInterop)((0, $b75c70034d5c1d96$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    let t1;
    if ($[0] !== createdDraftId || $[1] !== deleteContentMutation || $[2] !== isCreatingDraftCancelled || $[3] !== setCreatedDraftId || $[4] !== setIsCreatingDraftCancelled) {
        t1 = ()=>{
            if (createdDraftId && isCreatingDraftCancelled) {
                const executeDeleteDraft = async ()=>{
                    try {
                        setCreatedDraftId(null);
                        setIsCreatingDraftCancelled(false);
                        await deleteContentMutation({
                            variables: {
                                contentId: createdDraftId,
                                action: (0, $355bf0f849b3d686$export$e0db935847b66dda).DELETE_DRAFT
                            }
                        });
                    } catch (t2) {
                        const e = t2;
                        return e;
                    }
                };
                executeDeleteDraft();
            }
        };
        $[0] = createdDraftId;
        $[1] = deleteContentMutation;
        $[2] = isCreatingDraftCancelled;
        $[3] = setCreatedDraftId;
        $[4] = setIsCreatingDraftCancelled;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== createdDraftId || $[7] !== deleteContentMutation || $[8] !== isCreatingDraftCancelled || $[9] !== setCreatedDraftId || $[10] !== setIsCreatingDraftCancelled || $[11] !== subType) {
        t2 = [
            createdDraftId,
            setCreatedDraftId,
            isCreatingDraftCancelled,
            setIsCreatingDraftCancelled,
            subType,
            deleteContentMutation
        ];
        $[6] = createdDraftId;
        $[7] = deleteContentMutation;
        $[8] = isCreatingDraftCancelled;
        $[9] = setCreatedDraftId;
        $[10] = setIsCreatingDraftCancelled;
        $[11] = subType;
        $[12] = t2;
    } else t2 = $[12];
    (0, $cozmU.useEffect)(t1, t2);
} : ({ createdDraftId: createdDraftId, setCreatedDraftId: setCreatedDraftId, isCreatingDraftCancelled: isCreatingDraftCancelled, setIsCreatingDraftCancelled: setIsCreatingDraftCancelled, subType: subType })=>{
    const [deleteContentMutation] = (0, $308Wd.useMutationInterop)((0, $b75c70034d5c1d96$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    (0, $cozmU.useEffect)(()=>{
        if (createdDraftId && isCreatingDraftCancelled) {
            const executeDeleteDraft = async ()=>{
                try {
                    setCreatedDraftId(null);
                    setIsCreatingDraftCancelled(false);
                    await deleteContentMutation({
                        variables: {
                            contentId: createdDraftId,
                            action: (0, $355bf0f849b3d686$export$e0db935847b66dda).DELETE_DRAFT
                        }
                    });
                } catch (e) {
                    return e;
                }
            };
            executeDeleteDraft();
        }
    }, [
        createdDraftId,
        setCreatedDraftId,
        isCreatingDraftCancelled,
        setIsCreatingDraftCancelled,
        subType,
        deleteContentMutation
    ]);
};








/**
 * @generated SignedSource<<a300c1c4fc1be24056a30d582a5ab850>>
 * @relayHash f70c9aa0babc43946b2c568d0a9868ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1195bf03ccc474c75832db70dfc053eec403b0c30d40f437cab380ae071ea7c5
const $69cb8cc2300e4865$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "wasDeleted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useHandleDeleteOnboardingBlankPageMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useHandleDeleteOnboardingBlankPageMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f70c9aa0babc43946b2c568d0a9868ee",
            "id": "1195bf03ccc474c75832db70dfc053eec403b0c30d40f437cab380ae071ea7c5",
            "metadata": {},
            "name": "useHandleDeleteOnboardingBlankPageMutation",
            "operationKind": "mutation",
            "text": "mutation useHandleDeleteOnboardingBlankPageMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
        }
    };
}();
$69cb8cc2300e4865$var$node.hash = "2499f4dc8d89b567f1c3b7e615bfe79e";
var $69cb8cc2300e4865$export$2e2bcd8739ae039 = $69cb8cc2300e4865$var$node;









const $a913192dc3627179$export$7fff445e9bc9f5c5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId)=>{
    const $ = (0, $bDgLe.c)(3);
    const [deleteContentMutation] = (0, $308Wd.useMutationInterop)((0, $69cb8cc2300e4865$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    let t0;
    if ($[0] !== contentId || $[1] !== deleteContentMutation) {
        t0 = async ()=>{
            if (!contentId) return;
            try {
                await deleteContentMutation({
                    variables: {
                        contentId: contentId,
                        action: (0, $355bf0f849b3d686$export$e0db935847b66dda).DELETE_DRAFT_IF_BLANK
                    }
                });
            } catch (t1) {
                const e = t1;
            }
        };
        $[0] = contentId;
        $[1] = deleteContentMutation;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (contentId)=>{
    const [deleteContentMutation] = (0, $308Wd.useMutationInterop)((0, $69cb8cc2300e4865$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    return (0, $cozmU.useCallback)(async ()=>{
        // Entry points that start an import without an existing draft (e.g. the onboarding
        // CTA in the space side navigation) have no blank page to clean up.
        if (!contentId) return;
        try {
            await deleteContentMutation({
                variables: {
                    contentId: contentId,
                    action: (0, $355bf0f849b3d686$export$e0db935847b66dda).DELETE_DRAFT_IF_BLANK
                }
            });
        } catch (e) {
        // Deletion is best-effort; don't block navigation on failure.
        }
    }, [
        contentId,
        deleteContentMutation
    ]);
};


/**
 * @generated SignedSource<<28f38b254bfe5b7db21ffc3f5c08c6fe>>
 * @relayHash 13ae8934e04da59ec0a60a5d1726c98d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b09c3842a64f05087319bb47294275ff34e28de93629240ef34276a5ff50483
const $7f4892fc402b94a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeletePagesPayload",
            "kind": "LinkedField",
            "name": "deletePages",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ImportModalsDeletePagesActionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ImportModalsDeletePagesActionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "13ae8934e04da59ec0a60a5d1726c98d",
            "id": "7b09c3842a64f05087319bb47294275ff34e28de93629240ef34276a5ff50483",
            "metadata": {},
            "name": "ImportModalsDeletePagesActionMutation",
            "operationKind": "mutation",
            "text": "mutation ImportModalsDeletePagesActionMutation($input:[DeletePagesInput]!){deletePages(input:$input){taskId,status}}"
        }
    };
}();
$7f4892fc402b94a3$var$node.hash = "7280a7bca4e27a7d55671ba8a0d07c5a";
var $7f4892fc402b94a3$export$2e2bcd8739ae039 = $7f4892fc402b94a3$var$node;
















var $r3F1B = parcelRequire("r3F1B");


var $aGMzc = parcelRequire("aGMzc");











var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $2uDbg = parcelRequire("2uDbg");





var $jhwJP = parcelRequire("jhwJP");


var $lsxnT = parcelRequire("lsxnT");

const $669df68d731a7024$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, onClose: onClose, testId: testId } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: "small",
            testId: testId
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, onClose: onClose, testId: testId })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: "small",
        testId: testId
    }, children);
};
const $669df68d731a7024$var$i18nBase = (0, $kSwu1.defineMessages)({
    cancelDiscardModalButtonLabel: {
        id: "import-from-sources.discard-modal.cancelAction",
        defaultMessage: "Cancel"
    },
    createDiscardButtonLabel: {
        id: "import-from-sources.discard-modal.createAction",
        defaultMessage: "Create"
    },
    discardDraftDiscardModalCheckboxLabel: {
        id: "import-from-sources.discard-modal.discardDraftAction",
        defaultMessage: "Discard draft"
    },
    deleteCurrentPageCheckBoxLabel: {
        id: "import-from-sources.discard-modal.live-page.discardDraftAction",
        defaultMessage: "Delete current page"
    },
    discardModalText: {
        id: "import-from-sources.discard-modal.text",
        defaultMessage: "Your new page won\u2019t include any of the content in your current draft"
    },
    discardModalForLivePageText: {
        id: "import-from-sources.discard-modal.live-page.text",
        defaultMessage: "Your new page won\u2019t include any of the content in your current page"
    },
    discardModalTitle: {
        id: "import-from-sources.discard-modal.title",
        defaultMessage: "Create a new page?"
    },
    discardModalLiveDocTitle: {
        id: "import-from-sources.discard-modal.live-doc.title",
        defaultMessage: "Create a new live doc?"
    }
});
const $669df68d731a7024$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    discardModalForLivePageText: {
        id: "import-from-sources.discard-modal.live-page.text.livedocs",
        defaultMessage: "Your new doc won\u2019t include any of the content in your current doc"
    }
});
const $669df68d731a7024$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($669df68d731a7024$var$i18nBase, $669df68d731a7024$var$i18nLiveDocs); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $669df68d731a7024$var$ModalText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1DCdHi5zaO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHi5zaO",
            __cmplp.className
        ])
    });
});
const $669df68d731a7024$export$5a1c1fd1fd0d9704 = ({ onClose: onClose, onCreate: onCreate })=>{
    const [isDraftDiscarded, setIsDraftDiscarded] = (0, $cozmU.useState)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importDiscardModal'
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const discardChangeHandler = ({ target: target })=>{
        setIsDraftDiscarded(target.checked);
    };
    const handleDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'discardModal',
                action: 'dismissed',
                actionSubject: 'modal',
                actionSubjectId: 'importDiscardModal'
            }
        }).fire();
        onClose();
    };
    const handleCancel = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'discardModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importDiscardModalCancel'
            }
        }).fire();
        onClose();
    };
    const handleCreate = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'discardModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importDiscardModalCreate'
            }
        }).fire();
        onCreate(isDraftDiscarded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($669df68d731a7024$var$ChoreographerModal, {
        onClose: handleDismiss,
        testId: "import-discard-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isLivePage ? $669df68d731a7024$var$i18n.discardModalLiveDocTitle : $669df68d731a7024$var$i18n.discardModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($669df68d731a7024$var$ModalText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isLivePage ? $669df68d731a7024$var$i18n.discardModalForLivePageText : $669df68d731a7024$var$i18n.discardModalText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isDraftDiscarded,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isLivePage ? $669df68d731a7024$var$i18n.deleteCurrentPageCheckBoxLabel : $669df68d731a7024$var$i18n.discardDraftDiscardModalCheckboxLabel),
        onChange: discardChangeHandler
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel,
        testId: "discard-modal-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $669df68d731a7024$var$i18n.cancelDiscardModalButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleCreate,
        testId: "discard-modal-create-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $669df68d731a7024$var$i18n.createDiscardButtonLabel)))));
};



var $6kn6H = parcelRequire("6kn6H");














var $fytHI = parcelRequire("fytHI");

const $c4d86d67f987f78e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    tryDifferentDocumentUploadErrorPopupButtonTYPE: {
        id: "import-from-sources.upload-error-popup.type-tryDifferentDocument",
        defaultMessage: "Select another file"
    },
    closeUploadErrorPopupButtonTYPE: {
        id: "import-from-sources.upload-error-popup.close",
        defaultMessage: "Close"
    },
    uploadErrorPopupTitleTYPE: {
        id: "import-from-sources.upload-error-popup.type-title",
        defaultMessage: "Only .DOCX files are supported"
    },
    uploadErrorPopupContentTYPE: {
        id: "import-from-sources.upload-error-popup.type-content",
        defaultMessage: "We couldn\u2019t import the file you selected because it is the wrong file type. Select a different file to continue."
    }
});
const $c4d86d67f987f78e$export$502dbbf17b4c1aa6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onSubmit: onSubmit, onClose: onClose } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.uploadErrorPopupTitleTYPE);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.uploadErrorPopupContentTYPE);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.tryDifferentDocumentUploadErrorPopupButtonTYPE);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.closeUploadErrorPopupButtonTYPE);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== onClose || $[5] !== onSubmit) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fytHI.UploadErrorPopup), {
            onSubmit: onSubmit,
            onClose: onClose,
            headText: t1,
            bodyText: t2,
            submitText: t3,
            closeText: t4,
            modalWidth: "small"
        });
        $[4] = onClose;
        $[5] = onSubmit;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ onSubmit: onSubmit, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fytHI.UploadErrorPopup), {
        onSubmit: onSubmit,
        onClose: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.uploadErrorPopupTitleTYPE),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.uploadErrorPopupContentTYPE),
        submitText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.tryDifferentDocumentUploadErrorPopupButtonTYPE),
        closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c4d86d67f987f78e$export$a7357cdd1f0b0168.closeUploadErrorPopupButtonTYPE),
        modalWidth: "small"
    });
};





















var $7aRdF = parcelRequire("7aRdF");


var $aRGok = parcelRequire("aRGok");




















var $8cleY = parcelRequire("8cleY");













const $95f06d49a7301ba6$var$getSelectedDocuments = (docs)=>docs.filter((doc)=>doc.selected);
const $95f06d49a7301ba6$var$getDocumentsToUpload = (docs)=>docs.map((doc)=>doc.document);
const $95f06d49a7301ba6$export$93872e1884896fe6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { docs: docs } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    let t0;
    if ($[0] !== docs) {
        t0 = $95f06d49a7301ba6$var$getSelectedDocuments(docs);
        $[0] = docs;
        $[1] = t0;
    } else t0 = $[1];
    const selectedDocuments = t0;
    let t1;
    if ($[2] !== selectedDocuments) {
        t1 = $95f06d49a7301ba6$var$getDocumentsToUpload(selectedDocuments);
        $[2] = selectedDocuments;
        $[3] = t1;
    } else t1 = $[3];
    const documentsToUpload = t1;
    let t2;
    if ($[4] !== documentsToUpload || $[5] !== selectedDocuments) {
        t2 = {
            selectedDocuments: selectedDocuments,
            documentsToUpload: documentsToUpload
        };
        $[4] = documentsToUpload;
        $[5] = selectedDocuments;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ()=>{
    const { docs: docs } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const selectedDocuments = (0, $cozmU.useMemo)(()=>$95f06d49a7301ba6$var$getSelectedDocuments(docs), [
        docs
    ]);
    const documentsToUpload = (0, $cozmU.useMemo)(()=>$95f06d49a7301ba6$var$getDocumentsToUpload(selectedDocuments), [
        selectedDocuments
    ]);
    return {
        selectedDocuments: selectedDocuments,
        documentsToUpload: documentsToUpload
    };
};



var $lo1Qi = parcelRequire("lo1Qi");


var $hGnTB = parcelRequire("hGnTB");


var $dfcSL = parcelRequire("dfcSL");

const $a8a6277a6ac150aa$var$SelectedDocumentsData = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg20Hp _3iDTPbQ4SZ _1DCdHi2ADO _2Zuz6Q1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg20Hp _3iDTPbQ4SZ _1DCdHi2ADO _2Zuz6Q1Y8M",
            __cmplp.className
        ])
    });
});
const $a8a6277a6ac150aa$var$SelectedDocumentsWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0NUa3rWD6W _2WAcuGIZbP _3oUqlsUzH9 _36KdBz7zJH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0NUa3rWD6W _2WAcuGIZbP _3oUqlsUzH9 _36KdBz7zJH",
            __cmplp.className
        ])
    });
});
const $a8a6277a6ac150aa$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    bulkLimitModalDialogCancelAction: {
        id: "import-from-sources.bulk-limit-modal.cancelAction",
        defaultMessage: "Cancel"
    },
    bulkLimitModalDialogRetryAction: {
        id: "import-from-sources.bulk-limit-modal.retryAction",
        defaultMessage: "Retry"
    },
    bulkLimitModalDialogRetryHeading: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogRetryHeading",
        defaultMessage: "You can\u2019t import more than {bulkLimit} documents at once."
    },
    bulkLimitModalDialogRetryHeadingExtended: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogRetryHeadingExtended",
        defaultMessage: "You can\u2019t import more than {bulkLengthLimit, plural, one {# document} other {# documents}} at once, and the total size of all documents can\u2019t be more than {bulkSizeLimit} MB."
    },
    bulkLimitModalDialogDocsSelectedLength: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogDocsSelectedLength",
        defaultMessage: "{docsNumber, plural, one {# document} other {# documents}} selected"
    },
    bulkLimitModalDialogTotalSelectedDocsSize: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogTotalSelectedDocsSize",
        defaultMessage: "{totalSize} MB total size"
    },
    bulkLimitModalDialogSizeUnit: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogSizeUnit",
        defaultMessage: "MB"
    },
    bulkLimitModalDialogSizeCouldNotIdentify: {
        id: "import-from-sources.bulk-limit-modal.bulkLimitModalDialogSizeCouldNotIdentify",
        defaultMessage: "can\u2019t determine size"
    }
});
const $a8a6277a6ac150aa$export$ee52fc01a50ec016 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { onClose: onClose, onRetry: onRetry } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { docActions: t1, docs: docs } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocSelect: uploadDocSelect } = t1;
    const { documentsToUpload: documentsToUpload, selectedDocuments: selectedDocuments } = (0, $95f06d49a7301ba6$export$93872e1884896fe6)();
    let t2;
    if ($[0] !== documentsToUpload || $[1] !== onRetry) {
        t2 = ()=>onRetry(documentsToUpload);
        $[0] = documentsToUpload;
        $[1] = onRetry;
        $[2] = t2;
    } else t2 = $[2];
    const handleRetry = t2;
    let t3;
    if ($[3] !== uploadDocSelect) {
        t3 = (t4)=>{
            const { target: target } = t4;
            uploadDocSelect(target.value);
        };
        $[3] = uploadDocSelect;
        $[4] = t3;
    } else t3 = $[4];
    const handleChange = t3;
    let t4;
    if ($[5] !== intl) {
        t4 = (doc)=>{
            const { nameWithoutExt: nameWithoutExt, size: size } = doc;
            const msg = size ? `${(0, $lo1Qi.fixedBytesToMegabytes)(size)} ${intl.formatMessage($a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogSizeUnit)}` : intl.formatMessage($a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogSizeCouldNotIdentify);
            return `${nameWithoutExt} (${msg})`;
        };
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    const getCheckboxLabelText = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogRetryHeadingExtended,
            values: {
                bulkLengthLimit: (0, $8cleY.BULK_UPLOAD_LIMIT),
                bulkSizeLimit: (0, $lo1Qi.fixedBytesToMegabytes)((0, $dfcSL.TOTAL_UPLOAD_LIMIT_BULK))
            }
        })));
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== documentsToUpload.length) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsData, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogDocsSelectedLength,
            values: {
                docsNumber: documentsToUpload.length
            }
        }));
        $[8] = documentsToUpload.length;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== selectedDocuments) {
        t7 = (0, $lo1Qi.fixedBytesToMegabytes)((0, $hGnTB.getBulkTotalSize)(selectedDocuments));
        $[10] = selectedDocuments;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsData, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogTotalSelectedDocsSize,
            values: {
                totalSize: t7
            }
        }));
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== docs || $[15] !== getCheckboxLabelText || $[16] !== handleChange) {
        let t10;
        if ($[18] !== getCheckboxLabelText || $[19] !== handleChange) {
            t10 = (doc_0, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                    key: i,
                    isChecked: doc_0.selected,
                    label: getCheckboxLabelText(doc_0),
                    onChange: handleChange,
                    value: doc_0.nameWithoutExt
                });
            $[18] = getCheckboxLabelText;
            $[19] = handleChange;
            $[20] = t10;
        } else t10 = $[20];
        t9 = docs.map(t10);
        $[14] = docs;
        $[15] = getCheckboxLabelText;
        $[16] = handleChange;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsWrapper, null, t9);
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t6 || $[25] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, t6, t8, t10);
        $[23] = t10;
        $[24] = t6;
        $[25] = t8;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogCancelAction);
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== onClose) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: "cancel",
            appearance: "subtle",
            onClick: onClose,
            testId: "bulk-limit-modal-cancel"
        }, t12);
        $[28] = onClose;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== documentsToUpload || $[31] !== selectedDocuments) {
        t14 = !documentsToUpload.length || (0, $hGnTB.isBulkLengthLimitReached)(documentsToUpload) || (0, $hGnTB.isBulkTotalSizeLimitReached)(selectedDocuments);
        $[30] = documentsToUpload;
        $[31] = selectedDocuments;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogRetryAction);
        $[33] = t15;
    } else t15 = $[33];
    let t16;
    if ($[34] !== handleRetry || $[35] !== t14) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: "retry",
            appearance: "primary",
            onClick: handleRetry,
            testId: "bulk-limit-modal-retry",
            isDisabled: t14
        }, t15);
        $[34] = handleRetry;
        $[35] = t14;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== t13 || $[38] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t13, t16));
        $[37] = t13;
        $[38] = t16;
        $[39] = t17;
    } else t17 = $[39];
    let t18;
    if ($[40] !== t11 || $[41] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            width: "medium"
        }, t5, t11, t17));
        $[40] = t11;
        $[41] = t17;
        $[42] = t18;
    } else t18 = $[42];
    return t18;
} : ({ onClose: onClose, onRetry: onRetry })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { docActions: { uploadDocSelect: uploadDocSelect }, docs: docs } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { documentsToUpload: documentsToUpload, selectedDocuments: selectedDocuments } = (0, $95f06d49a7301ba6$export$93872e1884896fe6)();
    const handleRetry = ()=>onRetry(documentsToUpload);
    const handleChange = (0, $cozmU.useCallback)(({ target: target })=>{
        uploadDocSelect(target.value);
    }, [
        uploadDocSelect
    ]);
    const getCheckboxLabelText = (doc)=>{
        const { nameWithoutExt: nameWithoutExt, size: size } = doc;
        const msg = size ? `${(0, $lo1Qi.fixedBytesToMegabytes)(size)} ${intl.formatMessage($a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogSizeUnit)}` : intl.formatMessage($a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogSizeCouldNotIdentify);
        return `${nameWithoutExt} (${msg})`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogRetryHeadingExtended,
        values: {
            bulkLengthLimit: (0, $8cleY.BULK_UPLOAD_LIMIT),
            bulkSizeLimit: (0, $lo1Qi.fixedBytesToMegabytes)((0, $dfcSL.TOTAL_UPLOAD_LIMIT_BULK))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsData, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogDocsSelectedLength,
        values: {
            docsNumber: documentsToUpload.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsData, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogTotalSelectedDocsSize,
        values: {
            totalSize: (0, $lo1Qi.fixedBytesToMegabytes)((0, $hGnTB.getBulkTotalSize)(selectedDocuments))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8a6277a6ac150aa$var$SelectedDocumentsWrapper, null, docs.map((doc_0, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            key: i,
            isChecked: doc_0.selected,
            label: getCheckboxLabelText(doc_0),
            onChange: handleChange,
            value: doc_0.nameWithoutExt
        });
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        key: "cancel",
        appearance: "subtle",
        onClick: onClose,
        testId: "bulk-limit-modal-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogCancelAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        key: "retry",
        appearance: "primary",
        onClick: handleRetry,
        testId: "bulk-limit-modal-retry",
        isDisabled: !documentsToUpload.length || (0, $hGnTB.isBulkLengthLimitReached)(documentsToUpload) || (0, $hGnTB.isBulkTotalSizeLimitReached)(selectedDocuments)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a8a6277a6ac150aa$export$a7357cdd1f0b0168.bulkLimitModalDialogRetryAction))))));
};
















var $acRhQ = parcelRequire("acRhQ");

const $4656d114e9417da4$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    RestrictionWarningModalTitle: {
        id: "import-from-sources.warning-modal.RestrictionWarningModalTitle",
        defaultMessage: "No restrictions on child pages"
    },
    RestrictionWarningModalBody: {
        id: "import-from-sources.warning-modal.RestrictionWarningModalBody",
        defaultMessage: "You don\u2019t have permission to restrict content in this space. Anyone in your organization can view and edit all content imported here."
    },
    RestrictionWarningModalSubmit: {
        id: "import-from-sources.warning-modal.RestrictionWarningModalSubmit",
        defaultMessage: "Continue"
    }
});
const $4656d114e9417da4$export$902ffe599d4c6641 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onSubmit: onSubmit, onClose: onClose } = t0;
    const { documentsToUpload: documentsToUpload } = (0, $95f06d49a7301ba6$export$93872e1884896fe6)();
    let t1;
    if ($[0] !== documentsToUpload || $[1] !== onSubmit) {
        t1 = ()=>onSubmit(documentsToUpload);
        $[0] = documentsToUpload;
        $[1] = onSubmit;
        $[2] = t1;
    } else t1 = $[2];
    const handleRetry = t1;
    let t2;
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalTitle);
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalBody);
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalSubmit);
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else {
        t2 = $[3];
        t3 = $[4];
        t4 = $[5];
    }
    let t5;
    if ($[6] !== handleRetry || $[7] !== onClose) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
            onSubmit: handleRetry,
            onClose: onClose,
            headText: t2,
            bodyText: t3,
            submitText: t4
        });
        $[6] = handleRetry;
        $[7] = onClose;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ onSubmit: onSubmit, onClose: onClose })=>{
    const { documentsToUpload: documentsToUpload } = (0, $95f06d49a7301ba6$export$93872e1884896fe6)();
    const handleRetry = ()=>onSubmit(documentsToUpload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
        onSubmit: handleRetry,
        onClose: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalTitle),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalBody),
        submitText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4656d114e9417da4$export$a7357cdd1f0b0168.RestrictionWarningModalSubmit)
    });
};


















var $iMnC5 = parcelRequire("iMnC5");








var $cJ0FD = parcelRequire("cJ0FD");













var $e330514a6a8b4830$exports = {};
$e330514a6a8b4830$exports = new URL("scalability.1cba28e5.svg", import.meta.url).toString();


var $17f3e13d769ccded$exports = {};
$17f3e13d769ccded$exports = new URL("success.336c2357.svg", import.meta.url).toString();













var $9b66a54e8ae09aca$export$fad76899145ca0c7 = /*#__PURE__*/ function(ProgressStatus) {
    ProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ProgressStatus["SUCCESS"] = "SUCCESS";
    ProgressStatus["ERROR"] = "ERROR";
    return ProgressStatus;
}({});


const $036d04bc69a758c6$var$tickIncreasesRange = [
    {
        min: 30,
        max: 45,
        multiplier: 2
    },
    {
        min: 63,
        max: 80,
        multiplier: 10
    },
    {
        min: 86,
        max: 100,
        multiplier: 100
    }
];
const $036d04bc69a758c6$var$INITIAL_TICK = 50;
const $036d04bc69a758c6$var$MAX_PROGRESS = 99;
const $036d04bc69a758c6$export$6f53206d5592836e = (0, $3u0dr.isReactCompilerActiveV2)() ? (status, progress, setProgress)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    let t1;
    if ($[0] !== progress || $[1] !== setProgress || $[2] !== status) {
        t0 = ()=>{
            let timer;
            const clearTimer = ()=>{
                timer && clearTimeout(timer);
            };
            if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).IN_PROGRESS && progress < $036d04bc69a758c6$var$MAX_PROGRESS) {
                const tickCoefficient = $036d04bc69a758c6$var$tickIncreasesRange.find((t2)=>{
                    const { min: min, max: max } = t2;
                    return progress >= min && progress < max;
                });
                const tick = $036d04bc69a758c6$var$INITIAL_TICK * (tickCoefficient && tickCoefficient.multiplier || 1);
                timer = setTimeout(()=>{
                    setProgress(progress + 1);
                }, tick);
                return clearTimer;
            }
            if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS) setProgress(100);
        };
        t1 = [
            status,
            progress,
            setProgress
        ];
        $[0] = progress;
        $[1] = setProgress;
        $[2] = status;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (status, progress, setProgress)=>{
    (0, $cozmU.useEffect)(()=>{
        let timer;
        const clearTimer = ()=>{
            timer && clearTimeout(timer);
        };
        if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).IN_PROGRESS && progress < $036d04bc69a758c6$var$MAX_PROGRESS) {
            const tickCoefficient = $036d04bc69a758c6$var$tickIncreasesRange.find(({ min: min, max: max })=>progress >= min && progress < max);
            const tick = $036d04bc69a758c6$var$INITIAL_TICK * (tickCoefficient && tickCoefficient.multiplier || 1);
            timer = setTimeout(()=>{
                setProgress(progress + 1);
            }, tick);
            return clearTimer;
        }
        if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS) setProgress(100);
    }, [
        status,
        progress,
        setProgress
    ]);
};
















var $lfoFx = parcelRequire("lfoFx");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");





var $9ZvQo = parcelRequire("9ZvQo");




















var $9wGTI = parcelRequire("9wGTI");



var $iaxSo = parcelRequire("iaxSo");







var $18597b3cce1089d8$export$be905a02dce408ee = /*#__PURE__*/ function(ProcessErrors) {
    ProcessErrors["ADF_CONVERSION_ERROR"] = "AdfConversionError";
    ProcessErrors["PROCESS_IMAGE_ERROR"] = "ProcessImageError";
    return ProcessErrors;
}({});



var $lrhMp = parcelRequire("lrhMp");




const $52994668ae772766$var$i18nBase = (0, $kSwu1.defineMessages)({
    operationAborted: {
        id: "import-from-sources.error-message.operationAborted",
        defaultMessage: "Import canceled"
    },
    fileExceedsLimitLocalBulk: {
        id: "import-from-sources.error-message.fileExceedsLimitLocalBulk",
        defaultMessage: "This file is {fileSize} MB which exceeds the {uploadFileLimitMb} MB limit. You could break the content into smaller files and import them separately."
    },
    fileExceedsLimitGdBulk: {
        id: "import-from-sources.error-message.fileExceedsLimitGdBulk",
        defaultMessage: "This file exceeds the 10 MB export limit from Google Drive."
    },
    pageWithThisNameAlreadyExists: {
        id: "import-from-sources.error-message.pageWithThisNameAlreadyExists",
        defaultMessage: "A page with this name already exists. Page names have to be unique within a space. Give your page a different name to publish it."
    },
    liveDocWithThisNameAlreadyExists: {
        id: "import-from-sources.error-message.liveDocWithThisNameAlreadyExists",
        defaultMessage: "A live doc with this name already exists. Titles have to be unique within a space. Give your doc a different name."
    },
    imageErrorProcessWarningMessage: {
        id: "import-from-sources.error-message.imageErrorProcessWarningMessage",
        defaultMessage: "Some images couldn\u2019t be imported. We ran into an issue importing one or more of the images in your document. We\u2019ve created placeholders for them in your new page."
    },
    elementErrorProcessWarningMessage: {
        id: "import-from-sources.error-message.elementErrorProcessWarningMessage",
        defaultMessage: "Some elements couldn\u2019t be imported. We ran into an issue importing some elements of your document (images, fonts, etc.)."
    },
    elementErrorUserRateLimitMessage: {
        id: "import-from-sources.error-message.elementErrorUserRateLimitMessage",
        defaultMessage: "We had trouble importing this file. Finish this import and retry this upload in a few minutes."
    },
    strictFormatErrorMessage: {
        id: "import-from-sources.error-message.strictFormatErrorMessage",
        defaultMessage: "File format not supported. The .docx file imported was saved as a Strict Open XML. Please save it as Word Document .docx and import again."
    },
    payloadTooLargeErrorMessage: {
        id: "import-from-sources.error-message.payloadTooLargeErrorMessage",
        defaultMessage: "The content is too long. You can split the content into smaller files and import them separately."
    }
});
const $52994668ae772766$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    imageErrorProcessWarningMessage: {
        id: "import-from-sources.error-message.imageErrorProcessWarningMessage.livedocs",
        defaultMessage: "Some images couldn\u2019t be imported. We ran into an issue importing one or more of the images in your document. We\u2019ve created placeholders for them."
    }
});
const $52994668ae772766$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($52994668ae772766$var$i18nBase, $52994668ae772766$var$i18nLiveDocs);
const $52994668ae772766$var$getErrorMessage = (doc)=>{
    const ERROR_MESSAGES = {
        [(0, $9ZvQo.DocErrors).TYPE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $c4d86d67f987f78e$export$a7357cdd1f0b0168).uploadErrorPopupTitleTYPE),
        [(0, $9ZvQo.DocErrors).SIZE_LOCAL_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$52994668ae772766$export$a7357cdd1f0b0168.fileExceedsLimitLocalBulk,
            values: {
                fileSize: (0, $lo1Qi.fixedBytesToMegabytes)(doc.size ?? 0),
                uploadFileLimitMb: (0, $dfcSL.FILE_UPLOAD_LIMIT_MB)
            }
        }),
        [(0, $9ZvQo.DocErrors).SIZE_GD_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.fileExceedsLimitGdBulk),
        [(0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iaxSo.i18n).uploadErrorPopupContent),
        [(0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.operationAborted),
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        [(0, $9ZvQo.DocErrors).NOT_UNIQ_TITLE]: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.liveDocWithThisNameAlreadyExists) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.pageWithThisNameAlreadyExists),
        [(0, $18597b3cce1089d8$export$be905a02dce408ee).PROCESS_IMAGE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.imageErrorProcessWarningMessage),
        [(0, $18597b3cce1089d8$export$be905a02dce408ee).ADF_CONVERSION_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.elementErrorProcessWarningMessage),
        [(0, $lrhMp.GOOGLE_EXPORT_ERRORS).USER_RATE_LIMIT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.elementErrorUserRateLimitMessage),
        [(0, $9ZvQo.DocErrors).STRICT_FORMAT_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.strictFormatErrorMessage),
        [(0, $9ZvQo.DocErrors).PAYLOAD_TOO_LARGE]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $52994668ae772766$export$a7357cdd1f0b0168.payloadTooLargeErrorMessage)
    };
    return ERROR_MESSAGES[doc.error.type];
};
const $52994668ae772766$export$670b047017caeb11 = (0, $3u0dr.isReactCompilerActiveV2)() ? (doc)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== doc) {
        t0 = $52994668ae772766$var$getErrorMessage(doc);
        $[0] = doc;
        $[1] = t0;
    } else t0 = $[1];
    const errMessage = t0;
    return errMessage;
} : (doc)=>{
    const errMessage = (0, $cozmU.useMemo)(()=>$52994668ae772766$var$getErrorMessage(doc), [
        doc
    ]);
    return errMessage;
};

















var $4aRua = parcelRequire("4aRua");





var $chu6R = parcelRequire("chu6R");


const $ca47df5408cd0022$var$styles = {
    icon: "_0adFHs2ADO"
};
const $ca47df5408cd0022$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    uploadModalProgressTitleSuccess: {
        id: "import-from-sources.upload-modal.progressTitleSuccess",
        defaultMessage: "Import complete!"
    }
});
const $ca47df5408cd0022$export$f3f348ec50c3a717 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { status: status, message: message } = t0;
    let t1;
    if ($[0] !== message || $[1] !== status) {
        t1 = status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $ca47df5408cd0022$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ca47df5408cd0022$export$a7357cdd1f0b0168.uploadModalProgressTitleSuccess)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message);
        $[0] = message;
        $[1] = status;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ status: status, message: message })=>{
    return status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $ca47df5408cd0022$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: "Success"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ca47df5408cd0022$export$a7357cdd1f0b0168.uploadModalProgressTitleSuccess)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message);
};












var $ig7dg = parcelRequire("ig7dg");





var $4ez2K = parcelRequire("4ez2K");


















const $f2a87d9eecacaece$var$styles = {
    message: "_2sNsIg7NXe"
};
const $f2a87d9eecacaece$export$915e9e7bd4f0f96d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { doc: doc } = t0;
    const errMessage = (0, $52994668ae772766$export$670b047017caeb11)(doc);
    let t1;
    if ($[0] !== errMessage) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f2a87d9eecacaece$var$styles.message,
            testId: "error-message-component"
        }, errMessage);
        $[0] = errMessage;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ doc: doc })=>{
    const errMessage = (0, $52994668ae772766$export$670b047017caeb11)(doc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f2a87d9eecacaece$var$styles.message,
        testId: "error-message-component"
    }, errMessage);
};


const $eb83745d9d8b679f$var$styles = {
    container: "_1DCdHiNHnM",
    error: "_1DCdHidnbC",
    barName: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _39xV02e7g8 _1ANEUSLRg7",
    progressText: "_4ouGXIUF4f _1UtDYzy7kJ",
    progressContent: "_1bHrqEN91d"
};
const $eb83745d9d8b679f$export$ab045b1868012d9c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { progress: progress, doc: doc, children: children, status: status, testId: testId } = t0;
    const t1 = doc?.nameWithoutExt;
    let t2;
    if ($[0] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $eb83745d9d8b679f$var$styles.barName
        }, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = doc && doc?.error?.role !== (0, $9ZvQo.ErrorRoles).ERROR && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && `${progress}%`;
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $eb83745d9d8b679f$var$styles.progressText
        }, t3);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t2 || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between"
        }, t2, t4);
        $[4] = t2;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = doc?.completed || status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? 1 : progress / 100;
    let t7;
    if ($[7] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ig7dg.default), {
            ariaLabel: "upload progress bar",
            value: t6
        });
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t5 || $[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $eb83745d9d8b679f$var$styles.progressContent
        }, t5, t7);
        $[9] = t5;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== children || $[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, t8, children);
        $[12] = children;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== doc) {
        t10 = doc?.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $eb83745d9d8b679f$var$styles.error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2a87d9eecacaece$export$915e9e7bd4f0f96d), {
            doc: doc
        }));
        $[15] = doc;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10 || $[18] !== t9 || $[19] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $eb83745d9d8b679f$var$styles.container,
            testId: testId
        }, t9, t10);
        $[17] = t10;
        $[18] = t9;
        $[19] = testId;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ progress: progress, doc: doc, children: children, status: status, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eb83745d9d8b679f$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eb83745d9d8b679f$var$styles.progressContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eb83745d9d8b679f$var$styles.barName
    }, doc?.nameWithoutExt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $eb83745d9d8b679f$var$styles.progressText
    }, doc && doc?.error?.role !== (0, $9ZvQo.ErrorRoles).ERROR && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && `${progress}%`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ig7dg.default), {
        ariaLabel: "upload progress bar",
        value: doc?.completed || status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? 1 : progress / 100
    })), children), doc?.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $eb83745d9d8b679f$var$styles.error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2a87d9eecacaece$export$915e9e7bd4f0f96d), {
        doc: doc
    })));
};


const $721a4d05dfce2454$var$styles = {
    progress: "_0NUa3rWD6W _1Znuxb5zaO _2WAcuGIZbP _3oUqlsUzH9"
};
const $721a4d05dfce2454$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    uploadModalProgressTitleBulk: {
        id: "import-from-sources.upload-modal.progressTitleBulk",
        defaultMessage: "Importing documents\u2026"
    },
    uploadModalProgressTitleBulkFailed: {
        id: "import-from-sources.upload-modal.uploadModalProgressTitleBulkFailed",
        defaultMessage: "Bulk import failed!"
    }
});
const $721a4d05dfce2454$export$7a186a984cb1ca70 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { status: status, progress: progress, docs: docs, bulkParentPageId: bulkParentPageId, isCancelledDocumentsDeleted: isCancelledDocumentsDeleted, useSingleProgressBar: t1, isDisabledCancel: t2 } = t0;
    const useSingleProgressBar = t1 === undefined ? false : t1;
    const isDisabledCancel = t2 === undefined ? false : t2;
    const { docActions: t3 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocFailure: uploadDocFailure } = t3;
    let t4;
    if ($[0] !== progress) {
        t4 = (completed, i)=>{
            let result = !completed ? progress - (i + 1) : 100;
            if (result < 0) result = 0;
            return result;
        };
        $[0] = progress;
        $[1] = t4;
    } else t4 = $[1];
    const getProgressForOneDoc = t4;
    let t5;
    if ($[2] !== docs || $[3] !== progress || $[4] !== status) {
        t5 = ()=>{
            if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS) return 100;
            let result_0 = 0;
            for(let i_0 = 0; i_0 < docs.length; i_0++)result_0 = result_0 + (docs[i_0].completed ? 100 : progress - (i_0 + 1));
            return result_0 < 0 ? 1 : Math.round(result_0 / docs.length);
        };
        $[2] = docs;
        $[3] = progress;
        $[4] = status;
        $[5] = t5;
    } else t5 = $[5];
    const getCommonProgress = t5;
    const [isDocWasCancelled, setIsDocWasCancelled] = (0, $cozmU.useState)(false);
    const [isDeleteSingleDocStatus, setIsDeleteSingleDocStatus] = (0, $cozmU.useState)(false);
    let t6;
    if ($[6] !== bulkParentPageId || $[7] !== uploadDocFailure) {
        t6 = (doc)=>{
            setIsDocWasCancelled(true);
            if (doc?.controller && !bulkParentPageId) doc.controller.abort();
            uploadDocFailure(doc.document?.name, {
                type: (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
        };
        $[6] = bulkParentPageId;
        $[7] = uploadDocFailure;
        $[8] = t6;
    } else t6 = $[8];
    const handleClick = t6;
    let t7;
    let t8;
    if ($[9] !== getCommonProgress || $[10] !== isDocWasCancelled || $[11] !== status) {
        t7 = ()=>{
            if (isDocWasCancelled && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && getCommonProgress() === 100) return setIsDeleteSingleDocStatus(true);
            return setIsDeleteSingleDocStatus(false);
        };
        t8 = [
            status,
            isDocWasCancelled,
            getCommonProgress
        ];
        $[9] = getCommonProgress;
        $[10] = isDocWasCancelled;
        $[11] = status;
        $[12] = t7;
        $[13] = t8;
    } else {
        t7 = $[12];
        t8 = $[13];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[14] !== isDeleteSingleDocStatus || $[15] !== status) {
        t9 = ()=>{
            if (isDeleteSingleDocStatus) return (0, $52994668ae772766$export$a7357cdd1f0b0168).operationAborted;
            return status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? $721a4d05dfce2454$export$a7357cdd1f0b0168.uploadModalProgressTitleBulk : $721a4d05dfce2454$export$a7357cdd1f0b0168.uploadModalProgressTitleBulkFailed;
        };
        $[14] = isDeleteSingleDocStatus;
        $[15] = status;
        $[16] = t9;
    } else t9 = $[16];
    const getProgressMessage = t9;
    let t10;
    if ($[17] !== getProgressMessage) {
        t10 = getProgressMessage();
        $[17] = getProgressMessage;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== status || $[20] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca47df5408cd0022$export$f3f348ec50c3a717), {
            status: status,
            message: t10
        });
        $[19] = status;
        $[20] = t10;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== getCommonProgress || $[23] !== isDeleteSingleDocStatus || $[24] !== status) {
        t12 = status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && !isDeleteSingleDocStatus && `${getCommonProgress()}%`;
        $[22] = getCommonProgress;
        $[23] = isDeleteSingleDocStatus;
        $[24] = status;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$67655acf87fc1a21), {
            "data-testid": "progress-percentage"
        }, t12);
        $[26] = t12;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== isCancelledDocumentsDeleted || $[29] !== isDeleteSingleDocStatus) {
        t14 = isDeleteSingleDocStatus && !isCancelledDocumentsDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            testId: "progress-bulk-doc-modal-spinner"
        });
        $[28] = isCancelledDocumentsDeleted;
        $[29] = isDeleteSingleDocStatus;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== t11 || $[32] !== t13 || $[33] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$d79a481f0b262bdb), null, t11, t13, t14);
        $[31] = t11;
        $[32] = t13;
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== docs || $[36] !== getCommonProgress || $[37] !== getProgressForOneDoc || $[38] !== handleClick || $[39] !== isDisabledCancel || $[40] !== status || $[41] !== useSingleProgressBar) {
        t16 = useSingleProgressBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
            testId: "progress-bar-single-aggregate",
            progress: getCommonProgress(),
            status: status
        }) : docs.map((doc_0, i_1)=>{
            const progressOneDoc = getProgressForOneDoc(doc_0.completed, i_1);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
                progress: progressOneDoc,
                key: i_1,
                doc: doc_0,
                status: status
            }, !doc_0.completed && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && !isDisabledCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                testId: "cancel-icon-wrapper",
                label: "cancel",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                onClick: ()=>handleClick(doc_0)
            }));
        });
        $[35] = docs;
        $[36] = getCommonProgress;
        $[37] = getProgressForOneDoc;
        $[38] = handleClick;
        $[39] = isDisabledCancel;
        $[40] = status;
        $[41] = useSingleProgressBar;
        $[42] = t16;
    } else t16 = $[42];
    let t17;
    if ($[43] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $721a4d05dfce2454$var$styles.progress,
            testId: "progress-bars-wrapper"
        }, t16);
        $[43] = t16;
        $[44] = t17;
    } else t17 = $[44];
    let t18;
    if ($[45] !== t15 || $[46] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t15, t17);
        $[45] = t15;
        $[46] = t17;
        $[47] = t18;
    } else t18 = $[47];
    return t18;
} : ({ status: status, progress: progress, docs: docs, bulkParentPageId: bulkParentPageId, isCancelledDocumentsDeleted: isCancelledDocumentsDeleted, useSingleProgressBar: useSingleProgressBar = false, isDisabledCancel: isDisabledCancel = false })=>{
    const { docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const getProgressForOneDoc = (completed, i)=>{
        let result = !completed ? progress - (i + 1) : 100;
        if (result < 0) result = 0;
        return result;
    }; // eslint-disable-next-line
    const getCommonProgress = ()=>{
        if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS) return 100;
        let result_0 = 0;
        for(let i_0 = 0; i_0 < docs.length; i_0++)result_0 += docs[i_0].completed ? 100 : progress - (i_0 + 1);
        return result_0 < 0 ? 1 : Math.round(result_0 / docs.length);
    };
    const [isDocWasCancelled, setIsDocWasCancelled] = (0, $cozmU.useState)(false);
    const [isDeleteSingleDocStatus, setIsDeleteSingleDocStatus] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)((doc)=>{
        setIsDocWasCancelled(true);
        if (doc?.controller && !bulkParentPageId) doc.controller.abort();
        uploadDocFailure(doc.document?.name, {
            type: (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR,
            role: (0, $9ZvQo.ErrorRoles).ERROR
        });
    }, [
        uploadDocFailure,
        bulkParentPageId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isDocWasCancelled && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && getCommonProgress() === 100) return setIsDeleteSingleDocStatus(true);
        return setIsDeleteSingleDocStatus(false);
    }, [
        status,
        isDocWasCancelled,
        getCommonProgress
    ]); //TODO: remove getCommonProgress from useEffect dependencies
    const getProgressMessage = ()=>{
        if (isDeleteSingleDocStatus) return (0, $52994668ae772766$export$a7357cdd1f0b0168).operationAborted;
        return status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? $721a4d05dfce2454$export$a7357cdd1f0b0168.uploadModalProgressTitleBulk : $721a4d05dfce2454$export$a7357cdd1f0b0168.uploadModalProgressTitleBulkFailed;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$d79a481f0b262bdb), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca47df5408cd0022$export$f3f348ec50c3a717), {
        status: status,
        message: getProgressMessage()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$67655acf87fc1a21), {
        "data-testid": "progress-percentage"
    }, status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && !isDeleteSingleDocStatus && `${getCommonProgress()}%`), isDeleteSingleDocStatus && !isCancelledDocumentsDeleted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        testId: "progress-bulk-doc-modal-spinner"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $721a4d05dfce2454$var$styles.progress,
        testId: "progress-bars-wrapper"
    }, useSingleProgressBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
        testId: "progress-bar-single-aggregate",
        progress: getCommonProgress(),
        status: status
    }) : docs.map((doc_0, i_1)=>{
        const progressOneDoc = getProgressForOneDoc(doc_0.completed, i_1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
            progress: progressOneDoc,
            key: i_1,
            doc: doc_0,
            status: status
        }, !doc_0.completed && status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && !isDisabledCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "cancel-icon-wrapper",
            label: "cancel",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            onClick: ()=>handleClick(doc_0)
        }));
    })));
};

















const $8f6f43ff2d2bda1e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    uploadModalProgressTitle: {
        id: "import-from-sources.upload-modal.progressTitle",
        defaultMessage: "Importing document\u2026"
    }
});
const $8f6f43ff2d2bda1e$export$87e4b52f2ee8e0ee = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { status: status, progress: progress } = t0;
    const { formatNumber: formatNumber } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== status) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca47df5408cd0022$export$f3f348ec50c3a717), {
            status: status,
            message: $8f6f43ff2d2bda1e$export$a7357cdd1f0b0168.uploadModalProgressTitle
        });
        $[0] = status;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = progress / 100;
    let t3;
    if ($[2] !== formatNumber || $[3] !== t2) {
        t3 = formatNumber(t2, {
            style: "percent"
        });
        $[2] = formatNumber;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$67655acf87fc1a21), null, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t1 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$b18537538ae608f9), null, t1, t4);
        $[7] = t1;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== progress) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
            progress: progress
        });
        $[10] = progress;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ({ status: status, progress: progress })=>{
    const { formatNumber: formatNumber } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$b18537538ae608f9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca47df5408cd0022$export$f3f348ec50c3a717), {
        status: status,
        message: $8f6f43ff2d2bda1e$export$a7357cdd1f0b0168.uploadModalProgressTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$67655acf87fc1a21), null, formatNumber(progress / 100, {
        style: 'percent'
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eb83745d9d8b679f$export$ab045b1868012d9c), {
        progress: progress
    }));
};



const $234e7a8aa4434be3$export$b18537538ae608f9 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEKvfT _2sNsIgmnOE _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _37wbyuI7V3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEKvfT _2sNsIgmnOE _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _37wbyuI7V3",
            __cmplp.className
        ])
    });
});
const $234e7a8aa4434be3$export$d79a481f0b262bdb = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $234e7a8aa4434be3$export$b18537538ae608f9 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbHMkp _1wydGWoWWg _2Zuz6QSPN1 _37wbyuxEoi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = $234e7a8aa4434be3$export$b18537538ae608f9, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbHMkp _1wydGWoWWg _2Zuz6QSPN1 _37wbyuxEoi",
            __cmplp.className
        ])
    });
});
const $234e7a8aa4434be3$export$67655acf87fc1a21 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIUF4f _1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4ouGXIUF4f _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $234e7a8aa4434be3$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYENuhp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYENuhp",
            __cmplp.className
        ])
    });
});
const $234e7a8aa4434be3$export$be58b4326e23250f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0adFHs2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0adFHs2ADO",
            __cmplp.className
        ])
    });
});
const $234e7a8aa4434be3$var$styles = {
    image: "_4c065Up0Oa _2Y7lL4GXk2",
    imageV2: "_4c065Up0Oa _3iDTPbQ4SZ _37wbyuDIqT",
    warning: "_0bjKvDKxmn _4c065U8HPE _2Y7lL45zaO _0KLXruhxIM _43nrzT5zaO"
};
const $234e7a8aa4434be3$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    uploadModalDialogFinishAction: {
        id: "import-from-sources.upload-modal.finishAction",
        defaultMessage: "Finish"
    },
    uploadModalDialogCancelAction: {
        id: "import-from-sources.upload-modal.cancelAction",
        defaultMessage: "Cancel"
    },
    markdownWarnings: {
        id: "import-from-sources.markdown.success.warnings",
        defaultMessage: "{count, plural, one {# Markdown item was changed} other {# Markdown items were changed}} during import. Review the page before publishing."
    }
});
const $234e7a8aa4434be3$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, onClose: onClose, testId: testId } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose || $[3] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: 394,
            testId: testId
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = testId;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, onClose: onClose, testId: testId })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: 394,
        testId: testId
    }, children);
}; /**
    * How long the completed progress bar is held on screen before auto-landing in
    * the imported doc. Long enough to read as "done", short enough not to feel
    * like a stall.
    */ 
const $234e7a8aa4434be3$var$COMPLETION_BEAT_MS = 500;
const $234e7a8aa4434be3$export$670b0269826f1fb6 = ({ status: status, onCancel: onCancel, onFinishDraft: onFinishDraft, onFinishPage: onFinishPage, onRetry: onRetry, isDisabledCancel: isDisabledCancel, bulkParentPageId: bulkParentPageId, isCancelledDocumentsDeleted: isCancelledDocumentsDeleted, isAutoLandEnabled: isAutoLandEnabled = false, warnings: warnings = [] })=>{
    const [progress, setProgress] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { selectedDocuments: selectedDocuments } = (0, $95f06d49a7301ba6$export$93872e1884896fe6)();
    const isBulk = (0, $27bc3d6341d74652$export$885b4341e7c3daaa)(selectedDocuments);
    const warningCount = (0, $cozmU.useMemo)(()=>warnings.reduce((total, warning)=>total + warning.count, 0), [
        warnings
    ]);
    (0, $036d04bc69a758c6$export$6f53206d5592836e)(status, progress, setProgress);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importProgressModal'
            }
        }).fire(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismiss = ()=>{
        if (isDisabledCancel) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importProgressModal',
                action: 'dismissed',
                actionSubject: 'modal',
                actionSubjectId: 'importProgressModal'
            }
        }).fire();
        onCancel();
    }; // `action` stays 'clicked' even when the import auto-lands. The event is the
    // funnel's success marker and Phase 0 (SPICE-2548) mapped it to a core action,
    // so changing the shape here would split the metric across the V1/V2 cohorts.
    // `trigger` distinguishes the two paths for anyone slicing the data.
    const handleAnalyticsFinish = (0, $cozmU.useCallback)((trigger)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importSuccessModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importSuccessFinish',
                attributes: {
                    trigger: trigger
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const finishHandler = ()=>{
        handleAnalyticsFinish('click');
        onFinishDraft();
    };
    const finishHandlerBulk = ()=>{
        handleAnalyticsFinish('click');
        onFinishPage();
    }; // Auto-land: on success, navigate straight into the imported doc instead of
    // waiting for a "Finish" click. Ref-guarded because `status` can settle on
    // SUCCESS across several renders and navigating twice would double-fire the
    // analytics event and race the router.
    const hasAutoLandedRef = (0, $cozmU.useRef)(false);
    const onFinishDraftRef = (0, $cozmU.useRef)(onFinishDraft);
    const onFinishPageRef = (0, $cozmU.useRef)(onFinishPage);
    onFinishDraftRef.current = onFinishDraft;
    onFinishPageRef.current = onFinishPage;
    (0, $cozmU.useEffect)(()=>{
        if (!isAutoLandEnabled || status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS || hasAutoLandedRef.current) return;
        hasAutoLandedRef.current = true;
        handleAnalyticsFinish('auto'); // Mirrors getFinishAction(): bulk imports land on the created parent page,
        // single imports land on the created draft.
        const land = ()=>{
            if (isBulk) onFinishPageRef.current();
            else onFinishDraftRef.current();
        }; // The progress bar is simulated and caps at 99 until SUCCESS flips it to
        // 100 (see useHandleProgressBar). Navigating in the same commit unmounts
        // the modal before that final frame paints, so the bar appears to stop
        // short. This beat lets it visibly complete before we land in the doc.
        const timer = setTimeout(land, $234e7a8aa4434be3$var$COMPLETION_BEAT_MS);
        return ()=>clearTimeout(timer);
    }, [
        isAutoLandEnabled,
        status,
        isBulk,
        handleAnalyticsFinish
    ]);
    const cancelHandler = ()=>{
        if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).IN_PROGRESS) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importProgressModal',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'importInProgressCancel'
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'importSuccessModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'importCancel'
            }
        }).fire();
        return onCancel();
    };
    const getFinishAction = ()=>{
        if (status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR) return onRetry;
        return isBulk ? finishHandlerBulk : finishHandler;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($234e7a8aa4434be3$var$ChoreographerModal, {
        onClose: handleDismiss,
        testId: "import-progress-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: !isDisabledCancel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAutoLandEnabled ? $234e7a8aa4434be3$var$styles.imageV2 : $234e7a8aa4434be3$var$styles.image
    }, isAutoLandEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e330514a6a8b4830$exports))),
        width: "232",
        height: "232"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($17f3e13d769ccded$exports))),
        width: "100%"
    })), isBulk ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $721a4d05dfce2454$export$7a186a984cb1ca70), {
        status: status,
        progress: progress,
        docs: selectedDocuments,
        bulkParentPageId: bulkParentPageId,
        isCancelledDocumentsDeleted: isCancelledDocumentsDeleted,
        useSingleProgressBar: isAutoLandEnabled,
        isDisabledCancel: isDisabledCancel
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8f6f43ff2d2bda1e$export$87e4b52f2ee8e0ee), {
        status: status,
        progress: progress
    }), status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS && warningCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $234e7a8aa4434be3$var$styles.warning,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$234e7a8aa4434be3$export$a7357cdd1f0b0168.markdownWarnings,
        values: {
            count: warningCount
        }
    }))), (!isAutoLandEnabled || status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        key: "cancel",
        testId: "progress-modal-cancel-button",
        appearance: "subtle",
        isDisabled: isDisabledCancel,
        onClick: cancelHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $234e7a8aa4434be3$export$a7357cdd1f0b0168.uploadModalDialogCancelAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        key: "finish",
        testId: "progress-modal-finish-button",
        appearance: "primary",
        onClick: getFinishAction(),
        isDisabled: status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).IN_PROGRESS
    }, status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8a6277a6ac150aa$export$a7357cdd1f0b0168).bulkLimitModalDialogRetryAction) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $234e7a8aa4434be3$export$a7357cdd1f0b0168.uploadModalDialogFinishAction)))));
};








































const $367cb45ad482c2d2$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClose: onClose, label: label, width: width } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== label || $[3] !== onClose || $[4] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: width,
            label: label
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = label;
        $[3] = onClose;
        $[4] = width;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, onClose: onClose, label: label, width: width })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: width,
        label: label
    }, children);
};
const $367cb45ad482c2d2$var$i18n = (0, $kSwu1.defineMessages)({
    submitProcessWarningPopup: {
        id: "import-from-sources.process-warning-popup.submitAction",
        defaultMessage: "OK"
    },
    imageErrorProcessWarningPopupTitle: {
        id: "import-from-sources.process-warning-popup.imageErrorProcessPopupTitle",
        defaultMessage: "Some images couldn\u2019t be imported"
    },
    imageErrorProcessWarningPopupContent: {
        id: "import-from-sources.process-warning-popup.imageErrorProcessWarningPopupContent",
        defaultMessage: "We ran into an issue importing one or more of the images in your document. We\u2019ve created placeholders for them in your new page."
    },
    elementErrorProcessWarningPopupTitle: {
        id: "import-from-sources.process-warning-popup.elementErrorProcessWarningPopupTitle",
        defaultMessage: "Some elements couldn\u2019t be imported"
    },
    elementErrorProcessWarningPopupContent: {
        id: "import-from-sources.process-warning-popup.elementErrorProcessWarningPopupContent",
        defaultMessage: "We ran into an issue importing some elements of your document (images, fonts, etc.)."
    }
});
const $367cb45ad482c2d2$var$processWarningData = {
    [(0, $18597b3cce1089d8$export$be905a02dce408ee).PROCESS_IMAGE_ERROR]: {
        heading: $367cb45ad482c2d2$var$i18n.imageErrorProcessWarningPopupTitle,
        content: $367cb45ad482c2d2$var$i18n.imageErrorProcessWarningPopupContent,
        analyticEvent: {
            type: 'sendUIEvent',
            data: {
                source: 'warningSomeImagesModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gotItImportWarningImages'
            }
        }
    },
    [(0, $18597b3cce1089d8$export$be905a02dce408ee).ADF_CONVERSION_ERROR]: {
        heading: $367cb45ad482c2d2$var$i18n.elementErrorProcessWarningPopupTitle,
        content: $367cb45ad482c2d2$var$i18n.elementErrorProcessWarningPopupContent,
        analyticEvent: {
            type: 'sendUIEvent',
            data: {
                source: 'warningSomeElementsModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gotItImportWarningElements'
            }
        }
    }
};
const $367cb45ad482c2d2$export$3e3127b0b10918f7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onSubmit: onSubmit, errorType: errorType, onClose: onClose } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== errorType || $[2] !== onSubmit) {
        t1 = ()=>{
            createAnalyticsEvent($367cb45ad482c2d2$var$processWarningData[errorType].analyticEvent).fire();
            return onSubmit();
        };
        $[0] = createAnalyticsEvent;
        $[1] = errorType;
        $[2] = onSubmit;
        $[3] = t1;
    } else t1 = $[3];
    const onSubmitHandler = t1;
    const t2 = $367cb45ad482c2d2$var$processWarningData[errorType];
    const t3 = $367cb45ad482c2d2$var$processWarningData[errorType];
    let t4;
    if ($[4] !== t3.heading) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t3.heading)));
        $[4] = t3.heading;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = $367cb45ad482c2d2$var$processWarningData[errorType];
    let t6;
    if ($[6] !== t5.content) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t5.content));
        $[6] = t5.content;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $367cb45ad482c2d2$var$i18n.submitProcessWarningPopup);
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== onSubmitHandler) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onSubmitHandler,
            testId: "process-warning-popup-submit-button"
        }, t7));
        $[9] = onSubmitHandler;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== onClose || $[12] !== t2.heading.defaultMessage || $[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($367cb45ad482c2d2$var$ChoreographerModal, {
            onClose: onClose,
            width: 420,
            label: t2.heading.defaultMessage
        }, t4, t6, t8);
        $[11] = onClose;
        $[12] = t2.heading.defaultMessage;
        $[13] = t4;
        $[14] = t6;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ onSubmit: onSubmit, errorType: errorType, onClose: onClose })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubmitHandler = ()=>{
        createAnalyticsEvent($367cb45ad482c2d2$var$processWarningData[errorType].analyticEvent).fire();
        return onSubmit();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($367cb45ad482c2d2$var$ChoreographerModal, {
        onClose: onClose,
        width: 420,
        label: $367cb45ad482c2d2$var$processWarningData[errorType].heading.defaultMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $367cb45ad482c2d2$var$processWarningData[errorType].heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $367cb45ad482c2d2$var$processWarningData[errorType].content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onSubmitHandler,
        testId: "process-warning-popup-submit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $367cb45ad482c2d2$var$i18n.submitProcessWarningPopup))));
};

















const $51c2b0a44cad89ad$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    strictFormatModalTitle: {
        id: "import-from-sources.warning-modal.strictFormatModalTitle",
        defaultMessage: "File format not supported"
    },
    strictFormatModalBody: {
        id: "import-from-sources.warning-modal.strictFormatModalBody",
        defaultMessage: "The .docx file imported was saved as a Strict Open XML. Please save it as Word Document .docx and import again."
    }
});
const $51c2b0a44cad89ad$export$b46d298b389828cd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onSubmit: onSubmit, onClose: onClose } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $51c2b0a44cad89ad$export$a7357cdd1f0b0168.strictFormatModalTitle);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $51c2b0a44cad89ad$export$a7357cdd1f0b0168.strictFormatModalBody);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== onClose || $[3] !== onSubmit) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
            onSubmit: onSubmit,
            onClose: onClose,
            headText: t1,
            bodyText: t2
        });
        $[2] = onClose;
        $[3] = onSubmit;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ onSubmit: onSubmit, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
        onSubmit: onSubmit,
        onClose: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $51c2b0a44cad89ad$export$a7357cdd1f0b0168.strictFormatModalTitle),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $51c2b0a44cad89ad$export$a7357cdd1f0b0168.strictFormatModalBody)
    });
};

















const $bad0ccfe1f1b53b5$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    payloadTooLargeModalTitle: {
        id: "import-from-sources.warning-modal.payloadTooLargeModalTitle",
        defaultMessage: "The content is too long"
    },
    payloadTooLargeModalBody: {
        id: "import-from-sources.warning-modal.payloadTooLargeModalBody",
        defaultMessage: "You can split the content into smaller files and import them separately."
    }
});
const $bad0ccfe1f1b53b5$export$aa741b3b28644cce = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onSubmit: onSubmit, onClose: onClose } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bad0ccfe1f1b53b5$export$a7357cdd1f0b0168.payloadTooLargeModalTitle);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bad0ccfe1f1b53b5$export$a7357cdd1f0b0168.payloadTooLargeModalBody);
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== onClose || $[3] !== onSubmit) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
            onSubmit: onSubmit,
            onClose: onClose,
            headText: t1,
            bodyText: t2
        });
        $[2] = onClose;
        $[3] = onSubmit;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ onSubmit: onSubmit, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
        onSubmit: onSubmit,
        onClose: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bad0ccfe1f1b53b5$export$a7357cdd1f0b0168.payloadTooLargeModalTitle),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bad0ccfe1f1b53b5$export$a7357cdd1f0b0168.payloadTooLargeModalBody)
    });
};

















const $72917a82ebe7fb90$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "import-from-sources.markdown.outcome-unknown.title",
        defaultMessage: "Check whether your page was created"
    },
    body: {
        id: "import-from-sources.markdown.outcome-unknown.body",
        defaultMessage: "We lost the connection after starting page creation. Check the destination page tree before importing again. Support reference: {attemptId}"
    },
    close: {
        id: "import-from-sources.markdown.outcome-unknown.close",
        defaultMessage: "Close"
    }
});
const $72917a82ebe7fb90$export$23bd941d90a0a9a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { attemptId: attemptId, onClose: onClose } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $72917a82ebe7fb90$var$i18n.title);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== attemptId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$72917a82ebe7fb90$var$i18n.body,
            values: {
                attemptId: attemptId
            }
        });
        $[1] = attemptId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $72917a82ebe7fb90$var$i18n.close);
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== onClose || $[5] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaxSo.CommonErrorModal), {
            onClose: onClose,
            onSubmit: onClose,
            headText: t1,
            bodyText: t2,
            submitText: t3,
            hideCloseAction: true,
            suppressSubmitAnalytics: true
        });
        $[4] = onClose;
        $[5] = t2;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ attemptId: attemptId, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaxSo.CommonErrorModal), {
        onClose: onClose,
        onSubmit: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $72917a82ebe7fb90$var$i18n.title),
        bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$72917a82ebe7fb90$var$i18n.body,
            values: {
                attemptId: attemptId
            }
        }),
        submitText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $72917a82ebe7fb90$var$i18n.close),
        hideCloseAction: true,
        suppressSubmitAnalytics: true
    });


const $322dc637d0ac960e$export$6f18d383697961dc = ({ setDraftDiscard: setDraftDiscard, onReimport: onReimport, goToCreatedDraftPage: goToCreatedDraftPage, isDraftDiscard: isDraftDiscard, preserveSourcePage: preserveSourcePage, contentId: contentId, elementProcessingError: elementProcessingError, setElementProcessingError: setElementProcessingError, goToCreatedPage: goToCreatedPage, bulkParentPageId: bulkParentPageId, setBulkParentPageId: setBulkParentPageId, setIsCreatingDraftCancelled: setIsCreatingDraftCancelled, isCancelledDocumentsDeleted: isCancelledDocumentsDeleted })=>{
    const { closeModal: closeModal, showModal: showModal, modalStack: modalStack, docs: docs } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const [deletePagesActionMutation] = (0, $308Wd.useMutationInterop)((0, $7f4892fc402b94a3$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isEnabled: isUploadInOnboardingEnabled, loading: isUploadInOnboardingLoading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const shouldCreateAsLivePage = isLivePage || !isUploadInOnboardingLoading && isUploadInOnboardingEnabled;
    const [isDisabledCancel, setIsDisabledCancel] = (0, $cozmU.useState)(false);
    const isProgressCancelDisabled = isDisabledCancel || Boolean(modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS]?.cancelDisabled);
    //TODO: refactor
    (0, $cozmU.useEffect)(()=>{
        setIsDisabledCancel(Boolean(bulkParentPageId));
    }, [
        bulkParentPageId
    ]);
    const closeModalAndReimport = (modalType)=>{
        closeModal(modalType);
        // CONFDEV-76270: as onReimport call depends on closeModal call result
        // timer here is used for calling onReimport at the end of the call stack
        // when the state of the ImportStrategyContextComponent is fully updated
        setTimeout(()=>{
            onReimport();
        }, 0);
    };
    const handleDiscardModalCreate = (isDraftDiscardRequired)=>{
        setDraftDiscard(isDraftDiscardRequired);
        closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesDISCARD" */ (0, $aGMzc.ImportModalTypes).DISCARD);
    };
    const handleDiscardDraft = async ()=>{
        // contentId is empty when the import was started without an existing draft
        // (e.g. the onboarding CTA in the space side navigation) — nothing to discard.
        if (!preserveSourcePage && isDraftDiscard && contentId) try {
            const subType = shouldCreateAsLivePage ? 'live' : '';
            await (0, $fdac6c26a59eb2dd$export$2e9858c25869c949)(contentId, {
                subType: subType
            });
        } catch (error) {
            return false;
        }
    };
    const handleProgressModalFinishDraft = async ()=>{
        handleDiscardDraft();
        if (elementProcessingError) {
            closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            showModal((0, $aGMzc.ImportModalTypes).PROCESS_ERROR);
            return;
        }
        closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
        goToCreatedDraftPage();
    };
    const handleDeleteUploadedPages = async ()=>{
        try {
            if (bulkParentPageId) {
                setBulkParentPageId(null);
                await deletePagesActionMutation({
                    variables: {
                        input: [
                            {
                                pageID: parseInt(bulkParentPageId, 10),
                                areChildrenIncluded: true,
                                isSelected: true
                            }
                        ]
                    }
                });
            }
        } catch (e) {
            return e;
        }
    };
    const handleProgressModalCancel = ()=>{
        if (isProgressCancelDisabled) return;
        // abort import of the pages that currently in process
        docs.forEach((doc)=>doc.controller?.abort());
        // delete pages that have been imported
        handleDeleteUploadedPages();
        if (modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS].status !== (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR && !modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS].skipDeferredDraftCleanupOnCancel) setIsCreatingDraftCancelled(true);
        closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
    };
    const handleProcessWarningPopupSubmit = ()=>{
        closeModal((0, $aGMzc.ImportModalTypes).PROCESS_ERROR);
        setElementProcessingError(null);
        goToCreatedDraftPage();
    };
    const handleProgressModalFinishPage = async ()=>{
        handleDiscardDraft();
        // Close explicitly rather than relying on navigation unmounting this tree. Entry
        // points outside the editor (e.g. the side navigation) stay mounted across the
        // route change, which would otherwise leave the progress modal open.
        closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
        goToCreatedPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, modalStack[(0, $aGMzc.ImportModalTypes).DISCARD] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $669df68d731a7024$export$5a1c1fd1fd0d9704), {
        onCreate: handleDiscardModalCreate,
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).DISCARD)
    }), modalStack[(0, $aGMzc.ImportModalTypes).FILE_SIZE] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6kn6H.FileSizeModal), {
        fileData: modalStack[(0, $aGMzc.ImportModalTypes).FILE_SIZE],
        onSubmit: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesFILESIZE" */ (0, $aGMzc.ImportModalTypes).FILE_SIZE),
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).FILE_SIZE)
    }), modalStack[(0, $aGMzc.ImportModalTypes).FILE_TYPE] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4d86d67f987f78e$export$502dbbf17b4c1aa6), {
        onSubmit: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesFILETYPE" */ (0, $aGMzc.ImportModalTypes).FILE_TYPE),
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).FILE_TYPE)
    }), modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $234e7a8aa4434be3$export$670b0269826f1fb6), {
        status: modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS].status,
        isDisabledCancel: isProgressCancelDisabled,
        onCancel: handleProgressModalCancel,
        onFinishDraft: handleProgressModalFinishDraft,
        onFinishPage: handleProgressModalFinishPage,
        onRetry: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesPROGRESS" */ (0, $aGMzc.ImportModalTypes).PROGRESS),
        bulkParentPageId: bulkParentPageId,
        isCancelledDocumentsDeleted: isCancelledDocumentsDeleted,
        isAutoLandEnabled: !isUploadInOnboardingLoading && isUploadInOnboardingEnabled,
        warnings: modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS].warnings
    }), modalStack[(0, $aGMzc.ImportModalTypes).OUTCOME_UNKNOWN] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72917a82ebe7fb90$export$23bd941d90a0a9a6), {
        attemptId: modalStack[(0, $aGMzc.ImportModalTypes).OUTCOME_UNKNOWN].attemptId,
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).OUTCOME_UNKNOWN)
    }), modalStack[(0, $aGMzc.ImportModalTypes).UPLOAD_ERROR] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaxSo.CommonErrorModal), {
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).UPLOAD_ERROR),
        onSubmit: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesUPLOADERROR" */ (0, $aGMzc.ImportModalTypes).UPLOAD_ERROR),
        headText: modalStack[(0, $aGMzc.ImportModalTypes).UPLOAD_ERROR].headText,
        bodyText: modalStack[(0, $aGMzc.ImportModalTypes).UPLOAD_ERROR].bodyText,
        submitText: modalStack[(0, $aGMzc.ImportModalTypes).UPLOAD_ERROR].submitText,
        modalWidth: modalStack[(0, $aGMzc.ImportModalTypes).UPLOAD_ERROR].modalWidth
    }), modalStack[(0, $aGMzc.ImportModalTypes).PROCESS_ERROR] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $367cb45ad482c2d2$export$3e3127b0b10918f7), {
        errorType: elementProcessingError,
        onSubmit: handleProcessWarningPopupSubmit,
        onClose: ()=>{
            closeModal((0, $aGMzc.ImportModalTypes).PROCESS_ERROR);
            setElementProcessingError(null);
        }
    }), modalStack[(0, $aGMzc.ImportModalTypes).RESTRICTION] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4656d114e9417da4$export$902ffe599d4c6641), {
        onClose: modalStack[(0, $aGMzc.ImportModalTypes).RESTRICTION].onCancel,
        onSubmit: modalStack[(0, $aGMzc.ImportModalTypes).RESTRICTION].onConfirm
    }), modalStack[(0, $aGMzc.ImportModalTypes).BULK_LIMIT] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a8a6277a6ac150aa$export$ee52fc01a50ec016), {
        onClose: modalStack[(0, $aGMzc.ImportModalTypes).BULK_LIMIT].onCancel,
        onRetry: modalStack[(0, $aGMzc.ImportModalTypes).BULK_LIMIT].onConfirm
    }), modalStack[(0, $aGMzc.ImportModalTypes).STRICT_FORMAT_ERROR] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51c2b0a44cad89ad$export$b46d298b389828cd), {
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).STRICT_FORMAT_ERROR),
        onSubmit: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesSTRICTFORMATERROR" */ (0, $aGMzc.ImportModalTypes).STRICT_FORMAT_ERROR)
    }), modalStack[(0, $aGMzc.ImportModalTypes).PAYLOAD_TOO_LARGE] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bad0ccfe1f1b53b5$export$aa741b3b28644cce), {
        onClose: ()=>closeModal((0, $aGMzc.ImportModalTypes).PAYLOAD_TOO_LARGE),
        onSubmit: ()=>closeModalAndReimport(/* webpackChunkName: "loadable-ImportModalTypesPAYLOADTOOLARGE" */ (0, $aGMzc.ImportModalTypes).PAYLOAD_TOO_LARGE)
    }));
};


























var $8MCjw = parcelRequire("8MCjw");





const $6d0f0c81ce511a8d$export$c603015e0feebdbc = (errors)=>{
    return errors.some((error)=>error.type === (0, $18597b3cce1089d8$export$be905a02dce408ee).ADF_CONVERSION_ERROR) ? (0, $18597b3cce1089d8$export$be905a02dce408ee).ADF_CONVERSION_ERROR : (0, $18597b3cce1089d8$export$be905a02dce408ee).PROCESS_IMAGE_ERROR;
};



var $8ARcf = parcelRequire("8ARcf");


var $eImq9 = parcelRequire("eImq9");






var $k91X3 = parcelRequire("k91X3");

const $400742f0f2e900ff$var$isExpectedAbort = (error)=>error === (0, $7twp9.REQUEST_ABORTED) || error instanceof Error && Reflect.get(error, 'code') === 'aborted';
const $400742f0f2e900ff$export$7a303371fcf9e4d2 = (handleUploadFileWithDiscard, setCreatedDraftId, setImportedDraftPageData, setElementProcessingError, importStrategy, currentSpace, parentPageId, _restrictionType, subType, setImportedPageData, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions = false)=>{
    const { showModal: showModal, closeModal: closeModal, updateModalData: updateModalData } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { isEnabled: isUploadInOnboardingEnabled, loading: isUploadInOnboardingLoading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const fileSizeCheck = (0, $8ARcf.useFileSizeCheck)();
    const handleDocumentProcessingErrors = (errors)=>{
        if (!errors) return;
        const processErrorType = (0, $6d0f0c81ce511a8d$export$c603015e0feebdbc)(errors);
        setElementProcessingError(processErrorType);
    };
    const addAbortControllerDocuments = (0, $eImq9.useAddAbortControllerDocuments)();
    const isDocumentValid = (document)=>{
        if ((0, $8MCjw.isDocWithWrongType)(document.type)) {
            showModal((0, $aGMzc.ImportModalTypes).FILE_TYPE);
            return false;
        }
        return fileSizeCheck(document);
    };
    const validateDocumentAndCloseProgress = (document_0)=>{
        if (!isDocumentValid(document_0)) {
            closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            return false;
        }
        return true;
    };
    const parseErrorCode = async (error)=>{
        try {
            const errorBody = await error.response?.json();
            return errorBody?.error?.code;
        /* eslint-disable @typescript-eslint/no-unused-vars */ } catch (e) {
            return;
        }
    };
    const handleCreateParentPage = async ()=>{
        try {
            const folderName = importStrategy.current?.current?.folderName;
            const result = await (0, $fdac6c26a59eb2dd$export$e27fe4356d25ad56)(currentSpace, parentPageId, 'free', subType, folderName, true);
            return result.data.id;
        } catch (err) {
            if (err === (0, $7twp9.REQUEST_ABORTED)) return;
            closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            showModal((0, $aGMzc.ImportModalTypes).UPLOAD_ERROR);
        }
    };
    const handleUpload = async (documents)=>{
        // #TODO Move abort signal merge hook to context to avoid duplications
        // https://jira.atlassian.com/browse/CONFDEV-82060
        const [documentWithAbortSignal] = addAbortControllerDocuments(documents);
        const { doc: doc, signal: signal } = documentWithAbortSignal;
        try {
            const strategy = importStrategy.current?.current;
            const uploadSingle = strategy?.uploadSingle;
            if (uploadSingle) {
                if (hasSourceRestrictions) throw new (0, $k91X3.MarkdownImportError)('invalid_destination');
                if (!spaceId) throw new Error('A numeric space ID is required for this import strategy');
                const resolvedParentPageId = strategy.resolveParentPage ? await strategy.resolveParentPage({
                    spaceId: spaceId,
                    spaceKey: currentSpace,
                    parentPageId: parentPageId,
                    signal: signal
                }) : parentPageId;
                const { data: data, errors: errors_0, warnings: warnings } = await uploadSingle(doc, {
                    spaceId: spaceId,
                    spaceKey: currentSpace,
                    parentPageId: resolvedParentPageId,
                    signal: signal,
                    onCreateDispatch: ()=>updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                            cancelDisabled: true
                        })
                });
                setCreatedDraftId(data.id);
                setImportedDraftPageData(data);
                handleDocumentProcessingErrors(errors_0);
                updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                    status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS,
                    ...warnings?.length ? {
                        warnings: warnings
                    } : {}
                });
                return;
            }
            const isExperimentActive = !isUploadInOnboardingLoading && isUploadInOnboardingEnabled;
            const createdParentPageId = isExperimentActive ? await handleCreateParentPage() : undefined;
            if (isExperimentActive && !createdParentPageId) return;
            if (isExperimentActive && createdParentPageId) setImportedPageData({
                id: createdParentPageId,
                space: currentSpace
            });
            const uploadOptions = {
                signal: signal
            };
            if (createdParentPageId) uploadOptions.createdBulkParentPageId = createdParentPageId;
            const { data: data_0, errors: errors_1 } = await handleUploadFileWithDiscard(doc, uploadOptions);
            setCreatedDraftId(data_0.id);
            setImportedDraftPageData(data_0);
            // When the experiment created a separate parent page for the import, the blank page
            // that was originally created (e.g. via handleImportCTAClick) is not replaced by the
            // normal discard mechanism. Delete it explicitly.
            if (isExperimentActive && createdParentPageId && deleteOnboardingBlankPage) deleteOnboardingBlankPage();
            handleDocumentProcessingErrors(errors_1);
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS
            });
        } catch (error_0) {
            closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            if (!$400742f0f2e900ff$var$isExpectedAbort(error_0)) {
                if (error_0 instanceof (0, $k91X3.MarkdownImportError) && error_0.code === 'outcome_unknown') {
                    showModal((0, $aGMzc.ImportModalTypes).OUTCOME_UNKNOWN, {
                        attemptId: error_0.attemptId
                    });
                    return;
                }
                const errorCode = await parseErrorCode(error_0);
                if ((0, $aGMzc.ImportModalTypes)[errorCode]) showModal((0, $aGMzc.ImportModalTypes)[errorCode]);
                else showModal((0, $aGMzc.ImportModalTypes).UPLOAD_ERROR);
            }
        }
    };
    const validateBeforeProgress = async (documents_0)=>{
        const importStrategyRef = importStrategy.current;
        if (importStrategyRef.current.validateSingleUploadBeforeProgress) return importStrategyRef.current.validateSingleUploadBeforeProgress(documents_0);
        const isValid = validateDocumentAndCloseProgress(documents_0[0]);
        return isValid ? documents_0 : false;
    };
    const handleFilesBeforeUpload = async (documents_1)=>{
        // don't use destructuring on the top of the file to keep the link to the original strategy
        const importStrategyRef_0 = importStrategy.current;
        if (importStrategyRef_0.current.exportFile) {
            const exportedDoc = await importStrategyRef_0.current.exportFile(documents_1[0], false);
            return exportedDoc ? [
                exportedDoc
            ] : [];
        }
        return documents_1;
    };
    const validateBeforeUpload = async (documents_2)=>{
        // don't use destructuring on the top of the file to keep the link to the original strategy
        const importStrategyRef_1 = importStrategy.current;
        if (importStrategyRef_1.current.validateSingleBeforeUpload) return importStrategyRef_1.current.validateSingleBeforeUpload(documents_2);
        const filteredDocs = documents_2.filter((item)=>!!item);
        return filteredDocs.length ? filteredDocs : false;
    };
    return {
        handleUpload: handleUpload,
        validateBeforeProgress: validateBeforeProgress,
        handleFilesBeforeUpload: handleFilesBeforeUpload,
        validateBeforeUpload: validateBeforeUpload
    };
};











































const $943cdc6df47c602a$export$dbee0f8687885b77 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { updateModalData: updateModalData, docActions: t0 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocFailure: uploadDocFailure } = t0;
    let t1;
    if ($[0] !== updateModalData || $[1] !== uploadDocFailure) {
        t1 = (documents)=>{
            const filtered = documents.filter($943cdc6df47c602a$var$_temp);
            if (!filtered.length) {
                updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                    status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR
                });
                return [];
            }
            return filtered.map((doc_0)=>{
                if ((0, $8MCjw.isDocWithWrongType)(doc_0.type)) {
                    uploadDocFailure(doc_0.name, {
                        type: (0, $9ZvQo.DocErrors).TYPE_ERROR,
                        role: (0, $9ZvQo.ErrorRoles).ERROR
                    });
                    return null;
                }
                if ((0, $8MCjw.DocExceededSizeLimit)(doc_0.size, (0, $dfcSL.FILE_UPLOAD_LIMIT_BULK))) {
                    uploadDocFailure(doc_0.name, {
                        type: (0, $9ZvQo.DocErrors).SIZE_LOCAL_ERROR,
                        role: (0, $9ZvQo.ErrorRoles).ERROR
                    });
                    return null;
                }
                return doc_0;
            }).filter($943cdc6df47c602a$var$_temp2);
        };
        $[0] = updateModalData;
        $[1] = uploadDocFailure;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { updateModalData: updateModalData, docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)((documents)=>{
        const filtered = documents.filter((doc)=>doc);
        if (!filtered.length) {
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR
            });
            return [];
        }
        return filtered.map((doc_0)=>{
            if ((0, $8MCjw.isDocWithWrongType)(doc_0.type)) {
                uploadDocFailure(doc_0.name, {
                    type: (0, $9ZvQo.DocErrors).TYPE_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return null;
            }
            if ((0, $8MCjw.DocExceededSizeLimit)(doc_0.size, (0, $dfcSL.FILE_UPLOAD_LIMIT_BULK))) {
                uploadDocFailure(doc_0.name, {
                    type: (0, $9ZvQo.DocErrors).SIZE_LOCAL_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return null;
            }
            return doc_0;
        }).filter((doc_1)=>doc_1);
    }, [
        updateModalData,
        uploadDocFailure
    ]);
};
function $943cdc6df47c602a$var$_temp(doc) {
    return doc;
}
function $943cdc6df47c602a$var$_temp2(doc_1) {
    return doc_1;
}

















var $f7c9d10aaf355542$export$557dd33f559beb85 = /*#__PURE__*/ function(BulkUploadErrors) {
    BulkUploadErrors["ALL_REJECTED_ERROR"] = "ALL_REJECTED_ERROR";
    return BulkUploadErrors;
}({});
const $f7c9d10aaf355542$export$2d1ed99e15424e6c = (0, $3u0dr.isReactCompilerActiveV2)() ? (setBulkError)=>{
    const $ = (0, $bDgLe.c)(3);
    const { docActions: t0 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocFailure: uploadDocFailure } = t0;
    let t1;
    if ($[0] !== setBulkError || $[1] !== uploadDocFailure) {
        t1 = async (response, documents)=>{
            const rejectedResults = response.filter($f7c9d10aaf355542$var$_temp);
            if (!rejectedResults.length) return;
            await Promise.allSettled(rejectedResults.map(async (res)=>{
                const { error: error } = await res.reason.response.json();
                if ((0, $9ZvQo.DocErrors)[error?.code]) return uploadDocFailure(error.docTitle, {
                    type: (0, $9ZvQo.DocErrors)[error.code],
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
                return uploadDocFailure(error.docTitle, {
                    type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
            }));
            if (rejectedResults.length == documents.length) {
                setBulkError("ALL_REJECTED_ERROR");
                throw "ALL_REJECTED_ERROR";
            }
        };
        $[0] = setBulkError;
        $[1] = uploadDocFailure;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (setBulkError)=>{
    const { docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)(async (response, documents)=>{
        const rejectedResults = response.filter((item)=>item.status === 'rejected');
        if (!rejectedResults.length) return;
        await Promise.allSettled(rejectedResults.map(async (res)=>{
            const { error: error } = await res.reason.response.json();
            if ((0, $9ZvQo.DocErrors)[error?.code]) return uploadDocFailure(error.docTitle, {
                type: (0, $9ZvQo.DocErrors)[error.code],
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
            return uploadDocFailure(error.docTitle, {
                type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
        }));
        if (rejectedResults.length == documents.length) {
            setBulkError("ALL_REJECTED_ERROR");
            throw "ALL_REJECTED_ERROR";
        }
    }, [
        uploadDocFailure,
        setBulkError
    ]);
};
function $f7c9d10aaf355542$var$_temp(item) {
    return item.status === "rejected";
}


















const $daddfad19dc9d276$export$8d14f12b6442b177 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { docActions: t0 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocFailure: uploadDocFailure } = t0;
    let t1;
    if ($[0] !== uploadDocFailure) {
        t1 = (title, errors)=>uploadDocFailure(title, {
                type: (0, $6d0f0c81ce511a8d$export$c603015e0feebdbc)(errors),
                role: (0, $9ZvQo.ErrorRoles).WARNING
            });
        $[0] = uploadDocFailure;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { docActions: { uploadDocFailure: uploadDocFailure } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)((title, errors)=>{
        return uploadDocFailure(title, {
            type: (0, $6d0f0c81ce511a8d$export$c603015e0feebdbc)(errors),
            role: (0, $9ZvQo.ErrorRoles).WARNING
        });
    }, [
        uploadDocFailure
    ]);
};













const $9f5c30c3ff31354e$export$e7d72f4d6b03e178 = (docs, setBulkError)=>{
    const notLoadedErrors = [
        (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR,
        (0, $9ZvQo.DocErrors).NOT_UNIQ_TITLE,
        (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
        (0, $9ZvQo.DocErrors).STRICT_FORMAT_ERROR,
        (0, $9ZvQo.DocErrors).PAYLOAD_TOO_LARGE
    ];
    const notLoadedDocuments = docs.filter((doc)=>{
        const errorType = doc.error?.type;
        return notLoadedErrors.includes(errorType);
    });
    if (notLoadedDocuments.length == docs.length) {
        setBulkError((0, $f7c9d10aaf355542$export$557dd33f559beb85).ALL_REJECTED_ERROR);
        throw (0, $f7c9d10aaf355542$export$557dd33f559beb85).ALL_REJECTED_ERROR;
    }
};















/**
 * @generated SignedSource<<29b50ec3d783dd47f96131bd304543d9>>
 * @relayHash 2889869bb927e439de517c726513b15d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46263b7b9d87568ae18db5da5a414bfa456215494e7bacb65d86ad0fd9d66698
const $8e398947aecdd6a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeletePagesPayload",
            "kind": "LinkedField",
            "name": "deletePages",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHandleDeleteParentPageMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHandleDeleteParentPageMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2889869bb927e439de517c726513b15d",
            "id": "46263b7b9d87568ae18db5da5a414bfa456215494e7bacb65d86ad0fd9d66698",
            "metadata": {},
            "name": "useHandleDeleteParentPageMutation",
            "operationKind": "mutation",
            "text": "mutation useHandleDeleteParentPageMutation($input:[DeletePagesInput]!){deletePages(input:$input){taskId,status}}"
        }
    };
}();
$8e398947aecdd6a6$var$node.hash = "f331630de0b51709e0fd597ffc496eb6";
var $8e398947aecdd6a6$export$2e2bcd8739ae039 = $8e398947aecdd6a6$var$node;









const $1f24d9acde2c5926$export$4020c609e14f036 = (0, $3u0dr.isReactCompilerActiveV2)() ? (bulkError, bulkParentPageId, setBulkParentPageId)=>{
    const $ = (0, $bDgLe.c)(6);
    const [deletePagesActionMutation] = (0, $308Wd.useMutationInterop)((0, $8e398947aecdd6a6$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    let t0;
    let t1;
    if ($[0] !== bulkError || $[1] !== bulkParentPageId || $[2] !== deletePagesActionMutation || $[3] !== setBulkParentPageId) {
        t0 = ()=>{
            if (bulkParentPageId && bulkError === (0, $f7c9d10aaf355542$export$557dd33f559beb85).ALL_REJECTED_ERROR) {
                const executeDeleteParentPage = async ()=>{
                    try {
                        setBulkParentPageId(null);
                        await deletePagesActionMutation({
                            variables: {
                                input: [
                                    {
                                        pageID: parseInt(bulkParentPageId, 10),
                                        areChildrenIncluded: true,
                                        isSelected: true
                                    }
                                ]
                            }
                        });
                    } catch (t2) {
                        const e = t2;
                        return e;
                    }
                };
                executeDeleteParentPage();
            }
        };
        t1 = [
            bulkParentPageId,
            bulkError,
            setBulkParentPageId,
            deletePagesActionMutation
        ];
        $[0] = bulkError;
        $[1] = bulkParentPageId;
        $[2] = deletePagesActionMutation;
        $[3] = setBulkParentPageId;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (bulkError, bulkParentPageId, setBulkParentPageId)=>{
    const [deletePagesActionMutation] = (0, $308Wd.useMutationInterop)((0, $8e398947aecdd6a6$export$2e2bcd8739ae039), {
        __callerPackage__: "import-from-sources"
    });
    (0, $cozmU.useEffect)(()=>{
        if (bulkParentPageId && bulkError === (0, $f7c9d10aaf355542$export$557dd33f559beb85).ALL_REJECTED_ERROR) {
            const executeDeleteParentPage = async ()=>{
                try {
                    setBulkParentPageId(null);
                    await deletePagesActionMutation({
                        variables: {
                            input: [
                                {
                                    pageID: parseInt(bulkParentPageId, 10),
                                    areChildrenIncluded: true,
                                    isSelected: true
                                }
                            ]
                        }
                    });
                } catch (e) {
                    return e;
                }
            };
            executeDeleteParentPage();
        }
    }, [
        bulkParentPageId,
        bulkError,
        setBulkParentPageId,
        deletePagesActionMutation
    ]);
};






var $jK2OK = parcelRequire("jK2OK");
















const $43b1af244601afad$export$e55e8f991b5b55bd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { showConfirmModal: showConfirmModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    let t0;
    if ($[0] !== showConfirmModal) {
        t0 = async ()=>showConfirmModal((0, $aGMzc.ImportModalTypes).RESTRICTION);
        $[0] = showConfirmModal;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { showConfirmModal: showConfirmModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)(async ()=>showConfirmModal((0, $aGMzc.ImportModalTypes).RESTRICTION), [
        showConfirmModal
    ]);
};



var $hPg0A = parcelRequire("hPg0A");

const $6f06ae5dd92c9f61$export$7026b707909c302e = async (documents, exportFn)=>{
    const files = await Promise.allSettled(documents.map(async (doc)=>{
        return exportFn(doc, true);
    }));
    // @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    return files.filter((res)=>res.status === 'fulfilled').map((res)=>res.value);
};








const $3600bb79e67ceace$var$aggregateWarnings = (warnings)=>{
    const warningCounts = new Map();
    warnings.forEach(({ code: code, count: count })=>{
        warningCounts.set(code, (warningCounts.get(code) ?? 0) + count);
    });
    return Array.from(warningCounts, ([code, count])=>({
            code: code,
            count: count
        }));
};
const $3600bb79e67ceace$export$498cac9d3a227481 = (setIsCancelledDocumentsDeleted, currentSpace, restrictionType, parentPageId, handleUploadFileWithDiscard, setImportedPageData, importStrategy, subType, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions = false)=>{
    const { showModal: showModal, closeModal: closeModal, updateModalData: updateModalData, docs: docs, docActions: { uploadDocFailure: uploadDocFailure, uploadDocSuccess: uploadDocSuccess } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const [bulkError, setBulkError] = (0, $cozmU.useState)(null);
    const validateBulkDocuments = (0, $943cdc6df47c602a$export$dbee0f8687885b77)();
    const handleRejectedDocuments = (0, $f7c9d10aaf355542$export$2d1ed99e15424e6c)(setBulkError);
    const handleBulkProcessingErrors = (0, $daddfad19dc9d276$export$8d14f12b6442b177)();
    const addAbortControllerDocuments = (0, $eImq9.useAddAbortControllerDocuments)();
    const [bulkParentPageId, setBulkParentPageId] = (0, $cozmU.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const showRestrictionWarningModal = (0, $43b1af244601afad$export$e55e8f991b5b55bd)();
    const bulkLimitCheck = (0, $hPg0A.useBulkLimitCheck)();
    const { isEnabled: isUploadInOnboardingEnabled, loading: isUploadInOnboardingLoading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const isExperimentActive = !isUploadInOnboardingLoading && isUploadInOnboardingEnabled;
    const isIndependentPagesImport = importStrategy.current?.current?.bulkImportMode === 'independent-pages';
    (0, $1f24d9acde2c5926$export$4020c609e14f036)(bulkError, bulkParentPageId, setBulkParentPageId);
    //TODO: WTF?
    const docsRef = (0, $cozmU.useRef)(docs);
    docsRef.current = docs;
    const handleDeleteCancelledDocuments = ()=>{
        setIsCancelledDocumentsDeleted(false);
        const cancelledDocuments = docsRef.current.filter((doc)=>doc.error?.type === (0, $9ZvQo.DocErrors).REQUEST_ABORTED_ERROR && doc.id);
        try {
            cancelledDocuments.forEach(async (cancelledDoc)=>{
                await (0, $fdac6c26a59eb2dd$export$2e9858c25869c949)(cancelledDoc.id, {
                    isPublicPage: true
                });
            });
        } catch (e) {
            return;
        }
        setIsCancelledDocumentsDeleted(true);
        (0, $9f5c30c3ff31354e$export$e7d72f4d6b03e178)(docsRef.current, setBulkError);
    };
    const handleCreateParentPage = async ()=>{
        try {
            const folderName = isExperimentActive ? importStrategy.current?.current?.folderName : undefined;
            const effectiveRestrictionType = isExperimentActive ? 'free' : restrictionType;
            const createParentPageResult = folderName ? await (0, $fdac6c26a59eb2dd$export$e27fe4356d25ad56)(currentSpace, parentPageId, effectiveRestrictionType, subType, folderName, true) : await (0, $fdac6c26a59eb2dd$export$e27fe4356d25ad56)(currentSpace, parentPageId, effectiveRestrictionType, subType);
            const { data: { id: id } } = createParentPageResult;
            setBulkParentPageId(id);
            return id;
        } catch (err) {
            if (err === (0, $7twp9.REQUEST_ABORTED)) return;
            closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            //TODO: refactor: create a separate modal
            showModal((0, $aGMzc.ImportModalTypes).UPLOAD_ERROR, {
                headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iaxSo.i18n).failedBulkImportPopupTitle),
                bodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $iaxSo.i18n).failedBulkImportPopupContent),
                submitText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $a8a6277a6ac150aa$export$a7357cdd1f0b0168).bulkLimitModalDialogRetryAction),
                modalWidth: 'small'
            });
        }
    };
    const sendBulkAnalytics = (actionSubjectId, attributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'IFSBulkUpload',
                action: 'clicked',
                actionSubject: 'bulkUploads',
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...attributes
                }
            }
        }).fire();
    };
    const validateDocuments = (documents)=>{
        const validatedDocuments = validateBulkDocuments(documents);
        if (!validatedDocuments.length) {
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR
            });
            return false;
        }
        return validatedDocuments;
    };
    const handleIndependentPagesUpload = async (documents_0)=>{
        const uploadSingle = importStrategy.current?.current?.uploadSingle;
        if (!uploadSingle || !spaceId || hasSourceRestrictions) {
            documents_0.forEach(({ doc: doc_0 })=>{
                uploadDocFailure(doc_0.name, {
                    type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                    role: (0, $9ZvQo.ErrorRoles).ERROR
                });
            });
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR
            });
            return;
        }
        let successfulUploads = 0;
        const warnings = [];
        const resolveParentPage = importStrategy.current?.current?.resolveParentPage;
        const resolvedParentPageId = resolveParentPage && documents_0[0] ? await resolveParentPage({
            spaceId: spaceId,
            spaceKey: currentSpace,
            parentPageId: parentPageId,
            signal: documents_0[0].signal
        }) : parentPageId;
        for (const { doc: doc_1, signal: signal } of documents_0)try {
            const { data: data, errors: errors, warnings: documentWarnings = [] } = await uploadSingle(doc_1, {
                spaceId: spaceId,
                spaceKey: currentSpace,
                parentPageId: resolvedParentPageId,
                signal: signal,
                onCreateDispatch: ()=>updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                        cancelDisabled: true
                    })
            });
            const documentTitle = (0, $k7Q8j.getFileNameWithoutExtension)(doc_1.name);
            if (errors) handleBulkProcessingErrors(documentTitle, errors);
            uploadDocSuccess(doc_1.name, data.id);
            if (successfulUploads === 0) setImportedPageData({
                id: data.id,
                space: currentSpace
            });
            successfulUploads += 1;
            warnings.push(...documentWarnings);
        } catch (error) {
            if (error instanceof (0, $k91X3.MarkdownImportError) && error.code === 'outcome_unknown') {
                closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
                showModal((0, $aGMzc.ImportModalTypes).OUTCOME_UNKNOWN, {
                    attemptId: error.attemptId
                });
                return;
            }
            uploadDocFailure(doc_1.name, {
                type: (0, $9ZvQo.DocErrors).FAILED_UPLOAD_ERROR,
                role: (0, $9ZvQo.ErrorRoles).ERROR
            });
        }
        const aggregatedWarnings = $3600bb79e67ceace$var$aggregateWarnings(warnings);
        const status = successfulUploads > 0 ? (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS : (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR;
        updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
            status: status,
            ...status === (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR ? {
                cancelDisabled: false
            } : {},
            ...aggregatedWarnings.length ? {
                warnings: aggregatedWarnings
            } : {}
        });
    };
    const handleUpload = async (documents_1)=>{
        const importStrategyRef = importStrategy.current;
        //TODO: move it
        setBulkError(null);
        const validatedDocuments_0 = isIndependentPagesImport ? documents_1.filter((document)=>document !== null) : validateDocuments(documents_1);
        if (!validatedDocuments_0) return;
        const validatedDocumentsWithAbortSignal = addAbortControllerDocuments(validatedDocuments_0);
        try {
            sendBulkAnalytics(`${importStrategyRef.current.key}BulkUpload`, {
                documentsCount: documents_1.length
            });
            if (isIndependentPagesImport) {
                await handleIndependentPagesUpload(validatedDocumentsWithAbortSignal);
                return;
            }
            const createdBulkParentPageId = await handleCreateParentPage();
            if (!createdBulkParentPageId) return false;
            setImportedPageData({
                id: createdBulkParentPageId,
                space: currentSpace
            });
            //TODO: move into a function
            const response = await Promise.allSettled(validatedDocumentsWithAbortSignal.map(async ({ doc: doc_2, signal: signal_0 })=>{
                const { data: { title: title, id: id_0 }, errors: errors_0 } = await handleUploadFileWithDiscard(doc_2, {
                    createdBulkParentPageId: createdBulkParentPageId,
                    isBulkUpload: true,
                    signal: signal_0
                });
                if (errors_0) handleBulkProcessingErrors(title, errors_0);
                uploadDocSuccess(title, id_0);
                return id_0;
            }).filter((id_1)=>id_1));
            await handleRejectedDocuments(response, validatedDocuments_0);
            handleDeleteCancelledDocuments();
            // When the experiment created a separate parent page for the bulk import, the blank page
            // originally created (e.g. via handleImportCTAClick) is not replaced by the normal discard
            // mechanism. Delete it explicitly.
            if (isExperimentActive && createdBulkParentPageId && deleteOnboardingBlankPage) deleteOnboardingBlankPage();
            // When the experiment is active, navigate to the first successfully uploaded child page
            // instead of the parent folder so the user lands on actual imported content.
            if (isExperimentActive) {
                const firstFulfilledId = response.find((r)=>r.status === 'fulfilled' && !!r.value)?.value;
                if (firstFulfilledId) setImportedPageData({
                    id: firstFulfilledId,
                    space: currentSpace
                });
            }
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).SUCCESS
            });
        } catch (error_0) {
            updateModalData((0, $aGMzc.ImportModalTypes).PROGRESS, {
                status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).ERROR
            });
        }
    };
    const restrictionCheck = async ()=>{
        if (restrictionType !== (0, $jK2OK.parentPageTypes).RESTRICTED && !isExperimentActive) return showRestrictionWarningModal();
        return true;
    };
    const validateBeforeProgress = async (documents_2)=>{
        // don't use destructuring on the top of the file to keep the link to the original strategy
        const importStrategyRef_0 = importStrategy.current;
        if (!await restrictionCheck()) return false;
        const documentsWithinBulkLimits = isIndependentPagesImport ? await bulkLimitCheck(documents_2) : documents_2;
        if (!documentsWithinBulkLimits) return false;
        if (importStrategyRef_0.current.validateBulkUploadBeforeProgress) return importStrategyRef_0.current.validateBulkUploadBeforeProgress(documentsWithinBulkLimits);
        return bulkLimitCheck(documents_2);
    };
    const handleFilesBeforeUpload = async (documents_3)=>{
        // don't use destructuring on the top of the file to keep the link to the original setrategy
        const importStrategyRef_1 = importStrategy.current;
        if (importStrategyRef_1.current.exportFile) return (0, $6f06ae5dd92c9f61$export$7026b707909c302e)(documents_3, importStrategyRef_1.current.exportFile);
        return documents_3;
    };
    const validateBeforeUpload = async (documents_4)=>{
        // don't use destructuring on the top of the file to keep the link to the original strategy
        const importStrategyRef_2 = importStrategy.current;
        if (importStrategyRef_2.current.validateBulkBeforeUpload) return importStrategyRef_2.current.validateBulkBeforeUpload(documents_4);
        return validateDocuments(documents_4);
    };
    return {
        handleUpload: handleUpload,
        validateBeforeProgress: validateBeforeProgress,
        handleFilesBeforeUpload: handleFilesBeforeUpload,
        validateBeforeUpload: validateBeforeUpload
    };
};


const $dde36a42fd9d543c$export$388005f0f0e38bef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { setCreatedDraftId: setCreatedDraftId, setImportedDraftPageData: setImportedDraftPageData, setElementProcessingError: setElementProcessingError, setIsCancelledDocumentsDeleted: setIsCancelledDocumentsDeleted, currentSpace: currentSpace, restrictionType: restrictionType, parentPageId: parentPageId, handleUploadFileWithDiscard: handleUploadFileWithDiscard, setImportedPageData: setImportedPageData, importStrategyRef: importStrategyRef, subType: subType, deleteOnboardingBlankPage: deleteOnboardingBlankPage, spaceId: spaceId, hasSourceRestrictions: hasSourceRestrictions } = t0;
    const singleStrategy = (0, $400742f0f2e900ff$export$7a303371fcf9e4d2)(handleUploadFileWithDiscard, setCreatedDraftId, setImportedDraftPageData, setElementProcessingError, importStrategyRef, currentSpace, parentPageId, restrictionType, subType, setImportedPageData, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions);
    const bulkStrategy = (0, $3600bb79e67ceace$export$498cac9d3a227481)(setIsCancelledDocumentsDeleted, currentSpace, restrictionType, parentPageId, handleUploadFileWithDiscard, setImportedPageData, importStrategyRef, subType, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions);
    let t1;
    if ($[0] !== bulkStrategy || $[1] !== singleStrategy) {
        t1 = (isBulk)=>isBulk ? bulkStrategy : singleStrategy;
        $[0] = bulkStrategy;
        $[1] = singleStrategy;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ setCreatedDraftId: setCreatedDraftId, setImportedDraftPageData: setImportedDraftPageData, setElementProcessingError: setElementProcessingError, setIsCancelledDocumentsDeleted: setIsCancelledDocumentsDeleted, currentSpace: currentSpace, restrictionType: restrictionType, parentPageId: parentPageId, handleUploadFileWithDiscard: handleUploadFileWithDiscard, setImportedPageData: setImportedPageData, importStrategyRef: importStrategyRef, subType: subType, deleteOnboardingBlankPage: deleteOnboardingBlankPage, spaceId: spaceId, hasSourceRestrictions: hasSourceRestrictions })=>{
    const singleStrategy = (0, $400742f0f2e900ff$export$7a303371fcf9e4d2)(handleUploadFileWithDiscard, setCreatedDraftId, setImportedDraftPageData, setElementProcessingError, importStrategyRef, currentSpace, parentPageId, restrictionType, subType, setImportedPageData, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions);
    const bulkStrategy = (0, $3600bb79e67ceace$export$498cac9d3a227481)(setIsCancelledDocumentsDeleted, currentSpace, restrictionType, parentPageId, handleUploadFileWithDiscard, setImportedPageData, importStrategyRef, subType, deleteOnboardingBlankPage, spaceId, hasSourceRestrictions);
    return (isBulk)=>isBulk ? bulkStrategy : singleStrategy;
};


const $1dea3360b638051d$var$ImportStrategyContextComponent = ({ hasUserAddedContent: hasUserAddedContent, contentId: contentId, parentPageId: parentPageId, spaceId: spaceId, hasSourceRestrictions: hasSourceRestrictions = false, children: children, currentSpace: currentSpace, restrictionType: restrictionType })=>{
    const importStrategyRef = (0, $cozmU.useRef)(null);
    const goToDraftPage = (0, $40054d1753472ec4$export$740648e9e1f317ac)();
    const goToPage = (0, $e59673e9ec04ccad$export$6c54cc766c157eef)();
    const { showModal: showModal, closeModal: closeModal, docActions: { uploadDocsStart: uploadDocsStart } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const [bulkParentPageId, setBulkParentPageId] = (0, $cozmU.useState)(null);
    //Discard draft should be true by default to delete the page if it's empty
    const [isDraftDiscard, setDraftDiscard] = (0, $cozmU.useState)(true);
    const [createsSeparatePage, setCreatesSeparatePage] = (0, $cozmU.useState)(false);
    const [importedDraftPageData, setImportedDraftPageData] = (0, $cozmU.useState)(null);
    const [importedPageData, setImportedPageData] = (0, $cozmU.useState)(null);
    const [elementProcessingError, setElementProcessingError] = (0, $cozmU.useState)(null);
    const [createdDraftId, setCreatedDraftId] = (0, $cozmU.useState)(null);
    const [isCreatingDraftCancelled, setIsCreatingDraftCancelled] = (0, $cozmU.useState)(false);
    const [isCancelledDocumentsDeleted, setIsCancelledDocumentsDeleted] = (0, $cozmU.useState)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isEnabled: isUploadInOnboardingEnabled, loading: isUploadInOnboardingLoading } = (0, $ix5ga.useTwcg2304ImportInOnboarding)();
    const isExperimentActive = !isUploadInOnboardingLoading && isUploadInOnboardingEnabled;
    const isOnboardingImport = contentId === '' && parentPageId === null;
    const shouldCreateAsLivePage = isLivePage || isExperimentActive;
    // When the upload-in-onboarding experiment is active, the import creates a new parent page
    // rather than replacing the blank page via the originalDraftId discard mechanism. We must
    // explicitly delete the original blank page after a successful import in that case.
    const deleteOnboardingBlankPage = (0, $a913192dc3627179$export$7fff445e9bc9f5c5)(contentId);
    //TODO: don't use useEffect as an event handler. check isCreatingDraftCancelled after draft is created
    (0, $b2241accc91c4476$export$d012c53dc024cf12)({
        createdDraftId: createdDraftId,
        setCreatedDraftId: setCreatedDraftId,
        isCreatingDraftCancelled: isCreatingDraftCancelled,
        setIsCreatingDraftCancelled: setIsCreatingDraftCancelled,
        subType: shouldCreateAsLivePage ? 'live' : ''
    });
    const runImportStrategy = (0, $cozmU.useCallback)(()=>{
        importStrategyRef.current.current.pickDocument();
    }, []);
    // Stable identity so strategies' registerTrigger effects (keyed on onStartStrategy)
    // do not re-run on every parent render.
    const handleStartStrategy = (0, $cozmU.useCallback)((strategyRef)=>{
        importStrategyRef.current = strategyRef;
        const shouldCreateSeparatePage = strategyRef.current.createsSeparatePage === true;
        setCreatesSeparatePage(shouldCreateSeparatePage);
        setDraftDiscard(!shouldCreateSeparatePage);
        if (!shouldCreateSeparatePage && hasUserAddedContent && !isExperimentActive) showModal((0, $aGMzc.ImportModalTypes).DISCARD);
        else runImportStrategy();
    }, [
        hasUserAddedContent,
        isExperimentActive,
        showModal,
        runImportStrategy
    ]);
    const handleUploadFileWithDiscard = (document, options = {})=>{
        const { createdBulkParentPageId: createdBulkParentPageId, isBulkUpload: isBulkUpload, signal: signal } = options;
        // Only onboarding imports preserve the blank page while creating a separate live page.
        const effectiveDraftDiscard = isExperimentActive && isOnboardingImport ? false : isDraftDiscard;
        return (0, $d7928fb9aa00f145$export$a84f95519fdfe50e)({
            document: document,
            pageTitle: (0, $k7Q8j.getFileNameWithoutExtension)(document.name),
            parentPageId: createdBulkParentPageId || parentPageId,
            space: currentSpace,
            contentId: contentId,
            isDraftDiscard: effectiveDraftDiscard,
            importSource: importStrategyRef.current.current.key,
            isBulkUpload: isBulkUpload,
            signal: signal,
            ...shouldCreateAsLivePage && {
                subType: 'live'
            }
        });
    };
    const getUploadStrategy = (0, $dde36a42fd9d543c$export$388005f0f0e38bef)({
        setCreatedDraftId: setCreatedDraftId,
        setImportedDraftPageData: setImportedDraftPageData,
        setElementProcessingError: setElementProcessingError,
        setIsCancelledDocumentsDeleted: setIsCancelledDocumentsDeleted,
        currentSpace: currentSpace,
        restrictionType: restrictionType,
        parentPageId: parentPageId,
        handleUploadFileWithDiscard: handleUploadFileWithDiscard,
        setImportedPageData: setImportedPageData,
        importStrategyRef: importStrategyRef,
        subType: shouldCreateAsLivePage ? 'live' : '',
        deleteOnboardingBlankPage: deleteOnboardingBlankPage,
        spaceId: spaceId,
        hasSourceRestrictions: hasSourceRestrictions
    });
    const handleDocumentSelect = async (documents)=>{
        const uploadStrategy = getUploadStrategy((0, $27bc3d6341d74652$export$885b4341e7c3daaa)(documents));
        //should be before ProgressModal and the validations.
        uploadDocsStart(documents);
        ///////////////////// validation before ProgressModal is shown //////////////////////////
        const validatedDocuments = await uploadStrategy.validateBeforeProgress(documents);
        if (!validatedDocuments) return;
        /////////////////////////////////////////////////////////////////////////////////////////
        showModal((0, $aGMzc.ImportModalTypes).PROGRESS, {
            status: (0, $9b66a54e8ae09aca$export$fad76899145ca0c7).IN_PROGRESS,
            ...importStrategyRef.current?.current.uploadSingle ? {
                skipDeferredDraftCleanupOnCancel: true
            } : {}
        });
        ///////// handle files before unload to server. export files (google or onedrive) ///////
        const handledDocuments = await uploadStrategy.handleFilesBeforeUpload(validatedDocuments);
        /////////////////////////////////////////////////////////////////////////////////////////
        ////////// validate files before upload to server. (validate exported files) ////////////
        const finalDocuments = await uploadStrategy.validateBeforeUpload(handledDocuments);
        if (!finalDocuments) return;
        /////////////////////////////////////////////////////////////////////////////////////////
        uploadStrategy.handleUpload(finalDocuments);
    };
    const handleDocumentSelectError = ()=>{
        closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
        showModal((0, $aGMzc.ImportModalTypes).UPLOAD_ERROR);
    };
    const goToCreatedDraftPage = ()=>{
        goToDraftPage(importedDraftPageData);
    };
    const goToCreatedPage = ()=>{
        goToPage(importedPageData);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $322dc637d0ac960e$export$6f18d383697961dc), {
        isDraftDiscard: isDraftDiscard,
        preserveSourcePage: createsSeparatePage,
        setDraftDiscard: setDraftDiscard,
        onReimport: runImportStrategy,
        goToCreatedDraftPage: goToCreatedDraftPage,
        goToCreatedPage: goToCreatedPage,
        contentId: contentId,
        elementProcessingError: elementProcessingError,
        setElementProcessingError: setElementProcessingError,
        bulkParentPageId: bulkParentPageId,
        setBulkParentPageId: setBulkParentPageId,
        setIsCreatingDraftCancelled: setIsCreatingDraftCancelled,
        isCancelledDocumentsDeleted: isCancelledDocumentsDeleted
    }), children({
        handleStartStrategy: handleStartStrategy,
        handleDocumentSelect: handleDocumentSelect,
        handleDocumentSelectError: handleDocumentSelectError
    }));
};
const $1dea3360b638051d$export$2b7a879d53773c16 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $r3F1B.ImportStateContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1dea3360b638051d$var$ImportStrategyContextComponent, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $r3F1B.ImportStateContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1dea3360b638051d$var$ImportStrategyContextComponent, props));
module.exports["ImportStrategyContext"] = $1dea3360b638051d$export$2b7a879d53773c16;

});

parcelRegister("dUJl3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

var $34ecb5d75c483767$export$e9ba542517e26e98 = /*#__PURE__*/ function(ActiveImports) {
    ActiveImports["NONE"] = "";
    ActiveImports["IMPORT_FROM_LOCAL"] = "wordDoc";
    ActiveImports["IMPORT_FROM_GD"] = "gDoc";
    ActiveImports["IMPORT_FROM_ONE_DRIVE"] = "office365Doc";
    ActiveImports["IMPORT_FROM_MARKDOWN"] = "markdown";
    return ActiveImports;
}({});
const $34ecb5d75c483767$var$i18n = (0, $kSwu1.defineMessages)({
    oneDriveFolderName: {
        id: "import-from-sources.sources-list.oneDriveFolderName",
        defaultMessage: "OneDrive"
    },
    msWordFolderName: {
        id: "import-from-sources.sources-list.msWordFolderName",
        defaultMessage: "Word Documents"
    },
    gdocFolderName: {
        id: "import-from-sources.sources-list.gdocFolderName",
        defaultMessage: "Google Drive"
    },
    markdownFolderName: {
        id: "import-from-sources.sources-list.markdownFolderName",
        defaultMessage: "Markdown"
    }
});
const $34ecb5d75c483767$export$70ef76381365ea9 = {
    ["wordDoc"]: $34ecb5d75c483767$var$i18n.msWordFolderName,
    ["gDoc"]: $34ecb5d75c483767$var$i18n.gdocFolderName,
    ["office365Doc"]: $34ecb5d75c483767$var$i18n.oneDriveFolderName,
    ["markdown"]: $34ecb5d75c483767$var$i18n.markdownFolderName
};
module.exports["ActiveImports"] = $34ecb5d75c483767$export$e9ba542517e26e98;
module.exports["IMPORT_FOLDER_NAMES"] = $34ecb5d75c483767$export$70ef76381365ea9;

});

parcelRegister("7twp9", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $iDEwy = parcelRequire("iDEwy");

const $213fe87ec7151ce4$export$3dc7692b8c6656ca = 'REQUEST_ABORTED';
const $213fe87ec7151ce4$export$4e26ca037d9dd648 = (error)=>{
    return !!(0, $iDEwy.AbortErrors)[error.message?.trim()];
};
const $213fe87ec7151ce4$export$f1051aa427dd5220 = (url, options = {})=>{
    return (0, $f7B1p.cfetch)(url, options).catch((error)=>{
        if (options.signal?.aborted || $213fe87ec7151ce4$export$4e26ca037d9dd648(error)) throw $213fe87ec7151ce4$export$3dc7692b8c6656ca;
        throw error;
    });
};
module.exports["REQUEST_ABORTED"] = $213fe87ec7151ce4$export$3dc7692b8c6656ca;
module.exports["checkForAbortErrorMsg"] = $213fe87ec7151ce4$export$4e26ca037d9dd648;
module.exports["cfetchWithAbort"] = $213fe87ec7151ce4$export$f1051aa427dd5220;

});

parcelRegister("hTMqv", function(module, exports) {
const $956b190db89f8130$export$f2148d4bb476976e = '/gateway/api/import';
module.exports["IFS_API"] = $956b190db89f8130$export$f2148d4bb476976e;

});

parcelRegister("k7Q8j", function(module, exports) {
const $7363e85d61c777e8$export$afd41bce1ef3e9cf = (filename)=>filename.substring(0, filename.lastIndexOf('.docx')) || filename;
module.exports["getFileNameWithoutExtension"] = $7363e85d61c777e8$export$afd41bce1ef3e9cf;

});

parcelRegister("r3F1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bGxBv = parcelRequire("bGxBv");


var $9ZvQo = parcelRequire("9ZvQo");

const $b19e89ee181b2627$export$395529db2098ba9a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $b19e89ee181b2627$export$8127b8a252d600bb = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children } = t0;
    const { showModal: showModal, showConfirmModal: showConfirmModal, closeModal: closeModal, updateModalData: updateModalData, modalStack: modalStack } = (0, $bGxBv.useModals)();
    const { docs: docs, docActions: docActions } = (0, $9ZvQo.useUploadReducer)();
    let t1;
    if ($[0] !== closeModal || $[1] !== docActions || $[2] !== docs || $[3] !== modalStack || $[4] !== showConfirmModal || $[5] !== showModal || $[6] !== updateModalData) {
        t1 = {
            showModal: showModal,
            showConfirmModal: showConfirmModal,
            closeModal: closeModal,
            updateModalData: updateModalData,
            modalStack: modalStack,
            docs: docs,
            docActions: docActions
        };
        $[0] = closeModal;
        $[1] = docActions;
        $[2] = docs;
        $[3] = modalStack;
        $[4] = showConfirmModal;
        $[5] = showModal;
        $[6] = updateModalData;
        $[7] = t1;
    } else t1 = $[7];
    const contextState = t1;
    let t2;
    if ($[8] !== children || $[9] !== contextState) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b19e89ee181b2627$export$395529db2098ba9a.Provider, {
            value: contextState
        }, children);
        $[8] = children;
        $[9] = contextState;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ children: children })=>{
    const { showModal: showModal, showConfirmModal: showConfirmModal, closeModal: closeModal, updateModalData: updateModalData, modalStack: modalStack } = (0, $bGxBv.useModals)();
    const { docs: docs, docActions: docActions } = (0, $9ZvQo.useUploadReducer)();
    const contextState = (0, $cozmU.useMemo)(()=>({
            showModal: showModal,
            showConfirmModal: showConfirmModal,
            closeModal: closeModal,
            updateModalData: updateModalData,
            modalStack: modalStack,
            docs: docs,
            docActions: docActions
        }), [
        showModal,
        showConfirmModal,
        closeModal,
        updateModalData,
        modalStack,
        docs,
        docActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b19e89ee181b2627$export$395529db2098ba9a.Provider, {
        value: contextState
    }, children);
};
module.exports["ImportStateContext"] = $b19e89ee181b2627$export$395529db2098ba9a;
module.exports["ImportStateContextProvider"] = $b19e89ee181b2627$export$8127b8a252d600bb;

});

parcelRegister("aGMzc", function(module, exports) {
var $a92d9805227a3223$export$93f2a311f9fafb3f = /*#__PURE__*/ function(ImportModalTypes) {
    ImportModalTypes["FILE_SIZE"] = "FILE_SIZE";
    ImportModalTypes["FILE_TYPE"] = "FILE_TYPE";
    ImportModalTypes["DISCARD"] = "DISCARD";
    ImportModalTypes["PROGRESS"] = "PROGRESS";
    ImportModalTypes["UPLOAD_ERROR"] = "UPLOAD_ERROR";
    ImportModalTypes["PROCESS_ERROR"] = "PROCESS_ERROR";
    ImportModalTypes["BULK_LIMIT"] = "BULK_LIMIT";
    ImportModalTypes["STRICT_FORMAT_ERROR"] = "STRICT_FORMAT_ERROR";
    ImportModalTypes["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
    ImportModalTypes["RESTRICTION"] = "RESTRICTION";
    ImportModalTypes["OUTCOME_UNKNOWN"] = "OUTCOME_UNKNOWN";
    return ImportModalTypes;
}({});
module.exports["ImportModalTypes"] = $a92d9805227a3223$export$93f2a311f9fafb3f;

});

parcelRegister("6kn6H", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $acRhQ = parcelRequire("acRhQ");

const $5b9806519816c6b8$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    fileTooBig: {
        id: "import-from-sources.warning-modal.fileTooBig",
        defaultMessage: "This file is too big"
    },
    fileExceedsLimit: {
        id: "import-from-sources.warning-modal.fileExceedsLimit",
        defaultMessage: "{fileName} is {fileSize} MB which exceeds the 100 MB limit. You could break the content into smaller files and import them separately."
    }
});
const $5b9806519816c6b8$export$79aef72cb467c398 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { onSubmit: onSubmit, onClose: onClose, fileData: fileData, bodyText: bodyText } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5b9806519816c6b8$export$a7357cdd1f0b0168.fileTooBig);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== bodyText || $[2] !== fileData?.fileName || $[3] !== fileData?.fileSize) {
        t2 = bodyText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$5b9806519816c6b8$export$a7357cdd1f0b0168.fileExceedsLimit,
            values: {
                fileName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileData?.fileName),
                fileSize: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileData?.fileSize)
            }
        });
        $[1] = bodyText;
        $[2] = fileData?.fileName;
        $[3] = fileData?.fileSize;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onClose || $[6] !== onSubmit || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
            onSubmit: onSubmit,
            onClose: onClose,
            headText: t1,
            bodyText: t2
        });
        $[5] = onClose;
        $[6] = onSubmit;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ onSubmit: onSubmit, onClose: onClose, fileData: fileData, bodyText: bodyText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acRhQ.WarningModal), {
        onSubmit: onSubmit,
        onClose: onClose,
        headText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5b9806519816c6b8$export$a7357cdd1f0b0168.fileTooBig),
        bodyText: bodyText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$5b9806519816c6b8$export$a7357cdd1f0b0168.fileExceedsLimit,
            values: {
                fileName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileData?.fileName),
                fileSize: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, fileData?.fileSize)
            }
        })
    });
};
module.exports["FileSizeModal"] = $5b9806519816c6b8$export$79aef72cb467c398;

});

parcelRegister("fytHI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $lsxnT = parcelRequire("lsxnT");

const $63dff4080bc7dbff$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClose: onClose, label: label, width: width } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== label || $[3] !== onClose || $[4] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: width,
            label: label
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = label;
        $[3] = onClose;
        $[4] = width;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, onClose: onClose, label: label, width: width })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: width,
        label: label
    }, children);
};
const $63dff4080bc7dbff$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    uploadErrorAriaLabel: {
        id: "import-from-sources.upload-error.aria-label",
        defaultMessage: "Upload Error Popup"
    }
});
const $63dff4080bc7dbff$export$e1c331f39b7cb853 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { onSubmit: onSubmit, onClose: onClose, headText: headText, bodyText: bodyText, submitText: submitText, closeText: closeText, modalWidth: modalWidth, hideCloseAction: t1, suppressSubmitAnalytics: t2 } = t0;
    const hideCloseAction = t1 === undefined ? false : t1;
    const suppressSubmitAnalytics = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "unableToImportErrorModal",
                    action: "dismissed",
                    actionSubject: "button",
                    actionSubjectId: "closeImportError"
                }
            }).fire();
            return onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = t3;
    } else t3 = $[2];
    const handleCloseClick = t3;
    let t4;
    if ($[3] !== createAnalyticsEvent || $[4] !== onSubmit || $[5] !== suppressSubmitAnalytics) {
        t4 = ()=>{
            if (!suppressSubmitAnalytics) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "unableToImportErrorModal",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "selectDifferentDoc"
                }
            }).fire();
            onSubmit();
        };
        $[3] = createAnalyticsEvent;
        $[4] = onSubmit;
        $[5] = suppressSubmitAnalytics;
        $[6] = t4;
    } else t4 = $[6];
    const handleReimportClick = t4;
    const t5 = modalWidth || "medium";
    let t6;
    if ($[7] !== formatMessage) {
        t6 = formatMessage($63dff4080bc7dbff$export$a7357cdd1f0b0168.uploadErrorAriaLabel);
        $[7] = formatMessage;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== headText) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "danger"
        }, headText));
        $[9] = headText;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== bodyText) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, bodyText);
        $[11] = bodyText;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== closeText || $[14] !== handleCloseClick || $[15] !== hideCloseAction) {
        t9 = !hideCloseAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleCloseClick,
            testId: "upload-error-popup-close"
        }, closeText);
        $[13] = closeText;
        $[14] = handleCloseClick;
        $[15] = hideCloseAction;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== handleReimportClick || $[18] !== submitText) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleReimportClick,
            testId: "upload-error-popup-submit"
        }, submitText);
        $[17] = handleReimportClick;
        $[18] = submitText;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t10));
        $[20] = t10;
        $[21] = t9;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== onClose || $[24] !== t11 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63dff4080bc7dbff$var$ChoreographerModal, {
            onClose: onClose,
            width: t5,
            label: t6
        }, t7, t8, t11);
        $[23] = onClose;
        $[24] = t11;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
} : ({ onSubmit: onSubmit, onClose: onClose, headText: headText, bodyText: bodyText, submitText: submitText, closeText: closeText, modalWidth: modalWidth, hideCloseAction: hideCloseAction = false, suppressSubmitAnalytics: suppressSubmitAnalytics = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleCloseClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'unableToImportErrorModal',
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'closeImportError'
            }
        }).fire();
        return onClose();
    };
    const handleReimportClick = ()=>{
        if (!suppressSubmitAnalytics) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'unableToImportErrorModal',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'selectDifferentDoc'
            }
        }).fire();
        onSubmit();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63dff4080bc7dbff$var$ChoreographerModal, {
        onClose: onClose,
        width: modalWidth || 'medium',
        label: formatMessage($63dff4080bc7dbff$export$a7357cdd1f0b0168.uploadErrorAriaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "danger"
    }, headText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, bodyText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !hideCloseAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCloseClick,
        testId: "upload-error-popup-close"
    }, closeText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleReimportClick,
        testId: "upload-error-popup-submit"
    }, submitText))));
};
module.exports["UploadErrorPopup"] = $63dff4080bc7dbff$export$e1c331f39b7cb853;

});

parcelRegister("8cleY", function(module, exports) {
const $6387bc91b26c856b$export$192d54a49ba763a6 = 30;
module.exports["BULK_UPLOAD_LIMIT"] = $6387bc91b26c856b$export$192d54a49ba763a6;

});

parcelRegister("lo1Qi", function(module, exports) {
const $dc623e239db5e9f5$export$951d4f89ee4a6d52 = (bytes)=>{
    return Math.round(bytes * 0.001) / 1000;
};
module.exports["fixedBytesToMegabytes"] = $dc623e239db5e9f5$export$951d4f89ee4a6d52;

});

parcelRegister("hGnTB", function(module, exports) {

var $dfcSL = parcelRequire("dfcSL");


var $8cleY = parcelRequire("8cleY");

const $988d0fdc70085250$export$c6c4fa67c9df1806 = (documents)=>documents.length > (0, $8cleY.BULK_UPLOAD_LIMIT);
const $988d0fdc70085250$export$ec0f264aeb0acfd1 = (documents)=>{
    return documents.reduce((acc, doc)=>{
        if (doc && doc.size) return acc + doc.size;
        return acc;
    }, 0);
};
const $988d0fdc70085250$export$af4702a2c5cc44b4 = (documents)=>{
    return $988d0fdc70085250$export$ec0f264aeb0acfd1(documents) > (0, $dfcSL.TOTAL_UPLOAD_LIMIT_BULK);
};
module.exports["isBulkLengthLimitReached"] = $988d0fdc70085250$export$c6c4fa67c9df1806;
module.exports["getBulkTotalSize"] = $988d0fdc70085250$export$ec0f264aeb0acfd1;
module.exports["isBulkTotalSizeLimitReached"] = $988d0fdc70085250$export$af4702a2c5cc44b4;

});

parcelRegister("dfcSL", function(module, exports) {
const $9aae84840e9db6aa$export$26d9adf2bb040089 = 100000000; // 100 MB in bytes
const $9aae84840e9db6aa$export$af9674c25e18f3ab = 10000000; // 10 MB in bytes
const $9aae84840e9db6aa$export$afa01bffe3d57476 = 50000000; // 50 MB in bytes
const $9aae84840e9db6aa$export$eae81eb5739dfc8d = $9aae84840e9db6aa$export$af9674c25e18f3ab / Math.pow(1000, 2); // FILE_UPLOAD_LIMIT in bytes
module.exports["FILE_UPLOAD_LIMIT"] = $9aae84840e9db6aa$export$26d9adf2bb040089;
module.exports["FILE_UPLOAD_LIMIT_BULK"] = $9aae84840e9db6aa$export$af9674c25e18f3ab;
module.exports["TOTAL_UPLOAD_LIMIT_BULK"] = $9aae84840e9db6aa$export$afa01bffe3d57476;
module.exports["FILE_UPLOAD_LIMIT_MB"] = $9aae84840e9db6aa$export$eae81eb5739dfc8d;

});

parcelRegister("acRhQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $eQiT1 = parcelRequire("eQiT1");


var $fEPJS = parcelRequire("fEPJS");


var $jq995 = parcelRequire("jq995");


var $9Umtx = parcelRequire("9Umtx");


var $lsxnT = parcelRequire("lsxnT");

const $d3437babdcdbdb10$var$ChoreographerModal = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, onClose: onClose } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t1;
    if ($[0] !== Modal || $[1] !== children || $[2] !== onClose) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: onClose,
            width: 420
        }, children);
        $[0] = Modal;
        $[1] = children;
        $[2] = onClose;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children, onClose: onClose })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: 420
    }, children);
};
const $d3437babdcdbdb10$var$i18n = (0, $kSwu1.defineMessages)({
    cancel: {
        id: "import-from-sources.warning-modal.cancel-btn",
        defaultMessage: "Cancel"
    },
    submit: {
        id: "import-from-sources.warning-modal.submit-btn",
        defaultMessage: "Select new file"
    }
});
const $d3437babdcdbdb10$export$d69de51d0f6180c8 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { onSubmit: onSubmit, onClose: onClose, headText: headText, bodyText: bodyText, submitText: submitText } = t0;
    let t1;
    if ($[0] !== headText) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
            appearance: "warning"
        }, headText));
        $[0] = headText;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== bodyText) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, bodyText);
        $[2] = bodyText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d3437babdcdbdb10$var$i18n.cancel);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onClose,
            testId: "warning-modal-cancel-button"
        }, t3);
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== submitText) {
        t5 = submitText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d3437babdcdbdb10$var$i18n.submit);
        $[7] = submitText;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== onSubmit || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onSubmit,
            testId: "warning-modal-submit-button"
        }, t5);
        $[9] = onSubmit;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t4 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t6));
        $[12] = t4;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== onClose || $[16] !== t1 || $[17] !== t2 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3437babdcdbdb10$var$ChoreographerModal, {
            onClose: onClose
        }, t1, t2, t7);
        $[15] = onClose;
        $[16] = t1;
        $[17] = t2;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ onSubmit: onSubmit, onClose: onClose, headText: headText, bodyText: bodyText, submitText: submitText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3437babdcdbdb10$var$ChoreographerModal, {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, headText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, bodyText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "warning-modal-cancel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d3437babdcdbdb10$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onSubmit,
        testId: "warning-modal-submit-button"
    }, submitText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d3437babdcdbdb10$var$i18n.submit)))));
};
module.exports["WarningModal"] = $d3437babdcdbdb10$export$d69de51d0f6180c8;

});

parcelRegister("9ZvQo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k7Q8j = parcelRequire("k7Q8j");

var $99495723452afc9f$export$ed765fbf470e2f95 = /*#__PURE__*/ function(ErrorRoles) {
    ErrorRoles["ERROR"] = "ERROR";
    ErrorRoles["WARNING"] = "WARNING";
    return ErrorRoles;
}({});
var $99495723452afc9f$export$6eedc845fbf0fc13 = /*#__PURE__*/ function(DocErrors) {
    DocErrors["TYPE_ERROR"] = "TYPE_ERROR";
    DocErrors["SIZE_LOCAL_ERROR"] = "SIZE_LOCAL_ERROR";
    DocErrors["SIZE_GD_ERROR"] = "SIZE_GD_ERROR";
    DocErrors["REQUEST_ABORTED_ERROR"] = "REQUEST_ABORTED_ERROR";
    DocErrors["FAILED_UPLOAD_ERROR"] = "FAILED_UPLOAD_ERROR";
    DocErrors["NOT_UNIQ_TITLE"] = "NOT_UNIQ_TITLE";
    DocErrors["STRICT_FORMAT_ERROR"] = "STRICT_FORMAT_ERROR";
    DocErrors["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
    return DocErrors;
}({});
var $99495723452afc9f$export$4e832c30bd1277f3 = /*#__PURE__*/ function(DocAction) {
    DocAction["UPLOAD_DOCS_START"] = "UPLOAD_DOCS_START";
    DocAction["UPDATE_DOCUMENTS"] = "UPDATE_DOCUMENTS";
    DocAction["UPLOAD_DOC_SUCCESS"] = "UPLOAD_DOC_SUCCESS";
    DocAction["UPLOAD_DOC_FAILURE"] = "UPLOAD_DOC_FAILURE";
    DocAction["UPLOAD_DOC_SELECT"] = "UPLOAD_DOC_SELECT";
    DocAction["UPLOAD_DOC_CONTROLLER"] = "UPLOAD_DOC_CONTROLLER";
    DocAction["UPLOAD_DOC_SIZE"] = "UPLOAD_DOC_SIZE";
    DocAction["UPLOAD_DOC_CLEAR_ERRORS"] = "UPLOAD_DOC_CLEAR_ERRORS";
    return DocAction;
}({});
const $99495723452afc9f$var$setDocuments = (documents)=>{
    return documents.map((doc)=>{
        return {
            document: doc,
            nameWithoutExt: (0, $k7Q8j.getFileNameWithoutExtension)(doc.name),
            completed: false,
            selected: true,
            error: null,
            size: doc.size
        };
    });
};
const $99495723452afc9f$var$updateDocuments = (currentDocs, docs)=>{
    return currentDocs.map((currentDoc)=>{
        const matchedDocument = docs.find((doc)=>doc?.name === currentDoc?.document.name);
        if (matchedDocument) return {
            ...currentDoc,
            document: matchedDocument
        };
        return currentDoc;
    });
};
const $99495723452afc9f$var$setDocUplodedData = (docs, name, id)=>{
    return docs.map((doc)=>{
        if (name === doc.document.name || name === doc.nameWithoutExt) return {
            ...doc,
            completed: true,
            id: id
        };
        return {
            ...doc
        };
    });
};
const $99495723452afc9f$var$selectDocument = (docs, name)=>{
    return docs.map((doc)=>{
        if (name === doc.nameWithoutExt) return {
            ...doc,
            selected: !doc.selected
        };
        return {
            ...doc
        };
    });
};
const $99495723452afc9f$var$setDocumentError = (docs, name, error)=>{
    return docs.map((doc)=>{
        if (name === doc.document.name || name === doc.nameWithoutExt && doc.error?.type !== "REQUEST_ABORTED_ERROR") return {
            ...doc,
            completed: true,
            error: {
                ...error
            }
        };
        return {
            ...doc
        };
    });
};
const $99495723452afc9f$var$setDocumentController = (docs, name, controller)=>{
    return docs.map((doc)=>{
        if (name === doc.document.name) return {
            ...doc,
            controller: controller
        };
        return {
            ...doc
        };
    });
};
const $99495723452afc9f$var$setDocumentSize = (docs, name, size)=>{
    return docs.map((doc)=>{
        if (name === doc.document.name) return {
            ...doc,
            size: size
        };
        return {
            ...doc
        };
    });
};
const $99495723452afc9f$var$setDocumentsErrorNull = (docs)=>{
    return docs.map((doc)=>{
        return {
            ...doc,
            completed: false,
            error: null
        };
    });
};
const $99495723452afc9f$export$de7777153009832a = ()=>{
    //todo: definining initial state here means the reducer useCallback will change every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initialState = {
        docs: []
    };
    const reducer = (0, $cozmU.useCallback)((state, action)=>{
        switch(action.type){
            case "UPLOAD_DOCS_START":
                return {
                    docs: $99495723452afc9f$var$setDocuments(action.documents)
                };
            case "UPDATE_DOCUMENTS":
                return {
                    docs: $99495723452afc9f$var$updateDocuments(state.docs, action.documents)
                };
            case "UPLOAD_DOC_SUCCESS":
                return {
                    docs: $99495723452afc9f$var$setDocUplodedData(state.docs, action.name, action.id)
                };
            case "UPLOAD_DOC_FAILURE":
                {
                    const { name: name, error: error } = action;
                    return {
                        docs: $99495723452afc9f$var$setDocumentError(state.docs, name, error)
                    };
                }
            case "UPLOAD_DOC_SELECT":
                return {
                    docs: $99495723452afc9f$var$selectDocument(state.docs, action.name)
                };
            case "UPLOAD_DOC_CONTROLLER":
                {
                    const { name: name, controller: controller } = action;
                    return {
                        docs: $99495723452afc9f$var$setDocumentController(state.docs, name, controller)
                    };
                }
            case "UPLOAD_DOC_SIZE":
                {
                    const { name: name, size: size } = action;
                    return {
                        docs: $99495723452afc9f$var$setDocumentSize(state.docs, name, size)
                    };
                }
            case "UPLOAD_DOC_CLEAR_ERRORS":
                return {
                    docs: $99495723452afc9f$var$setDocumentsErrorNull(state.docs)
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [{ docs: docs }, dispatch] = (0, $cozmU.useReducer)(reducer, initialState);
    const docActions = (0, $cozmU.useMemo)(()=>({
            uploadDocsStart: (documents)=>{
                dispatch({
                    type: "UPLOAD_DOCS_START",
                    documents: documents
                });
            },
            updateDocuments: (documents)=>{
                dispatch({
                    type: "UPDATE_DOCUMENTS",
                    documents: documents
                });
            },
            uploadDocSuccess: (name, id)=>{
                dispatch({
                    type: "UPLOAD_DOC_SUCCESS",
                    name: name,
                    id: id
                });
            },
            uploadDocFailure: (name, error)=>{
                dispatch({
                    type: "UPLOAD_DOC_FAILURE",
                    name: name,
                    error: error
                });
            },
            uploadDocSelect: (name)=>{
                dispatch({
                    type: "UPLOAD_DOC_SELECT",
                    name: name
                });
            },
            uploadDocController: (name, controller)=>{
                dispatch({
                    type: "UPLOAD_DOC_CONTROLLER",
                    name: name,
                    controller: controller
                });
            },
            uploadDocSize: (name, size)=>{
                dispatch({
                    type: "UPLOAD_DOC_SIZE",
                    name: name,
                    size: size
                });
            },
            uploadDocClearErrors: ()=>{
                dispatch({
                    type: "UPLOAD_DOC_CLEAR_ERRORS"
                });
            }
        }), []);
    return {
        docs: docs,
        docActions: docActions
    };
};
module.exports["ErrorRoles"] = $99495723452afc9f$export$ed765fbf470e2f95;
module.exports["DocErrors"] = $99495723452afc9f$export$6eedc845fbf0fc13;
module.exports["useUploadReducer"] = $99495723452afc9f$export$de7777153009832a;

});

parcelRegister("iaxSo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fytHI = parcelRequire("fytHI");

const $bbd8485f4b5919d9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    closeUploadErrorPopupButton: {
        id: "import-from-sources.upload-error-popup.close",
        defaultMessage: "Close"
    },
    uploadErrorPopupTitle: {
        id: "import-from-sources.upload-error-popup.title",
        defaultMessage: "This file can\u2019t be imported"
    },
    uploadErrorPopupContent: {
        id: "import-from-sources.upload-error-popup.content",
        defaultMessage: "We ran into issues because the file may the wrong type, password protected, or read-only."
    },
    bulkUploadErrorPopupTitle: {
        id: "import-from-sources.bulk-upload-error-popup.title",
        defaultMessage: "These files can\u2019t be imported"
    },
    bulkUploadErrorPopupContent: {
        id: "import-from-sources.bulk-upload-error-popup.content",
        defaultMessage: "We ran into issues because the files may the wrong type, password protected, or read-only."
    },
    tryDifferentDocumentUploadErrorPopupButton: {
        id: "import-from-sources.upload-error-popup.tryDifferentDocument",
        defaultMessage: "Select new file"
    },
    tryDifferentDocumentsUploadErrorPopupButton: {
        id: "import-from-sources.upload-error-popup.tryDifferentDocuments",
        defaultMessage: "Select new files"
    },
    failedBulkImportPopupTitle: {
        id: "import-from-sources.upload-error-popup.failedBulkImportPopupTitle",
        defaultMessage: "Bulk import failed"
    },
    failedBulkImportPopupContent: {
        id: "import-from-sources.upload-error-popup.failedBulkImportPopupContent",
        defaultMessage: "We ran into a problem importing your files. Check your internet connection and try again."
    }
});
const $bbd8485f4b5919d9$export$18152c94d7d2eb0d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onClose: onClose, onSubmit: onSubmit, headText: headText, bodyText: bodyText, submitText: submitText, modalWidth: modalWidth, hideCloseAction: hideCloseAction, suppressSubmitAnalytics: suppressSubmitAnalytics } = t0;
    let t1;
    if ($[0] !== headText) {
        t1 = headText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.uploadErrorPopupTitle);
        $[0] = headText;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== bodyText) {
        t2 = bodyText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.uploadErrorPopupContent);
        $[2] = bodyText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== submitText) {
        t3 = submitText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.tryDifferentDocumentUploadErrorPopupButton);
        $[4] = submitText;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.closeUploadErrorPopupButton);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== hideCloseAction || $[8] !== modalWidth || $[9] !== onClose || $[10] !== onSubmit || $[11] !== suppressSubmitAnalytics || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fytHI.UploadErrorPopup), {
            onClose: onClose,
            onSubmit: onSubmit,
            headText: t1,
            bodyText: t2,
            submitText: t3,
            closeText: t4,
            modalWidth: modalWidth,
            hideCloseAction: hideCloseAction,
            suppressSubmitAnalytics: suppressSubmitAnalytics
        });
        $[7] = hideCloseAction;
        $[8] = modalWidth;
        $[9] = onClose;
        $[10] = onSubmit;
        $[11] = suppressSubmitAnalytics;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ onClose: onClose, onSubmit: onSubmit, headText: headText, bodyText: bodyText, submitText: submitText, modalWidth: modalWidth, hideCloseAction: hideCloseAction, suppressSubmitAnalytics: suppressSubmitAnalytics })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fytHI.UploadErrorPopup), {
        onClose: onClose,
        onSubmit: onSubmit,
        headText: headText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.uploadErrorPopupTitle),
        bodyText: bodyText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.uploadErrorPopupContent),
        submitText: submitText || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.tryDifferentDocumentUploadErrorPopupButton),
        closeText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bbd8485f4b5919d9$export$a7357cdd1f0b0168.closeUploadErrorPopupButton),
        modalWidth: modalWidth,
        hideCloseAction: hideCloseAction,
        suppressSubmitAnalytics: suppressSubmitAnalytics
    });
};
module.exports["i18n"] = $bbd8485f4b5919d9$export$a7357cdd1f0b0168;
module.exports["CommonErrorModal"] = $bbd8485f4b5919d9$export$18152c94d7d2eb0d;

});

parcelRegister("lrhMp", function(module, exports) {
var $8fa9c1ec2367494d$export$c1052de058fac70d = /*#__PURE__*/ function(GOOGLE_EXPORT_ERRORS) {
    GOOGLE_EXPORT_ERRORS["FILE_SIZE_LIMIT"] = "exportSizeLimitExceeded";
    GOOGLE_EXPORT_ERRORS["USER_RATE_LIMIT"] = "userRateLimitExceeded";
    return GOOGLE_EXPORT_ERRORS;
}({});
module.exports["GOOGLE_EXPORT_ERRORS"] = $8fa9c1ec2367494d$export$c1052de058fac70d;

});

parcelRegister("8MCjw", function(module, exports) {

var $e3aE9 = parcelRequire("e3aE9");

const $443ad7e1e222c154$export$442e144b057b13db = (type)=>{
    if (type === '') // this conditions was added due to the input returns empty type field in a file on Google Chrome at Windows
    // https://jira.atlassian.com/browse/CONFDEV-77360
    return false;
    return !Object.values((0, $e3aE9.FILES_EXPORT_FORMATS)).includes(type);
};
const $443ad7e1e222c154$export$65849f507328d32b = (docSize, limit)=>docSize > limit;
module.exports["isDocWithWrongType"] = $443ad7e1e222c154$export$442e144b057b13db;
module.exports["DocExceededSizeLimit"] = $443ad7e1e222c154$export$65849f507328d32b;

});

parcelRegister("8ARcf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $r3F1B = parcelRequire("r3F1B");


var $aGMzc = parcelRequire("aGMzc");


var $8MCjw = parcelRequire("8MCjw");


var $dfcSL = parcelRequire("dfcSL");


var $lo1Qi = parcelRequire("lo1Qi");

const $a953a98e65315814$export$53159476b9a2a116 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { showModal: showModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    let t0;
    if ($[0] !== showModal) {
        t0 = (document)=>{
            if ((0, $8MCjw.DocExceededSizeLimit)(document.size, (0, $dfcSL.FILE_UPLOAD_LIMIT))) {
                showModal((0, $aGMzc.ImportModalTypes).FILE_SIZE, {
                    fileName: document.name,
                    fileSize: (0, $lo1Qi.fixedBytesToMegabytes)(document.size)
                });
                return false;
            }
            return true;
        };
        $[0] = showModal;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { showModal: showModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)((document)=>{
        if ((0, $8MCjw.DocExceededSizeLimit)(document.size, (0, $dfcSL.FILE_UPLOAD_LIMIT))) {
            showModal((0, $aGMzc.ImportModalTypes).FILE_SIZE, {
                fileName: document.name,
                fileSize: (0, $lo1Qi.fixedBytesToMegabytes)(document.size)
            });
            return false;
        }
        return true;
    }, [
        showModal
    ]);
};
module.exports["useFileSizeCheck"] = $a953a98e65315814$export$53159476b9a2a116;

});

parcelRegister("eImq9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $r3F1B = parcelRequire("r3F1B");

const $01edfa52ee8bcca6$export$cee5a5b1030c8528 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { docActions: t0 } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    const { uploadDocController: uploadDocController } = t0;
    let t1;
    if ($[0] !== uploadDocController) {
        t1 = (documents)=>documents.map((doc)=>{
                const controller = new AbortController();
                uploadDocController(doc.name, controller);
                return {
                    doc: doc,
                    signal: controller.signal
                };
            });
        $[0] = uploadDocController;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { docActions: { uploadDocController: uploadDocController } } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)((documents)=>{
        return documents.map((doc)=>{
            const controller = new AbortController();
            uploadDocController(doc.name, controller);
            return {
                doc: doc,
                signal: controller.signal
            };
        });
    }, [
        uploadDocController
    ]);
};
module.exports["useAddAbortControllerDocuments"] = $01edfa52ee8bcca6$export$cee5a5b1030c8528;

});

parcelRegister("hPg0A", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $r3F1B = parcelRequire("r3F1B");


var $aGMzc = parcelRequire("aGMzc");


var $hGnTB = parcelRequire("hGnTB");

const $c421cf260a0a7f1e$export$9d4a3acb870c78b0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { showConfirmModal: showConfirmModal, modalStack: modalStack, closeModal: closeModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    let t0;
    if ($[0] !== closeModal || $[1] !== modalStack || $[2] !== showConfirmModal) {
        t0 = async (fileList)=>{
            if ((0, $hGnTB.isBulkLengthLimitReached)(fileList) || (0, $hGnTB.isBulkTotalSizeLimitReached)(fileList)) {
                if (modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS]) closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
                return showConfirmModal((0, $aGMzc.ImportModalTypes).BULK_LIMIT);
            } else return fileList;
        };
        $[0] = closeModal;
        $[1] = modalStack;
        $[2] = showConfirmModal;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const { showConfirmModal: showConfirmModal, modalStack: modalStack, closeModal: closeModal } = (0, $cozmU.useContext)((0, $r3F1B.ImportStateContext));
    return (0, $cozmU.useCallback)(//TODO: add types for documents
    async (fileList)=>{
        if ((0, $hGnTB.isBulkLengthLimitReached)(fileList) || (0, $hGnTB.isBulkTotalSizeLimitReached)(fileList)) {
            if (modalStack[(0, $aGMzc.ImportModalTypes).PROGRESS]) closeModal((0, $aGMzc.ImportModalTypes).PROGRESS);
            return showConfirmModal((0, $aGMzc.ImportModalTypes).BULK_LIMIT);
        } else return fileList;
    }, [
        showConfirmModal,
        closeModal,
        modalStack
    ]);
};
module.exports["useBulkLimitCheck"] = $c421cf260a0a7f1e$export$9d4a3acb870c78b0;

});

parcelRegister("iDEwy", function(module, exports) {
/**
 * When the request has been canceled via abortController different browsers produce different abortion messages (error.message):
 * Chrome & Edge: "Network failure: AbortError: The user aborted a request."
 * Firefox: "Network failure: AbortError: The operation was aborted."
 * Safari: "Network failure: AbortError: Fetch is aborted"
 *
 * DOMException errors happen when the component had been removed
 * before the ongoing request which leads to state changes
 * was resolved
 */ const $7e24950b9f7e45f0$export$6c24b7e4415d3734 = {
    'Network failure: AbortError: The user aborted a request.': 'CHROME_EDGE_ABORT_ERROR',
    'Network failure: AbortError: The operation was aborted.': 'FIREFOX_ABORT_ERROR',
    'Network failure: AbortError: Fetch is aborted': 'SAFARI',
    'The user aborted a request.': 'CHROME_EDGE_DOMException_AbortError',
    'Fetch is aborted': 'SAFARI_DOMException_AbortError',
    'The operation was aborted.': 'FIREFOX_DOMException_AbortError'
};
module.exports["AbortErrors"] = $7e24950b9f7e45f0$export$6c24b7e4415d3734;

});

parcelRegister("bGxBv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a1827781586fe105$export$2ee174121202e4c7 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const [modalStack, setModalStack] = (0, $cozmU.useState)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (modalType, t2)=>{
            const modalData = t2 === undefined ? {} : t2;
            setModalStack((previousStack)=>{
                const updatedModalStack = {
                    ...previousStack
                };
                updatedModalStack[modalType] = {
                    ...previousStack[modalType],
                    ...modalData
                };
                return updatedModalStack;
            });
        };
        $[1] = t1;
    } else t1 = $[1];
    const showModal = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (modalType_0)=>{
            setModalStack((previousStack_0)=>{
                const updatedModalStack_0 = {
                    ...previousStack_0
                };
                delete updatedModalStack_0[modalType_0];
                return updatedModalStack_0;
            });
        };
        $[2] = t2;
    } else t2 = $[2];
    const closeModal = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (modalType_1)=>new Promise((resolve)=>{
                showModal(modalType_1, {
                    onConfirm: (data)=>{
                        closeModal(modalType_1);
                        resolve(data || true);
                    },
                    onCancel: ()=>{
                        closeModal(modalType_1);
                        resolve(false);
                    }
                });
            });
        $[3] = t3;
    } else t3 = $[3];
    const showConfirmModal = t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (modalType_2, modalData_0)=>{
            setModalStack((previousStack_1)=>{
                const updatedModalStack_1 = {
                    ...previousStack_1
                };
                if (updatedModalStack_1[modalType_2]) updatedModalStack_1[modalType_2] = {
                    ...previousStack_1[modalType_2],
                    ...modalData_0
                };
                return updatedModalStack_1;
            });
        };
        $[4] = t4;
    } else t4 = $[4];
    const updateModalData = t4;
    let t5;
    if ($[5] !== modalStack) {
        t5 = {
            modalStack: modalStack,
            showModal: showModal,
            showConfirmModal: showConfirmModal,
            closeModal: closeModal,
            updateModalData: updateModalData
        };
        $[5] = modalStack;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ()=>{
    const [modalStack, setModalStack] = (0, $cozmU.useState)({});
    const showModal = (0, $cozmU.useCallback)((modalType, modalData = {})=>{
        setModalStack((previousStack)=>{
            const updatedModalStack = {
                ...previousStack
            };
            updatedModalStack[modalType] = {
                ...previousStack[modalType],
                ...modalData
            };
            return updatedModalStack;
        });
    }, [
        setModalStack
    ]);
    const closeModal = (0, $cozmU.useCallback)((modalType_0)=>{
        setModalStack((previousStack_0)=>{
            const updatedModalStack_0 = {
                ...previousStack_0
            };
            delete updatedModalStack_0[modalType_0];
            return updatedModalStack_0;
        });
    }, [
        setModalStack
    ]);
    const showConfirmModal = (0, $cozmU.useCallback)((modalType_1)=>{
        return new Promise((resolve)=>{
            showModal(modalType_1, {
                onConfirm: (data)=>{
                    closeModal(modalType_1);
                    resolve(data || true);
                },
                onCancel: ()=>{
                    closeModal(modalType_1);
                    resolve(false);
                }
            });
        });
    }, [
        showModal,
        closeModal
    ]);
    const updateModalData = (0, $cozmU.useCallback)((modalType_2, modalData_0)=>{
        setModalStack((previousStack_1)=>{
            const updatedModalStack_1 = {
                ...previousStack_1
            };
            if (updatedModalStack_1[modalType_2]) updatedModalStack_1[modalType_2] = {
                ...previousStack_1[modalType_2],
                ...modalData_0
            };
            return updatedModalStack_1;
        });
    }, [
        setModalStack
    ]);
    return {
        modalStack: modalStack,
        showModal: showModal,
        showConfirmModal: showConfirmModal,
        closeModal: closeModal,
        updateModalData: updateModalData
    };
};
module.exports["useModals"] = $a1827781586fe105$export$2ee174121202e4c7;

});

parcelRegister("e3aE9", function(module, exports) {
// List of supported formats: https://developers.google.com/drive/api/v3/ref-export-formats
var $da4a016359eefcbd$export$ec9289d6e030dc5d = /*#__PURE__*/ function(FILES_EXPORT_FORMATS) {
    FILES_EXPORT_FORMATS["WordDocument"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    return FILES_EXPORT_FORMATS;
}({});
module.exports["FILES_EXPORT_FORMATS"] = $da4a016359eefcbd$export$ec9289d6e030dc5d;

});


//# sourceMappingURL=SourcesList.465a1f7a.js.map
